/*! jQuery v3.2.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(a, b) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function(a) {
        if (!a.document)
            throw new Error("jQuery requires a window with a document");
        return b(a)
    }
    : b(a)
}("undefined" != typeof window ? window : this, function(a, b) {
    "use strict";
    var c = []
      , d = a.document
      , e = Object.getPrototypeOf
      , f = c.slice
      , g = c.concat
      , h = c.push
      , i = c.indexOf
      , j = {}
      , k = j.toString
      , l = j.hasOwnProperty
      , m = l.toString
      , n = m.call(Object)
      , o = {};
    function p(a, b) {
        b = b || d;
        var c = b.createElement("script");
        c.text = a,
        b.head.appendChild(c).parentNode.removeChild(c)
    }
    var q = "3.2.1"
      , r = function(a, b) {
        return new r.fn.init(a,b)
    }
      , s = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
      , t = /^-ms-/
      , u = /-([a-z])/g
      , v = function(a, b) {
        return b.toUpperCase()
    };
    r.fn = r.prototype = {
        jquery: q,
        constructor: r,
        length: 0,
        toArray: function() {
            return f.call(this)
        },
        get: function(a) {
            return null == a ? f.call(this) : a < 0 ? this[a + this.length] : this[a]
        },
        pushStack: function(a) {
            var b = r.merge(this.constructor(), a);
            return b.prevObject = this,
            b
        },
        each: function(a) {
            return r.each(this, a)
        },
        map: function(a) {
            return this.pushStack(r.map(this, function(b, c) {
                return a.call(b, c, b)
            }))
        },
        slice: function() {
            return this.pushStack(f.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(a) {
            var b = this.length
              , c = +a + (a < 0 ? b : 0);
            return this.pushStack(c >= 0 && c < b ? [this[c]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: h,
        sort: c.sort,
        splice: c.splice
    },
    r.extend = r.fn.extend = function() {
        var a, b, c, d, e, f, g = arguments[0] || {}, h = 1, i = arguments.length, j = !1;
        for ("boolean" == typeof g && (j = g,
        g = arguments[h] || {},
        h++),
        "object" == typeof g || r.isFunction(g) || (g = {}),
        h === i && (g = this,
        h--); h < i; h++)
            if (null != (a = arguments[h]))
                for (b in a)
                    c = g[b],
                    d = a[b],
                    g !== d && (j && d && (r.isPlainObject(d) || (e = Array.isArray(d))) ? (e ? (e = !1,
                    f = c && Array.isArray(c) ? c : []) : f = c && r.isPlainObject(c) ? c : {},
                    g[b] = r.extend(j, f, d)) : void 0 !== d && (g[b] = d));
        return g
    }
    ,
    r.extend({
        expando: "jQuery" + (q + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(a) {
            throw new Error(a)
        },
        noop: function() {},
        isFunction: function(a) {
            return "function" === r.type(a)
        },
        isWindow: function(a) {
            return null != a && a === a.window
        },
        isNumeric: function(a) {
            var b = r.type(a);
            return ("number" === b || "string" === b) && !isNaN(a - parseFloat(a))
        },
        isPlainObject: function(a) {
            var b, c;
            return !(!a || "[object Object]" !== k.call(a)) && (!(b = e(a)) || (c = l.call(b, "constructor") && b.constructor,
            "function" == typeof c && m.call(c) === n))
        },
        isEmptyObject: function(a) {
            var b;
            for (b in a)
                return !1;
            return !0
        },
        type: function(a) {
            return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? j[k.call(a)] || "object" : typeof a
        },
        globalEval: function(a) {
            p(a)
        },
        camelCase: function(a) {
            return a.replace(t, "ms-").replace(u, v)
        },
        each: function(a, b) {
            var c, d = 0;
            if (w(a)) {
                for (c = a.length; d < c; d++)
                    if (b.call(a[d], d, a[d]) === !1)
                        break
            } else
                for (d in a)
                    if (b.call(a[d], d, a[d]) === !1)
                        break;
            return a
        },
        trim: function(a) {
            return null == a ? "" : (a + "").replace(s, "")
        },
        makeArray: function(a, b) {
            var c = b || [];
            return null != a && (w(Object(a)) ? r.merge(c, "string" == typeof a ? [a] : a) : h.call(c, a)),
            c
        },
        inArray: function(a, b, c) {
            return null == b ? -1 : i.call(b, a, c)
        },
        merge: function(a, b) {
            for (var c = +b.length, d = 0, e = a.length; d < c; d++)
                a[e++] = b[d];
            return a.length = e,
            a
        },
        grep: function(a, b, c) {
            for (var d, e = [], f = 0, g = a.length, h = !c; f < g; f++)
                d = !b(a[f], f),
                d !== h && e.push(a[f]);
            return e
        },
        map: function(a, b, c) {
            var d, e, f = 0, h = [];
            if (w(a))
                for (d = a.length; f < d; f++)
                    e = b(a[f], f, c),
                    null != e && h.push(e);
            else
                for (f in a)
                    e = b(a[f], f, c),
                    null != e && h.push(e);
            return g.apply([], h)
        },
        guid: 1,
        proxy: function(a, b) {
            var c, d, e;
            if ("string" == typeof b && (c = a[b],
            b = a,
            a = c),
            r.isFunction(a))
                return d = f.call(arguments, 2),
                e = function() {
                    return a.apply(b || this, d.concat(f.call(arguments)))
                }
                ,
                e.guid = a.guid = a.guid || r.guid++,
                e
        },
        now: Date.now,
        support: o
    }),
    "function" == typeof Symbol && (r.fn[Symbol.iterator] = c[Symbol.iterator]),
    r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(a, b) {
        j["[object " + b + "]"] = b.toLowerCase()
    });
    function w(a) {
        var b = !!a && "length"in a && a.length
          , c = r.type(a);
        return "function" !== c && !r.isWindow(a) && ("array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a)
    }
    var x = function(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u = "sizzle" + 1 * new Date, v = a.document, w = 0, x = 0, y = ha(), z = ha(), A = ha(), B = function(a, b) {
            return a === b && (l = !0),
            0
        }, C = {}.hasOwnProperty, D = [], E = D.pop, F = D.push, G = D.push, H = D.slice, I = function(a, b) {
            for (var c = 0, d = a.length; c < d; c++)
                if (a[c] === b)
                    return c;
            return -1
        }, J = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", K = "[\\x20\\t\\r\\n\\f]", L = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", M = "\\[" + K + "*(" + L + ")(?:" + K + "*([*^$|!~]?=)" + K + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + L + "))|)" + K + "*\\]", N = ":(" + L + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)", O = new RegExp(K + "+","g"), P = new RegExp("^" + K + "+|((?:^|[^\\\\])(?:\\\\.)*)" + K + "+$","g"), Q = new RegExp("^" + K + "*," + K + "*"), R = new RegExp("^" + K + "*([>+~]|" + K + ")" + K + "*"), S = new RegExp("=" + K + "*([^\\]'\"]*?)" + K + "*\\]","g"), T = new RegExp(N), U = new RegExp("^" + L + "$"), V = {
            ID: new RegExp("^#(" + L + ")"),
            CLASS: new RegExp("^\\.(" + L + ")"),
            TAG: new RegExp("^(" + L + "|[*])"),
            ATTR: new RegExp("^" + M),
            PSEUDO: new RegExp("^" + N),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + K + "*(even|odd|(([+-]|)(\\d*)n|)" + K + "*(?:([+-]|)" + K + "*(\\d+)|))" + K + "*\\)|)","i"),
            bool: new RegExp("^(?:" + J + ")$","i"),
            needsContext: new RegExp("^" + K + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + K + "*((?:-\\d)?\\d*)" + K + "*\\)|)(?=[^-]|$)","i")
        }, W = /^(?:input|select|textarea|button)$/i, X = /^h\d$/i, Y = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, $ = /[+~]/, _ = new RegExp("\\\\([\\da-f]{1,6}" + K + "?|(" + K + ")|.)","ig"), aa = function(a, b, c) {
            var d = "0x" + b - 65536;
            return d !== d || c ? b : d < 0 ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320)
        }, ba = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ca = function(a, b) {
            return b ? "\0" === a ? "\ufffd" : a.slice(0, -1) + "\\" + a.charCodeAt(a.length - 1).toString(16) + " " : "\\" + a
        }, da = function() {
            m()
        }, ea = ta(function(a) {
            return a.disabled === !0 && ("form"in a || "label"in a)
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            G.apply(D = H.call(v.childNodes), v.childNodes),
            D[v.childNodes.length].nodeType
        } catch (fa) {
            G = {
                apply: D.length ? function(a, b) {
                    F.apply(a, H.call(b))
                }
                : function(a, b) {
                    var c = a.length
                      , d = 0;
                    while (a[c++] = b[d++])
                        ;
                    a.length = c - 1
                }
            }
        }
        function ga(a, b, d, e) {
            var f, h, j, k, l, o, r, s = b && b.ownerDocument, w = b ? b.nodeType : 9;
            if (d = d || [],
            "string" != typeof a || !a || 1 !== w && 9 !== w && 11 !== w)
                return d;
            if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b),
            b = b || n,
            p)) {
                if (11 !== w && (l = Z.exec(a)))
                    if (f = l[1]) {
                        if (9 === w) {
                            if (!(j = b.getElementById(f)))
                                return d;
                            if (j.id === f)
                                return d.push(j),
                                d
                        } else if (s && (j = s.getElementById(f)) && t(b, j) && j.id === f)
                            return d.push(j),
                            d
                    } else {
                        if (l[2])
                            return G.apply(d, b.getElementsByTagName(a)),
                            d;
                        if ((f = l[3]) && c.getElementsByClassName && b.getElementsByClassName)
                            return G.apply(d, b.getElementsByClassName(f)),
                            d
                    }
                if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
                    if (1 !== w)
                        s = b,
                        r = a;
                    else if ("object" !== b.nodeName.toLowerCase()) {
                        (k = b.getAttribute("id")) ? k = k.replace(ba, ca) : b.setAttribute("id", k = u),
                        o = g(a),
                        h = o.length;
                        while (h--)
                            o[h] = "#" + k + " " + sa(o[h]);
                        r = o.join(","),
                        s = $.test(a) && qa(b.parentNode) || b
                    }
                    if (r)
                        try {
                            return G.apply(d, s.querySelectorAll(r)),
                            d
                        } catch (x) {} finally {
                            k === u && b.removeAttribute("id")
                        }
                }
            }
            return i(a.replace(P, "$1"), b, d, e)
        }
        function ha() {
            var a = [];
            function b(c, e) {
                return a.push(c + " ") > d.cacheLength && delete b[a.shift()],
                b[c + " "] = e
            }
            return b
        }
        function ia(a) {
            return a[u] = !0,
            a
        }
        function ja(a) {
            var b = n.createElement("fieldset");
            try {
                return !!a(b)
            } catch (c) {
                return !1
            } finally {
                b.parentNode && b.parentNode.removeChild(b),
                b = null
            }
        }
        function ka(a, b) {
            var c = a.split("|")
              , e = c.length;
            while (e--)
                d.attrHandle[c[e]] = b
        }
        function la(a, b) {
            var c = b && a
              , d = c && 1 === a.nodeType && 1 === b.nodeType && a.sourceIndex - b.sourceIndex;
            if (d)
                return d;
            if (c)
                while (c = c.nextSibling)
                    if (c === b)
                        return -1;
            return a ? 1 : -1
        }
        function ma(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return "input" === c && b.type === a
            }
        }
        function na(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return ("input" === c || "button" === c) && b.type === a
            }
        }
        function oa(a) {
            return function(b) {
                return "form"in b ? b.parentNode && b.disabled === !1 ? "label"in b ? "label"in b.parentNode ? b.parentNode.disabled === a : b.disabled === a : b.isDisabled === a || b.isDisabled !== !a && ea(b) === a : b.disabled === a : "label"in b && b.disabled === a
            }
        }
        function pa(a) {
            return ia(function(b) {
                return b = +b,
                ia(function(c, d) {
                    var e, f = a([], c.length, b), g = f.length;
                    while (g--)
                        c[e = f[g]] && (c[e] = !(d[e] = c[e]))
                })
            })
        }
        function qa(a) {
            return a && "undefined" != typeof a.getElementsByTagName && a
        }
        c = ga.support = {},
        f = ga.isXML = function(a) {
            var b = a && (a.ownerDocument || a).documentElement;
            return !!b && "HTML" !== b.nodeName
        }
        ,
        m = ga.setDocument = function(a) {
            var b, e, g = a ? a.ownerDocument || a : v;
            return g !== n && 9 === g.nodeType && g.documentElement ? (n = g,
            o = n.documentElement,
            p = !f(n),
            v !== n && (e = n.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", da, !1) : e.attachEvent && e.attachEvent("onunload", da)),
            c.attributes = ja(function(a) {
                return a.className = "i",
                !a.getAttribute("className")
            }),
            c.getElementsByTagName = ja(function(a) {
                return a.appendChild(n.createComment("")),
                !a.getElementsByTagName("*").length
            }),
            c.getElementsByClassName = Y.test(n.getElementsByClassName),
            c.getById = ja(function(a) {
                return o.appendChild(a).id = u,
                !n.getElementsByName || !n.getElementsByName(u).length
            }),
            c.getById ? (d.filter.ID = function(a) {
                var b = a.replace(_, aa);
                return function(a) {
                    return a.getAttribute("id") === b
                }
            }
            ,
            d.find.ID = function(a, b) {
                if ("undefined" != typeof b.getElementById && p) {
                    var c = b.getElementById(a);
                    return c ? [c] : []
                }
            }
            ) : (d.filter.ID = function(a) {
                var b = a.replace(_, aa);
                return function(a) {
                    var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");
                    return c && c.value === b
                }
            }
            ,
            d.find.ID = function(a, b) {
                if ("undefined" != typeof b.getElementById && p) {
                    var c, d, e, f = b.getElementById(a);
                    if (f) {
                        if (c = f.getAttributeNode("id"),
                        c && c.value === a)
                            return [f];
                        e = b.getElementsByName(a),
                        d = 0;
                        while (f = e[d++])
                            if (c = f.getAttributeNode("id"),
                            c && c.value === a)
                                return [f]
                    }
                    return []
                }
            }
            ),
            d.find.TAG = c.getElementsByTagName ? function(a, b) {
                return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0
            }
            : function(a, b) {
                var c, d = [], e = 0, f = b.getElementsByTagName(a);
                if ("*" === a) {
                    while (c = f[e++])
                        1 === c.nodeType && d.push(c);
                    return d
                }
                return f
            }
            ,
            d.find.CLASS = c.getElementsByClassName && function(a, b) {
                if ("undefined" != typeof b.getElementsByClassName && p)
                    return b.getElementsByClassName(a)
            }
            ,
            r = [],
            q = [],
            (c.qsa = Y.test(n.querySelectorAll)) && (ja(function(a) {
                o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + K + "*(?:''|\"\")"),
                a.querySelectorAll("[selected]").length || q.push("\\[" + K + "*(?:value|" + J + ")"),
                a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="),
                a.querySelectorAll(":checked").length || q.push(":checked"),
                a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]")
            }),
            ja(function(a) {
                a.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var b = n.createElement("input");
                b.setAttribute("type", "hidden"),
                a.appendChild(b).setAttribute("name", "D"),
                a.querySelectorAll("[name=d]").length && q.push("name" + K + "*[*^$|!~]?="),
                2 !== a.querySelectorAll(":enabled").length && q.push(":enabled", ":disabled"),
                o.appendChild(a).disabled = !0,
                2 !== a.querySelectorAll(":disabled").length && q.push(":enabled", ":disabled"),
                a.querySelectorAll("*,:x"),
                q.push(",.*:")
            })),
            (c.matchesSelector = Y.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ja(function(a) {
                c.disconnectedMatch = s.call(a, "*"),
                s.call(a, "[s!='']:x"),
                r.push("!=", N)
            }),
            q = q.length && new RegExp(q.join("|")),
            r = r.length && new RegExp(r.join("|")),
            b = Y.test(o.compareDocumentPosition),
            t = b || Y.test(o.contains) ? function(a, b) {
                var c = 9 === a.nodeType ? a.documentElement : a
                  , d = b && b.parentNode;
                return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)))
            }
            : function(a, b) {
                if (b)
                    while (b = b.parentNode)
                        if (b === a)
                            return !0;
                return !1
            }
            ,
            B = b ? function(a, b) {
                if (a === b)
                    return l = !0,
                    0;
                var d = !a.compareDocumentPosition - !b.compareDocumentPosition;
                return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1,
                1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === n || a.ownerDocument === v && t(v, a) ? -1 : b === n || b.ownerDocument === v && t(v, b) ? 1 : k ? I(k, a) - I(k, b) : 0 : 4 & d ? -1 : 1)
            }
            : function(a, b) {
                if (a === b)
                    return l = !0,
                    0;
                var c, d = 0, e = a.parentNode, f = b.parentNode, g = [a], h = [b];
                if (!e || !f)
                    return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? I(k, a) - I(k, b) : 0;
                if (e === f)
                    return la(a, b);
                c = a;
                while (c = c.parentNode)
                    g.unshift(c);
                c = b;
                while (c = c.parentNode)
                    h.unshift(c);
                while (g[d] === h[d])
                    d++;
                return d ? la(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0
            }
            ,
            n) : n
        }
        ,
        ga.matches = function(a, b) {
            return ga(a, null, null, b)
        }
        ,
        ga.matchesSelector = function(a, b) {
            if ((a.ownerDocument || a) !== n && m(a),
            b = b.replace(S, "='$1']"),
            c.matchesSelector && p && !A[b + " "] && (!r || !r.test(b)) && (!q || !q.test(b)))
                try {
                    var d = s.call(a, b);
                    if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType)
                        return d
                } catch (e) {}
            return ga(b, n, null, [a]).length > 0
        }
        ,
        ga.contains = function(a, b) {
            return (a.ownerDocument || a) !== n && m(a),
            t(a, b)
        }
        ,
        ga.attr = function(a, b) {
            (a.ownerDocument || a) !== n && m(a);
            var e = d.attrHandle[b.toLowerCase()]
              , f = e && C.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
            return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null
        }
        ,
        ga.escape = function(a) {
            return (a + "").replace(ba, ca)
        }
        ,
        ga.error = function(a) {
            throw new Error("Syntax error, unrecognized expression: " + a)
        }
        ,
        ga.uniqueSort = function(a) {
            var b, d = [], e = 0, f = 0;
            if (l = !c.detectDuplicates,
            k = !c.sortStable && a.slice(0),
            a.sort(B),
            l) {
                while (b = a[f++])
                    b === a[f] && (e = d.push(f));
                while (e--)
                    a.splice(d[e], 1)
            }
            return k = null,
            a
        }
        ,
        e = ga.getText = function(a) {
            var b, c = "", d = 0, f = a.nodeType;
            if (f) {
                if (1 === f || 9 === f || 11 === f) {
                    if ("string" == typeof a.textContent)
                        return a.textContent;
                    for (a = a.firstChild; a; a = a.nextSibling)
                        c += e(a)
                } else if (3 === f || 4 === f)
                    return a.nodeValue
            } else
                while (b = a[d++])
                    c += e(b);
            return c
        }
        ,
        d = ga.selectors = {
            cacheLength: 50,
            createPseudo: ia,
            match: V,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(a) {
                    return a[1] = a[1].replace(_, aa),
                    a[3] = (a[3] || a[4] || a[5] || "").replace(_, aa),
                    "~=" === a[2] && (a[3] = " " + a[3] + " "),
                    a.slice(0, 4)
                },
                CHILD: function(a) {
                    return a[1] = a[1].toLowerCase(),
                    "nth" === a[1].slice(0, 3) ? (a[3] || ga.error(a[0]),
                    a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])),
                    a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && ga.error(a[0]),
                    a
                },
                PSEUDO: function(a) {
                    var b, c = !a[6] && a[2];
                    return V.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && T.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b),
                    a[2] = c.slice(0, b)),
                    a.slice(0, 3))
                }
            },
            filter: {
                TAG: function(a) {
                    var b = a.replace(_, aa).toLowerCase();
                    return "*" === a ? function() {
                        return !0
                    }
                    : function(a) {
                        return a.nodeName && a.nodeName.toLowerCase() === b
                    }
                },
                CLASS: function(a) {
                    var b = y[a + " "];
                    return b || (b = new RegExp("(^|" + K + ")" + a + "(" + K + "|$)")) && y(a, function(a) {
                        return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "")
                    })
                },
                ATTR: function(a, b, c) {
                    return function(d) {
                        var e = ga.attr(d, a);
                        return null == e ? "!=" === b : !b || (e += "",
                        "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(O, " ") + " ").indexOf(c) > -1 : "|=" === b && (e === c || e.slice(0, c.length + 1) === c + "-"))
                    }
                },
                CHILD: function(a, b, c, d, e) {
                    var f = "nth" !== a.slice(0, 3)
                      , g = "last" !== a.slice(-4)
                      , h = "of-type" === b;
                    return 1 === d && 0 === e ? function(a) {
                        return !!a.parentNode
                    }
                    : function(b, c, i) {
                        var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling", q = b.parentNode, r = h && b.nodeName.toLowerCase(), s = !i && !h, t = !1;
                        if (q) {
                            if (f) {
                                while (p) {
                                    m = b;
                                    while (m = m[p])
                                        if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType)
                                            return !1;
                                    o = p = "only" === a && !o && "nextSibling"
                                }
                                return !0
                            }
                            if (o = [g ? q.firstChild : q.lastChild],
                            g && s) {
                                m = q,
                                l = m[u] || (m[u] = {}),
                                k = l[m.uniqueID] || (l[m.uniqueID] = {}),
                                j = k[a] || [],
                                n = j[0] === w && j[1],
                                t = n && j[2],
                                m = n && q.childNodes[n];
                                while (m = ++n && m && m[p] || (t = n = 0) || o.pop())
                                    if (1 === m.nodeType && ++t && m === b) {
                                        k[a] = [w, n, t];
                                        break
                                    }
                            } else if (s && (m = b,
                            l = m[u] || (m[u] = {}),
                            k = l[m.uniqueID] || (l[m.uniqueID] = {}),
                            j = k[a] || [],
                            n = j[0] === w && j[1],
                            t = n),
                            t === !1)
                                while (m = ++n && m && m[p] || (t = n = 0) || o.pop())
                                    if ((h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) && ++t && (s && (l = m[u] || (m[u] = {}),
                                    k = l[m.uniqueID] || (l[m.uniqueID] = {}),
                                    k[a] = [w, t]),
                                    m === b))
                                        break;
                            return t -= e,
                            t === d || t % d === 0 && t / d >= 0
                        }
                    }
                },
                PSEUDO: function(a, b) {
                    var c, e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || ga.error("unsupported pseudo: " + a);
                    return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b],
                    d.setFilters.hasOwnProperty(a.toLowerCase()) ? ia(function(a, c) {
                        var d, f = e(a, b), g = f.length;
                        while (g--)
                            d = I(a, f[g]),
                            a[d] = !(c[d] = f[g])
                    }) : function(a) {
                        return e(a, 0, c)
                    }
                    ) : e
                }
            },
            pseudos: {
                not: ia(function(a) {
                    var b = []
                      , c = []
                      , d = h(a.replace(P, "$1"));
                    return d[u] ? ia(function(a, b, c, e) {
                        var f, g = d(a, null, e, []), h = a.length;
                        while (h--)
                            (f = g[h]) && (a[h] = !(b[h] = f))
                    }) : function(a, e, f) {
                        return b[0] = a,
                        d(b, null, f, c),
                        b[0] = null,
                        !c.pop()
                    }
                }),
                has: ia(function(a) {
                    return function(b) {
                        return ga(a, b).length > 0
                    }
                }),
                contains: ia(function(a) {
                    return a = a.replace(_, aa),
                    function(b) {
                        return (b.textContent || b.innerText || e(b)).indexOf(a) > -1
                    }
                }),
                lang: ia(function(a) {
                    return U.test(a || "") || ga.error("unsupported lang: " + a),
                    a = a.replace(_, aa).toLowerCase(),
                    function(b) {
                        var c;
                        do
                            if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang"))
                                return c = c.toLowerCase(),
                                c === a || 0 === c.indexOf(a + "-");
                        while ((b = b.parentNode) && 1 === b.nodeType);return !1
                    }
                }),
                target: function(b) {
                    var c = a.location && a.location.hash;
                    return c && c.slice(1) === b.id
                },
                root: function(a) {
                    return a === o
                },
                focus: function(a) {
                    return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex)
                },
                enabled: oa(!1),
                disabled: oa(!0),
                checked: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && !!a.checked || "option" === b && !!a.selected
                },
                selected: function(a) {
                    return a.parentNode && a.parentNode.selectedIndex,
                    a.selected === !0
                },
                empty: function(a) {
                    for (a = a.firstChild; a; a = a.nextSibling)
                        if (a.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(a) {
                    return !d.pseudos.empty(a)
                },
                header: function(a) {
                    return X.test(a.nodeName)
                },
                input: function(a) {
                    return W.test(a.nodeName)
                },
                button: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && "button" === a.type || "button" === b
                },
                text: function(a) {
                    var b;
                    return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase())
                },
                first: pa(function() {
                    return [0]
                }),
                last: pa(function(a, b) {
                    return [b - 1]
                }),
                eq: pa(function(a, b, c) {
                    return [c < 0 ? c + b : c]
                }),
                even: pa(function(a, b) {
                    for (var c = 0; c < b; c += 2)
                        a.push(c);
                    return a
                }),
                odd: pa(function(a, b) {
                    for (var c = 1; c < b; c += 2)
                        a.push(c);
                    return a
                }),
                lt: pa(function(a, b, c) {
                    for (var d = c < 0 ? c + b : c; --d >= 0; )
                        a.push(d);
                    return a
                }),
                gt: pa(function(a, b, c) {
                    for (var d = c < 0 ? c + b : c; ++d < b; )
                        a.push(d);
                    return a
                })
            }
        },
        d.pseudos.nth = d.pseudos.eq;
        for (b in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            d.pseudos[b] = ma(b);
        for (b in {
            submit: !0,
            reset: !0
        })
            d.pseudos[b] = na(b);
        function ra() {}
        ra.prototype = d.filters = d.pseudos,
        d.setFilters = new ra,
        g = ga.tokenize = function(a, b) {
            var c, e, f, g, h, i, j, k = z[a + " "];
            if (k)
                return b ? 0 : k.slice(0);
            h = a,
            i = [],
            j = d.preFilter;
            while (h) {
                c && !(e = Q.exec(h)) || (e && (h = h.slice(e[0].length) || h),
                i.push(f = [])),
                c = !1,
                (e = R.exec(h)) && (c = e.shift(),
                f.push({
                    value: c,
                    type: e[0].replace(P, " ")
                }),
                h = h.slice(c.length));
                for (g in d.filter)
                    !(e = V[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(),
                    f.push({
                        value: c,
                        type: g,
                        matches: e
                    }),
                    h = h.slice(c.length));
                if (!c)
                    break
            }
            return b ? h.length : h ? ga.error(a) : z(a, i).slice(0)
        }
        ;
        function sa(a) {
            for (var b = 0, c = a.length, d = ""; b < c; b++)
                d += a[b].value;
            return d
        }
        function ta(a, b, c) {
            var d = b.dir
              , e = b.next
              , f = e || d
              , g = c && "parentNode" === f
              , h = x++;
            return b.first ? function(b, c, e) {
                while (b = b[d])
                    if (1 === b.nodeType || g)
                        return a(b, c, e);
                return !1
            }
            : function(b, c, i) {
                var j, k, l, m = [w, h];
                if (i) {
                    while (b = b[d])
                        if ((1 === b.nodeType || g) && a(b, c, i))
                            return !0
                } else
                    while (b = b[d])
                        if (1 === b.nodeType || g)
                            if (l = b[u] || (b[u] = {}),
                            k = l[b.uniqueID] || (l[b.uniqueID] = {}),
                            e && e === b.nodeName.toLowerCase())
                                b = b[d] || b;
                            else {
                                if ((j = k[f]) && j[0] === w && j[1] === h)
                                    return m[2] = j[2];
                                if (k[f] = m,
                                m[2] = a(b, c, i))
                                    return !0
                            }
                return !1
            }
        }
        function ua(a) {
            return a.length > 1 ? function(b, c, d) {
                var e = a.length;
                while (e--)
                    if (!a[e](b, c, d))
                        return !1;
                return !0
            }
            : a[0]
        }
        function va(a, b, c) {
            for (var d = 0, e = b.length; d < e; d++)
                ga(a, b[d], c);
            return c
        }
        function wa(a, b, c, d, e) {
            for (var f, g = [], h = 0, i = a.length, j = null != b; h < i; h++)
                (f = a[h]) && (c && !c(f, d, e) || (g.push(f),
                j && b.push(h)));
            return g
        }
        function xa(a, b, c, d, e, f) {
            return d && !d[u] && (d = xa(d)),
            e && !e[u] && (e = xa(e, f)),
            ia(function(f, g, h, i) {
                var j, k, l, m = [], n = [], o = g.length, p = f || va(b || "*", h.nodeType ? [h] : h, []), q = !a || !f && b ? p : wa(p, m, a, h, i), r = c ? e || (f ? a : o || d) ? [] : g : q;
                if (c && c(q, r, h, i),
                d) {
                    j = wa(r, n),
                    d(j, [], h, i),
                    k = j.length;
                    while (k--)
                        (l = j[k]) && (r[n[k]] = !(q[n[k]] = l))
                }
                if (f) {
                    if (e || a) {
                        if (e) {
                            j = [],
                            k = r.length;
                            while (k--)
                                (l = r[k]) && j.push(q[k] = l);
                            e(null, r = [], j, i)
                        }
                        k = r.length;
                        while (k--)
                            (l = r[k]) && (j = e ? I(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l))
                    }
                } else
                    r = wa(r === g ? r.splice(o, r.length) : r),
                    e ? e(null, g, r, i) : G.apply(g, r)
            })
        }
        function ya(a) {
            for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = ta(function(a) {
                return a === b
            }, h, !0), l = ta(function(a) {
                return I(b, a) > -1
            }, h, !0), m = [function(a, c, d) {
                var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
                return b = null,
                e
            }
            ]; i < f; i++)
                if (c = d.relative[a[i].type])
                    m = [ta(ua(m), c)];
                else {
                    if (c = d.filter[a[i].type].apply(null, a[i].matches),
                    c[u]) {
                        for (e = ++i; e < f; e++)
                            if (d.relative[a[e].type])
                                break;
                        return xa(i > 1 && ua(m), i > 1 && sa(a.slice(0, i - 1).concat({
                            value: " " === a[i - 2].type ? "*" : ""
                        })).replace(P, "$1"), c, i < e && ya(a.slice(i, e)), e < f && ya(a = a.slice(e)), e < f && sa(a))
                    }
                    m.push(c)
                }
            return ua(m)
        }
        function za(a, b) {
            var c = b.length > 0
              , e = a.length > 0
              , f = function(f, g, h, i, k) {
                var l, o, q, r = 0, s = "0", t = f && [], u = [], v = j, x = f || e && d.find.TAG("*", k), y = w += null == v ? 1 : Math.random() || .1, z = x.length;
                for (k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++) {
                    if (e && l) {
                        o = 0,
                        g || l.ownerDocument === n || (m(l),
                        h = !p);
                        while (q = a[o++])
                            if (q(l, g || n, h)) {
                                i.push(l);
                                break
                            }
                        k && (w = y)
                    }
                    c && ((l = !q && l) && r--,
                    f && t.push(l))
                }
                if (r += s,
                c && s !== r) {
                    o = 0;
                    while (q = b[o++])
                        q(t, u, g, h);
                    if (f) {
                        if (r > 0)
                            while (s--)
                                t[s] || u[s] || (u[s] = E.call(i));
                        u = wa(u)
                    }
                    G.apply(i, u),
                    k && !f && u.length > 0 && r + b.length > 1 && ga.uniqueSort(i)
                }
                return k && (w = y,
                j = v),
                t
            };
            return c ? ia(f) : f
        }
        return h = ga.compile = function(a, b) {
            var c, d = [], e = [], f = A[a + " "];
            if (!f) {
                b || (b = g(a)),
                c = b.length;
                while (c--)
                    f = ya(b[c]),
                    f[u] ? d.push(f) : e.push(f);
                f = A(a, za(e, d)),
                f.selector = a
            }
            return f
        }
        ,
        i = ga.select = function(a, b, c, e) {
            var f, i, j, k, l, m = "function" == typeof a && a, n = !e && g(a = m.selector || a);
            if (c = c || [],
            1 === n.length) {
                if (i = n[0] = n[0].slice(0),
                i.length > 2 && "ID" === (j = i[0]).type && 9 === b.nodeType && p && d.relative[i[1].type]) {
                    if (b = (d.find.ID(j.matches[0].replace(_, aa), b) || [])[0],
                    !b)
                        return c;
                    m && (b = b.parentNode),
                    a = a.slice(i.shift().value.length)
                }
                f = V.needsContext.test(a) ? 0 : i.length;
                while (f--) {
                    if (j = i[f],
                    d.relative[k = j.type])
                        break;
                    if ((l = d.find[k]) && (e = l(j.matches[0].replace(_, aa), $.test(i[0].type) && qa(b.parentNode) || b))) {
                        if (i.splice(f, 1),
                        a = e.length && sa(i),
                        !a)
                            return G.apply(c, e),
                            c;
                        break
                    }
                }
            }
            return (m || h(a, n))(e, b, !p, c, !b || $.test(a) && qa(b.parentNode) || b),
            c
        }
        ,
        c.sortStable = u.split("").sort(B).join("") === u,
        c.detectDuplicates = !!l,
        m(),
        c.sortDetached = ja(function(a) {
            return 1 & a.compareDocumentPosition(n.createElement("fieldset"))
        }),
        ja(function(a) {
            return a.innerHTML = "<a href='#'></a>",
            "#" === a.firstChild.getAttribute("href")
        }) || ka("type|href|height|width", function(a, b, c) {
            if (!c)
                return a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2)
        }),
        c.attributes && ja(function(a) {
            return a.innerHTML = "<input/>",
            a.firstChild.setAttribute("value", ""),
            "" === a.firstChild.getAttribute("value")
        }) || ka("value", function(a, b, c) {
            if (!c && "input" === a.nodeName.toLowerCase())
                return a.defaultValue
        }),
        ja(function(a) {
            return null == a.getAttribute("disabled")
        }) || ka(J, function(a, b, c) {
            var d;
            if (!c)
                return a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null
        }),
        ga
    }(a);
    r.find = x,
    r.expr = x.selectors,
    r.expr[":"] = r.expr.pseudos,
    r.uniqueSort = r.unique = x.uniqueSort,
    r.text = x.getText,
    r.isXMLDoc = x.isXML,
    r.contains = x.contains,
    r.escapeSelector = x.escape;
    var y = function(a, b, c) {
        var d = []
          , e = void 0 !== c;
        while ((a = a[b]) && 9 !== a.nodeType)
            if (1 === a.nodeType) {
                if (e && r(a).is(c))
                    break;
                d.push(a)
            }
        return d
    }
      , z = function(a, b) {
        for (var c = []; a; a = a.nextSibling)
            1 === a.nodeType && a !== b && c.push(a);
        return c
    }
      , A = r.expr.match.needsContext;
    function B(a, b) {
        return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase()
    }
    var C = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i
      , D = /^.[^:#\[\.,]*$/;
    function E(a, b, c) {
        return r.isFunction(b) ? r.grep(a, function(a, d) {
            return !!b.call(a, d, a) !== c
        }) : b.nodeType ? r.grep(a, function(a) {
            return a === b !== c
        }) : "string" != typeof b ? r.grep(a, function(a) {
            return i.call(b, a) > -1 !== c
        }) : D.test(b) ? r.filter(b, a, c) : (b = r.filter(b, a),
        r.grep(a, function(a) {
            return i.call(b, a) > -1 !== c && 1 === a.nodeType
        }))
    }
    r.filter = function(a, b, c) {
        var d = b[0];
        return c && (a = ":not(" + a + ")"),
        1 === b.length && 1 === d.nodeType ? r.find.matchesSelector(d, a) ? [d] : [] : r.find.matches(a, r.grep(b, function(a) {
            return 1 === a.nodeType
        }))
    }
    ,
    r.fn.extend({
        find: function(a) {
            var b, c, d = this.length, e = this;
            if ("string" != typeof a)
                return this.pushStack(r(a).filter(function() {
                    for (b = 0; b < d; b++)
                        if (r.contains(e[b], this))
                            return !0
                }));
            for (c = this.pushStack([]),
            b = 0; b < d; b++)
                r.find(a, e[b], c);
            return d > 1 ? r.uniqueSort(c) : c
        },
        filter: function(a) {
            return this.pushStack(E(this, a || [], !1))
        },
        not: function(a) {
            return this.pushStack(E(this, a || [], !0))
        },
        is: function(a) {
            return !!E(this, "string" == typeof a && A.test(a) ? r(a) : a || [], !1).length
        }
    });
    var F, G = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, H = r.fn.init = function(a, b, c) {
        var e, f;
        if (!a)
            return this;
        if (c = c || F,
        "string" == typeof a) {
            if (e = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : G.exec(a),
            !e || !e[1] && b)
                return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);
            if (e[1]) {
                if (b = b instanceof r ? b[0] : b,
                r.merge(this, r.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)),
                C.test(e[1]) && r.isPlainObject(b))
                    for (e in b)
                        r.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
                return this
            }
            return f = d.getElementById(e[2]),
            f && (this[0] = f,
            this.length = 1),
            this
        }
        return a.nodeType ? (this[0] = a,
        this.length = 1,
        this) : r.isFunction(a) ? void 0 !== c.ready ? c.ready(a) : a(r) : r.makeArray(a, this)
    }
    ;
    H.prototype = r.fn,
    F = r(d);
    var I = /^(?:parents|prev(?:Until|All))/
      , J = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    r.fn.extend({
        has: function(a) {
            var b = r(a, this)
              , c = b.length;
            return this.filter(function() {
                for (var a = 0; a < c; a++)
                    if (r.contains(this, b[a]))
                        return !0
            })
        },
        closest: function(a, b) {
            var c, d = 0, e = this.length, f = [], g = "string" != typeof a && r(a);
            if (!A.test(a))
                for (; d < e; d++)
                    for (c = this[d]; c && c !== b; c = c.parentNode)
                        if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && r.find.matchesSelector(c, a))) {
                            f.push(c);
                            break
                        }
            return this.pushStack(f.length > 1 ? r.uniqueSort(f) : f)
        },
        index: function(a) {
            return a ? "string" == typeof a ? i.call(r(a), this[0]) : i.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(a, b) {
            return this.pushStack(r.uniqueSort(r.merge(this.get(), r(a, b))))
        },
        addBack: function(a) {
            return this.add(null == a ? this.prevObject : this.prevObject.filter(a))
        }
    });
    function K(a, b) {
        while ((a = a[b]) && 1 !== a.nodeType)
            ;
        return a
    }
    r.each({
        parent: function(a) {
            var b = a.parentNode;
            return b && 11 !== b.nodeType ? b : null
        },
        parents: function(a) {
            return y(a, "parentNode")
        },
        parentsUntil: function(a, b, c) {
            return y(a, "parentNode", c)
        },
        next: function(a) {
            return K(a, "nextSibling")
        },
        prev: function(a) {
            return K(a, "previousSibling")
        },
        nextAll: function(a) {
            return y(a, "nextSibling")
        },
        prevAll: function(a) {
            return y(a, "previousSibling")
        },
        nextUntil: function(a, b, c) {
            return y(a, "nextSibling", c)
        },
        prevUntil: function(a, b, c) {
            return y(a, "previousSibling", c)
        },
        siblings: function(a) {
            return z((a.parentNode || {}).firstChild, a)
        },
        children: function(a) {
            return z(a.firstChild)
        },
        contents: function(a) {
            return B(a, "iframe") ? a.contentDocument : (B(a, "template") && (a = a.content || a),
            r.merge([], a.childNodes))
        }
    }, function(a, b) {
        r.fn[a] = function(c, d) {
            var e = r.map(this, b, c);
            return "Until" !== a.slice(-5) && (d = c),
            d && "string" == typeof d && (e = r.filter(d, e)),
            this.length > 1 && (J[a] || r.uniqueSort(e),
            I.test(a) && e.reverse()),
            this.pushStack(e)
        }
    });
    var L = /[^\x20\t\r\n\f]+/g;
    function M(a) {
        var b = {};
        return r.each(a.match(L) || [], function(a, c) {
            b[c] = !0
        }),
        b
    }
    r.Callbacks = function(a) {
        a = "string" == typeof a ? M(a) : r.extend({}, a);
        var b, c, d, e, f = [], g = [], h = -1, i = function() {
            for (e = e || a.once,
            d = b = !0; g.length; h = -1) {
                c = g.shift();
                while (++h < f.length)
                    f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && (h = f.length,
                    c = !1)
            }
            a.memory || (c = !1),
            b = !1,
            e && (f = c ? [] : "")
        }, j = {
            add: function() {
                return f && (c && !b && (h = f.length - 1,
                g.push(c)),
                function d(b) {
                    r.each(b, function(b, c) {
                        r.isFunction(c) ? a.unique && j.has(c) || f.push(c) : c && c.length && "string" !== r.type(c) && d(c)
                    })
                }(arguments),
                c && !b && i()),
                this
            },
            remove: function() {
                return r.each(arguments, function(a, b) {
                    var c;
                    while ((c = r.inArray(b, f, c)) > -1)
                        f.splice(c, 1),
                        c <= h && h--
                }),
                this
            },
            has: function(a) {
                return a ? r.inArray(a, f) > -1 : f.length > 0
            },
            empty: function() {
                return f && (f = []),
                this
            },
            disable: function() {
                return e = g = [],
                f = c = "",
                this
            },
            disabled: function() {
                return !f
            },
            lock: function() {
                return e = g = [],
                c || b || (f = c = ""),
                this
            },
            locked: function() {
                return !!e
            },
            fireWith: function(a, c) {
                return e || (c = c || [],
                c = [a, c.slice ? c.slice() : c],
                g.push(c),
                b || i()),
                this
            },
            fire: function() {
                return j.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!d
            }
        };
        return j
    }
    ;
    function N(a) {
        return a
    }
    function O(a) {
        throw a
    }
    function P(a, b, c, d) {
        var e;
        try {
            a && r.isFunction(e = a.promise) ? e.call(a).done(b).fail(c) : a && r.isFunction(e = a.then) ? e.call(a, b, c) : b.apply(void 0, [a].slice(d))
        } catch (a) {
            c.apply(void 0, [a])
        }
    }
    r.extend({
        Deferred: function(b) {
            var c = [["notify", "progress", r.Callbacks("memory"), r.Callbacks("memory"), 2], ["resolve", "done", r.Callbacks("once memory"), r.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", r.Callbacks("once memory"), r.Callbacks("once memory"), 1, "rejected"]]
              , d = "pending"
              , e = {
                state: function() {
                    return d
                },
                always: function() {
                    return f.done(arguments).fail(arguments),
                    this
                },
                "catch": function(a) {
                    return e.then(null, a)
                },
                pipe: function() {
                    var a = arguments;
                    return r.Deferred(function(b) {
                        r.each(c, function(c, d) {
                            var e = r.isFunction(a[d[4]]) && a[d[4]];
                            f[d[1]](function() {
                                var a = e && e.apply(this, arguments);
                                a && r.isFunction(a.promise) ? a.promise().progress(b.notify).done(b.resolve).fail(b.reject) : b[d[0] + "With"](this, e ? [a] : arguments)
                            })
                        }),
                        a = null
                    }).promise()
                },
                then: function(b, d, e) {
                    var f = 0;
                    function g(b, c, d, e) {
                        return function() {
                            var h = this
                              , i = arguments
                              , j = function() {
                                var a, j;
                                if (!(b < f)) {
                                    if (a = d.apply(h, i),
                                    a === c.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    j = a && ("object" == typeof a || "function" == typeof a) && a.then,
                                    r.isFunction(j) ? e ? j.call(a, g(f, c, N, e), g(f, c, O, e)) : (f++,
                                    j.call(a, g(f, c, N, e), g(f, c, O, e), g(f, c, N, c.notifyWith))) : (d !== N && (h = void 0,
                                    i = [a]),
                                    (e || c.resolveWith)(h, i))
                                }
                            }
                              , k = e ? j : function() {
                                try {
                                    j()
                                } catch (a) {
                                    r.Deferred.exceptionHook && r.Deferred.exceptionHook(a, k.stackTrace),
                                    b + 1 >= f && (d !== O && (h = void 0,
                                    i = [a]),
                                    c.rejectWith(h, i))
                                }
                            }
                            ;
                            b ? k() : (r.Deferred.getStackHook && (k.stackTrace = r.Deferred.getStackHook()),
                            a.setTimeout(k))
                        }
                    }
                    return r.Deferred(function(a) {
                        c[0][3].add(g(0, a, r.isFunction(e) ? e : N, a.notifyWith)),
                        c[1][3].add(g(0, a, r.isFunction(b) ? b : N)),
                        c[2][3].add(g(0, a, r.isFunction(d) ? d : O))
                    }).promise()
                },
                promise: function(a) {
                    return null != a ? r.extend(a, e) : e
                }
            }
              , f = {};
            return r.each(c, function(a, b) {
                var g = b[2]
                  , h = b[5];
                e[b[1]] = g.add,
                h && g.add(function() {
                    d = h
                }, c[3 - a][2].disable, c[0][2].lock),
                g.add(b[3].fire),
                f[b[0]] = function() {
                    return f[b[0] + "With"](this === f ? void 0 : this, arguments),
                    this
                }
                ,
                f[b[0] + "With"] = g.fireWith
            }),
            e.promise(f),
            b && b.call(f, f),
            f
        },
        when: function(a) {
            var b = arguments.length
              , c = b
              , d = Array(c)
              , e = f.call(arguments)
              , g = r.Deferred()
              , h = function(a) {
                return function(c) {
                    d[a] = this,
                    e[a] = arguments.length > 1 ? f.call(arguments) : c,
                    --b || g.resolveWith(d, e)
                }
            };
            if (b <= 1 && (P(a, g.done(h(c)).resolve, g.reject, !b),
            "pending" === g.state() || r.isFunction(e[c] && e[c].then)))
                return g.then();
            while (c--)
                P(e[c], h(c), g.reject);
            return g.promise()
        }
    });
    var Q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    r.Deferred.exceptionHook = function(b, c) {
        a.console && a.console.warn && b && Q.test(b.name) && a.console.warn("jQuery.Deferred exception: " + b.message, b.stack, c)
    }
    ,
    r.readyException = function(b) {
        a.setTimeout(function() {
            throw b
        })
    }
    ;
    var R = r.Deferred();
    r.fn.ready = function(a) {
        return R.then(a)["catch"](function(a) {
            r.readyException(a)
        }),
        this
    }
    ,
    r.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(a) {
            (a === !0 ? --r.readyWait : r.isReady) || (r.isReady = !0,
            a !== !0 && --r.readyWait > 0 || R.resolveWith(d, [r]))
        }
    }),
    r.ready.then = R.then;
    function S() {
        d.removeEventListener("DOMContentLoaded", S),
        a.removeEventListener("load", S),
        r.ready()
    }
    "complete" === d.readyState || "loading" !== d.readyState && !d.documentElement.doScroll ? a.setTimeout(r.ready) : (d.addEventListener("DOMContentLoaded", S),
    a.addEventListener("load", S));
    var T = function(a, b, c, d, e, f, g) {
        var h = 0
          , i = a.length
          , j = null == c;
        if ("object" === r.type(c)) {
            e = !0;
            for (h in c)
                T(a, b, h, c[h], !0, f, g)
        } else if (void 0 !== d && (e = !0,
        r.isFunction(d) || (g = !0),
        j && (g ? (b.call(a, d),
        b = null) : (j = b,
        b = function(a, b, c) {
            return j.call(r(a), c)
        }
        )),
        b))
            for (; h < i; h++)
                b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
        return e ? a : j ? b.call(a) : i ? b(a[0], c) : f
    }
      , U = function(a) {
        return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType
    };
    function V() {
        this.expando = r.expando + V.uid++
    }
    V.uid = 1,
    V.prototype = {
        cache: function(a) {
            var b = a[this.expando];
            return b || (b = {},
            U(a) && (a.nodeType ? a[this.expando] = b : Object.defineProperty(a, this.expando, {
                value: b,
                configurable: !0
            }))),
            b
        },
        set: function(a, b, c) {
            var d, e = this.cache(a);
            if ("string" == typeof b)
                e[r.camelCase(b)] = c;
            else
                for (d in b)
                    e[r.camelCase(d)] = b[d];
            return e
        },
        get: function(a, b) {
            return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][r.camelCase(b)]
        },
        access: function(a, b, c) {
            return void 0 === b || b && "string" == typeof b && void 0 === c ? this.get(a, b) : (this.set(a, b, c),
            void 0 !== c ? c : b)
        },
        remove: function(a, b) {
            var c, d = a[this.expando];
            if (void 0 !== d) {
                if (void 0 !== b) {
                    Array.isArray(b) ? b = b.map(r.camelCase) : (b = r.camelCase(b),
                    b = b in d ? [b] : b.match(L) || []),
                    c = b.length;
                    while (c--)
                        delete d[b[c]]
                }
                (void 0 === b || r.isEmptyObject(d)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando])
            }
        },
        hasData: function(a) {
            var b = a[this.expando];
            return void 0 !== b && !r.isEmptyObject(b)
        }
    };
    var W = new V
      , X = new V
      , Y = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Z = /[A-Z]/g;
    function $(a) {
        return "true" === a || "false" !== a && ("null" === a ? null : a === +a + "" ? +a : Y.test(a) ? JSON.parse(a) : a)
    }
    function _(a, b, c) {
        var d;
        if (void 0 === c && 1 === a.nodeType)
            if (d = "data-" + b.replace(Z, "-$&").toLowerCase(),
            c = a.getAttribute(d),
            "string" == typeof c) {
                try {
                    c = $(c)
                } catch (e) {}
                X.set(a, b, c)
            } else
                c = void 0;
        return c
    }
    r.extend({
        hasData: function(a) {
            return X.hasData(a) || W.hasData(a)
        },
        data: function(a, b, c) {
            return X.access(a, b, c)
        },
        removeData: function(a, b) {
            X.remove(a, b)
        },
        _data: function(a, b, c) {
            return W.access(a, b, c)
        },
        _removeData: function(a, b) {
            W.remove(a, b)
        }
    }),
    r.fn.extend({
        data: function(a, b) {
            var c, d, e, f = this[0], g = f && f.attributes;
            if (void 0 === a) {
                if (this.length && (e = X.get(f),
                1 === f.nodeType && !W.get(f, "hasDataAttrs"))) {
                    c = g.length;
                    while (c--)
                        g[c] && (d = g[c].name,
                        0 === d.indexOf("data-") && (d = r.camelCase(d.slice(5)),
                        _(f, d, e[d])));
                    W.set(f, "hasDataAttrs", !0)
                }
                return e
            }
            return "object" == typeof a ? this.each(function() {
                X.set(this, a)
            }) : T(this, function(b) {
                var c;
                if (f && void 0 === b) {
                    if (c = X.get(f, a),
                    void 0 !== c)
                        return c;
                    if (c = _(f, a),
                    void 0 !== c)
                        return c
                } else
                    this.each(function() {
                        X.set(this, a, b)
                    })
            }, null, b, arguments.length > 1, null, !0)
        },
        removeData: function(a) {
            return this.each(function() {
                X.remove(this, a)
            })
        }
    }),
    r.extend({
        queue: function(a, b, c) {
            var d;
            if (a)
                return b = (b || "fx") + "queue",
                d = W.get(a, b),
                c && (!d || Array.isArray(c) ? d = W.access(a, b, r.makeArray(c)) : d.push(c)),
                d || []
        },
        dequeue: function(a, b) {
            b = b || "fx";
            var c = r.queue(a, b)
              , d = c.length
              , e = c.shift()
              , f = r._queueHooks(a, b)
              , g = function() {
                r.dequeue(a, b)
            };
            "inprogress" === e && (e = c.shift(),
            d--),
            e && ("fx" === b && c.unshift("inprogress"),
            delete f.stop,
            e.call(a, g, f)),
            !d && f && f.empty.fire()
        },
        _queueHooks: function(a, b) {
            var c = b + "queueHooks";
            return W.get(a, c) || W.access(a, c, {
                empty: r.Callbacks("once memory").add(function() {
                    W.remove(a, [b + "queue", c])
                })
            })
        }
    }),
    r.fn.extend({
        queue: function(a, b) {
            var c = 2;
            return "string" != typeof a && (b = a,
            a = "fx",
            c--),
            arguments.length < c ? r.queue(this[0], a) : void 0 === b ? this : this.each(function() {
                var c = r.queue(this, a, b);
                r._queueHooks(this, a),
                "fx" === a && "inprogress" !== c[0] && r.dequeue(this, a)
            })
        },
        dequeue: function(a) {
            return this.each(function() {
                r.dequeue(this, a)
            })
        },
        clearQueue: function(a) {
            return this.queue(a || "fx", [])
        },
        promise: function(a, b) {
            var c, d = 1, e = r.Deferred(), f = this, g = this.length, h = function() {
                --d || e.resolveWith(f, [f])
            };
            "string" != typeof a && (b = a,
            a = void 0),
            a = a || "fx";
            while (g--)
                c = W.get(f[g], a + "queueHooks"),
                c && c.empty && (d++,
                c.empty.add(h));
            return h(),
            e.promise(b)
        }
    });
    var aa = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , ba = new RegExp("^(?:([+-])=|)(" + aa + ")([a-z%]*)$","i")
      , ca = ["Top", "Right", "Bottom", "Left"]
      , da = function(a, b) {
        return a = b || a,
        "none" === a.style.display || "" === a.style.display && r.contains(a.ownerDocument, a) && "none" === r.css(a, "display")
    }
      , ea = function(a, b, c, d) {
        var e, f, g = {};
        for (f in b)
            g[f] = a.style[f],
            a.style[f] = b[f];
        e = c.apply(a, d || []);
        for (f in b)
            a.style[f] = g[f];
        return e
    };
    function fa(a, b, c, d) {
        var e, f = 1, g = 20, h = d ? function() {
            return d.cur()
        }
        : function() {
            return r.css(a, b, "")
        }
        , i = h(), j = c && c[3] || (r.cssNumber[b] ? "" : "px"), k = (r.cssNumber[b] || "px" !== j && +i) && ba.exec(r.css(a, b));
        if (k && k[3] !== j) {
            j = j || k[3],
            c = c || [],
            k = +i || 1;
            do
                f = f || ".5",
                k /= f,
                r.style(a, b, k + j);
            while (f !== (f = h() / i) && 1 !== f && --g)
        }
        return c && (k = +k || +i || 0,
        e = c[1] ? k + (c[1] + 1) * c[2] : +c[2],
        d && (d.unit = j,
        d.start = k,
        d.end = e)),
        e
    }
    var ga = {};
    function ha(a) {
        var b, c = a.ownerDocument, d = a.nodeName, e = ga[d];
        return e ? e : (b = c.body.appendChild(c.createElement(d)),
        e = r.css(b, "display"),
        b.parentNode.removeChild(b),
        "none" === e && (e = "block"),
        ga[d] = e,
        e)
    }
    function ia(a, b) {
        for (var c, d, e = [], f = 0, g = a.length; f < g; f++)
            d = a[f],
            d.style && (c = d.style.display,
            b ? ("none" === c && (e[f] = W.get(d, "display") || null,
            e[f] || (d.style.display = "")),
            "" === d.style.display && da(d) && (e[f] = ha(d))) : "none" !== c && (e[f] = "none",
            W.set(d, "display", c)));
        for (f = 0; f < g; f++)
            null != e[f] && (a[f].style.display = e[f]);
        return a
    }
    r.fn.extend({
        show: function() {
            return ia(this, !0)
        },
        hide: function() {
            return ia(this)
        },
        toggle: function(a) {
            return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function() {
                da(this) ? r(this).show() : r(this).hide()
            })
        }
    });
    var ja = /^(?:checkbox|radio)$/i
      , ka = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
      , la = /^$|\/(?:java|ecma)script/i
      , ma = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    ma.optgroup = ma.option,
    ma.tbody = ma.tfoot = ma.colgroup = ma.caption = ma.thead,
    ma.th = ma.td;
    function na(a, b) {
        var c;
        return c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [],
        void 0 === b || b && B(a, b) ? r.merge([a], c) : c
    }
    function oa(a, b) {
        for (var c = 0, d = a.length; c < d; c++)
            W.set(a[c], "globalEval", !b || W.get(b[c], "globalEval"))
    }
    var pa = /<|&#?\w+;/;
    function qa(a, b, c, d, e) {
        for (var f, g, h, i, j, k, l = b.createDocumentFragment(), m = [], n = 0, o = a.length; n < o; n++)
            if (f = a[n],
            f || 0 === f)
                if ("object" === r.type(f))
                    r.merge(m, f.nodeType ? [f] : f);
                else if (pa.test(f)) {
                    g = g || l.appendChild(b.createElement("div")),
                    h = (ka.exec(f) || ["", ""])[1].toLowerCase(),
                    i = ma[h] || ma._default,
                    g.innerHTML = i[1] + r.htmlPrefilter(f) + i[2],
                    k = i[0];
                    while (k--)
                        g = g.lastChild;
                    r.merge(m, g.childNodes),
                    g = l.firstChild,
                    g.textContent = ""
                } else
                    m.push(b.createTextNode(f));
        l.textContent = "",
        n = 0;
        while (f = m[n++])
            if (d && r.inArray(f, d) > -1)
                e && e.push(f);
            else if (j = r.contains(f.ownerDocument, f),
            g = na(l.appendChild(f), "script"),
            j && oa(g),
            c) {
                k = 0;
                while (f = g[k++])
                    la.test(f.type || "") && c.push(f)
            }
        return l
    }
    !function() {
        var a = d.createDocumentFragment()
          , b = a.appendChild(d.createElement("div"))
          , c = d.createElement("input");
        c.setAttribute("type", "radio"),
        c.setAttribute("checked", "checked"),
        c.setAttribute("name", "t"),
        b.appendChild(c),
        o.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked,
        b.innerHTML = "<textarea>x</textarea>",
        o.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue
    }();
    var ra = d.documentElement
      , sa = /^key/
      , ta = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , ua = /^([^.]*)(?:\.(.+)|)/;
    function va() {
        return !0
    }
    function wa() {
        return !1
    }
    function xa() {
        try {
            return d.activeElement
        } catch (a) {}
    }
    function ya(a, b, c, d, e, f) {
        var g, h;
        if ("object" == typeof b) {
            "string" != typeof c && (d = d || c,
            c = void 0);
            for (h in b)
                ya(a, h, c, d, b[h], f);
            return a
        }
        if (null == d && null == e ? (e = c,
        d = c = void 0) : null == e && ("string" == typeof c ? (e = d,
        d = void 0) : (e = d,
        d = c,
        c = void 0)),
        e === !1)
            e = wa;
        else if (!e)
            return a;
        return 1 === f && (g = e,
        e = function(a) {
            return r().off(a),
            g.apply(this, arguments)
        }
        ,
        e.guid = g.guid || (g.guid = r.guid++)),
        a.each(function() {
            r.event.add(this, b, e, d, c)
        })
    }
    r.event = {
        global: {},
        add: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, n, o, p, q = W.get(a);
            if (q) {
                c.handler && (f = c,
                c = f.handler,
                e = f.selector),
                e && r.find.matchesSelector(ra, e),
                c.guid || (c.guid = r.guid++),
                (i = q.events) || (i = q.events = {}),
                (g = q.handle) || (g = q.handle = function(b) {
                    return "undefined" != typeof r && r.event.triggered !== b.type ? r.event.dispatch.apply(a, arguments) : void 0
                }
                ),
                b = (b || "").match(L) || [""],
                j = b.length;
                while (j--)
                    h = ua.exec(b[j]) || [],
                    n = p = h[1],
                    o = (h[2] || "").split(".").sort(),
                    n && (l = r.event.special[n] || {},
                    n = (e ? l.delegateType : l.bindType) || n,
                    l = r.event.special[n] || {},
                    k = r.extend({
                        type: n,
                        origType: p,
                        data: d,
                        handler: c,
                        guid: c.guid,
                        selector: e,
                        needsContext: e && r.expr.match.needsContext.test(e),
                        namespace: o.join(".")
                    }, f),
                    (m = i[n]) || (m = i[n] = [],
                    m.delegateCount = 0,
                    l.setup && l.setup.call(a, d, o, g) !== !1 || a.addEventListener && a.addEventListener(n, g)),
                    l.add && (l.add.call(a, k),
                    k.handler.guid || (k.handler.guid = c.guid)),
                    e ? m.splice(m.delegateCount++, 0, k) : m.push(k),
                    r.event.global[n] = !0)
            }
        },
        remove: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, n, o, p, q = W.hasData(a) && W.get(a);
            if (q && (i = q.events)) {
                b = (b || "").match(L) || [""],
                j = b.length;
                while (j--)
                    if (h = ua.exec(b[j]) || [],
                    n = p = h[1],
                    o = (h[2] || "").split(".").sort(),
                    n) {
                        l = r.event.special[n] || {},
                        n = (d ? l.delegateType : l.bindType) || n,
                        m = i[n] || [],
                        h = h[2] && new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        g = f = m.length;
                        while (f--)
                            k = m[f],
                            !e && p !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1),
                            k.selector && m.delegateCount--,
                            l.remove && l.remove.call(a, k));
                        g && !m.length && (l.teardown && l.teardown.call(a, o, q.handle) !== !1 || r.removeEvent(a, n, q.handle),
                        delete i[n])
                    } else
                        for (n in i)
                            r.event.remove(a, n + b[j], c, d, !0);
                r.isEmptyObject(i) && W.remove(a, "handle events")
            }
        },
        dispatch: function(a) {
            var b = r.event.fix(a), c, d, e, f, g, h, i = new Array(arguments.length), j = (W.get(this, "events") || {})[b.type] || [], k = r.event.special[b.type] || {};
            for (i[0] = b,
            c = 1; c < arguments.length; c++)
                i[c] = arguments[c];
            if (b.delegateTarget = this,
            !k.preDispatch || k.preDispatch.call(this, b) !== !1) {
                h = r.event.handlers.call(this, b, j),
                c = 0;
                while ((f = h[c++]) && !b.isPropagationStopped()) {
                    b.currentTarget = f.elem,
                    d = 0;
                    while ((g = f.handlers[d++]) && !b.isImmediatePropagationStopped())
                        b.rnamespace && !b.rnamespace.test(g.namespace) || (b.handleObj = g,
                        b.data = g.data,
                        e = ((r.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i),
                        void 0 !== e && (b.result = e) === !1 && (b.preventDefault(),
                        b.stopPropagation()))
                }
                return k.postDispatch && k.postDispatch.call(this, b),
                b.result
            }
        },
        handlers: function(a, b) {
            var c, d, e, f, g, h = [], i = b.delegateCount, j = a.target;
            if (i && j.nodeType && !("click" === a.type && a.button >= 1))
                for (; j !== this; j = j.parentNode || this)
                    if (1 === j.nodeType && ("click" !== a.type || j.disabled !== !0)) {
                        for (f = [],
                        g = {},
                        c = 0; c < i; c++)
                            d = b[c],
                            e = d.selector + " ",
                            void 0 === g[e] && (g[e] = d.needsContext ? r(e, this).index(j) > -1 : r.find(e, this, null, [j]).length),
                            g[e] && f.push(d);
                        f.length && h.push({
                            elem: j,
                            handlers: f
                        })
                    }
            return j = this,
            i < b.length && h.push({
                elem: j,
                handlers: b.slice(i)
            }),
            h
        },
        addProp: function(a, b) {
            Object.defineProperty(r.Event.prototype, a, {
                enumerable: !0,
                configurable: !0,
                get: r.isFunction(b) ? function() {
                    if (this.originalEvent)
                        return b(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[a]
                }
                ,
                set: function(b) {
                    Object.defineProperty(this, a, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: b
                    })
                }
            })
        },
        fix: function(a) {
            return a[r.expando] ? a : new r.Event(a)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== xa() && this.focus)
                        return this.focus(),
                        !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === xa() && this.blur)
                        return this.blur(),
                        !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ("checkbox" === this.type && this.click && B(this, "input"))
                        return this.click(),
                        !1
                },
                _default: function(a) {
                    return B(a.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(a) {
                    void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result)
                }
            }
        }
    },
    r.removeEvent = function(a, b, c) {
        a.removeEventListener && a.removeEventListener(b, c)
    }
    ,
    r.Event = function(a, b) {
        return this instanceof r.Event ? (a && a.type ? (this.originalEvent = a,
        this.type = a.type,
        this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? va : wa,
        this.target = a.target && 3 === a.target.nodeType ? a.target.parentNode : a.target,
        this.currentTarget = a.currentTarget,
        this.relatedTarget = a.relatedTarget) : this.type = a,
        b && r.extend(this, b),
        this.timeStamp = a && a.timeStamp || r.now(),
        void (this[r.expando] = !0)) : new r.Event(a,b)
    }
    ,
    r.Event.prototype = {
        constructor: r.Event,
        isDefaultPrevented: wa,
        isPropagationStopped: wa,
        isImmediatePropagationStopped: wa,
        isSimulated: !1,
        preventDefault: function() {
            var a = this.originalEvent;
            this.isDefaultPrevented = va,
            a && !this.isSimulated && a.preventDefault()
        },
        stopPropagation: function() {
            var a = this.originalEvent;
            this.isPropagationStopped = va,
            a && !this.isSimulated && a.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = va,
            a && !this.isSimulated && a.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    r.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        "char": !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(a) {
            var b = a.button;
            return null == a.which && sa.test(a.type) ? null != a.charCode ? a.charCode : a.keyCode : !a.which && void 0 !== b && ta.test(a.type) ? 1 & b ? 1 : 2 & b ? 3 : 4 & b ? 2 : 0 : a.which
        }
    }, r.event.addProp),
    r.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(a, b) {
        r.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function(a) {
                var c, d = this, e = a.relatedTarget, f = a.handleObj;
                return e && (e === d || r.contains(d, e)) || (a.type = f.origType,
                c = f.handler.apply(this, arguments),
                a.type = b),
                c
            }
        }
    }),
    r.fn.extend({
        on: function(a, b, c, d) {
            return ya(this, a, b, c, d)
        },
        one: function(a, b, c, d) {
            return ya(this, a, b, c, d, 1)
        },
        off: function(a, b, c) {
            var d, e;
            if (a && a.preventDefault && a.handleObj)
                return d = a.handleObj,
                r(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler),
                this;
            if ("object" == typeof a) {
                for (e in a)
                    this.off(e, b, a[e]);
                return this
            }
            return b !== !1 && "function" != typeof b || (c = b,
            b = void 0),
            c === !1 && (c = wa),
            this.each(function() {
                r.event.remove(this, a, c, b)
            })
        }
    });
    var za = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , Aa = /<script|<style|<link/i
      , Ba = /checked\s*(?:[^=]|=\s*.checked.)/i
      , Ca = /^true\/(.*)/
      , Da = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Ea(a, b) {
        return B(a, "table") && B(11 !== b.nodeType ? b : b.firstChild, "tr") ? r(">tbody", a)[0] || a : a
    }
    function Fa(a) {
        return a.type = (null !== a.getAttribute("type")) + "/" + a.type,
        a
    }
    function Ga(a) {
        var b = Ca.exec(a.type);
        return b ? a.type = b[1] : a.removeAttribute("type"),
        a
    }
    function Ha(a, b) {
        var c, d, e, f, g, h, i, j;
        if (1 === b.nodeType) {
            if (W.hasData(a) && (f = W.access(a),
            g = W.set(b, f),
            j = f.events)) {
                delete g.handle,
                g.events = {};
                for (e in j)
                    for (c = 0,
                    d = j[e].length; c < d; c++)
                        r.event.add(b, e, j[e][c])
            }
            X.hasData(a) && (h = X.access(a),
            i = r.extend({}, h),
            X.set(b, i))
        }
    }
    function Ia(a, b) {
        var c = b.nodeName.toLowerCase();
        "input" === c && ja.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue)
    }
    function Ja(a, b, c, d) {
        b = g.apply([], b);
        var e, f, h, i, j, k, l = 0, m = a.length, n = m - 1, q = b[0], s = r.isFunction(q);
        if (s || m > 1 && "string" == typeof q && !o.checkClone && Ba.test(q))
            return a.each(function(e) {
                var f = a.eq(e);
                s && (b[0] = q.call(this, e, f.html())),
                Ja(f, b, c, d)
            });
        if (m && (e = qa(b, a[0].ownerDocument, !1, a, d),
        f = e.firstChild,
        1 === e.childNodes.length && (e = f),
        f || d)) {
            for (h = r.map(na(e, "script"), Fa),
            i = h.length; l < m; l++)
                j = e,
                l !== n && (j = r.clone(j, !0, !0),
                i && r.merge(h, na(j, "script"))),
                c.call(a[l], j, l);
            if (i)
                for (k = h[h.length - 1].ownerDocument,
                r.map(h, Ga),
                l = 0; l < i; l++)
                    j = h[l],
                    la.test(j.type || "") && !W.access(j, "globalEval") && r.contains(k, j) && (j.src ? r._evalUrl && r._evalUrl(j.src) : p(j.textContent.replace(Da, ""), k))
        }
        return a
    }
    function Ka(a, b, c) {
        for (var d, e = b ? r.filter(b, a) : a, f = 0; null != (d = e[f]); f++)
            c || 1 !== d.nodeType || r.cleanData(na(d)),
            d.parentNode && (c && r.contains(d.ownerDocument, d) && oa(na(d, "script")),
            d.parentNode.removeChild(d));
        return a
    }
    r.extend({
        htmlPrefilter: function(a) {
            return a.replace(za, "<$1></$2>")
        },
        clone: function(a, b, c) {
            var d, e, f, g, h = a.cloneNode(!0), i = r.contains(a.ownerDocument, a);
            if (!(o.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || r.isXMLDoc(a)))
                for (g = na(h),
                f = na(a),
                d = 0,
                e = f.length; d < e; d++)
                    Ia(f[d], g[d]);
            if (b)
                if (c)
                    for (f = f || na(a),
                    g = g || na(h),
                    d = 0,
                    e = f.length; d < e; d++)
                        Ha(f[d], g[d]);
                else
                    Ha(a, h);
            return g = na(h, "script"),
            g.length > 0 && oa(g, !i && na(a, "script")),
            h
        },
        cleanData: function(a) {
            for (var b, c, d, e = r.event.special, f = 0; void 0 !== (c = a[f]); f++)
                if (U(c)) {
                    if (b = c[W.expando]) {
                        if (b.events)
                            for (d in b.events)
                                e[d] ? r.event.remove(c, d) : r.removeEvent(c, d, b.handle);
                        c[W.expando] = void 0
                    }
                    c[X.expando] && (c[X.expando] = void 0)
                }
        }
    }),
    r.fn.extend({
        detach: function(a) {
            return Ka(this, a, !0)
        },
        remove: function(a) {
            return Ka(this, a)
        },
        text: function(a) {
            return T(this, function(a) {
                return void 0 === a ? r.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a)
                })
            }, null, a, arguments.length)
        },
        append: function() {
            return Ja(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = Ea(this, a);
                    b.appendChild(a)
                }
            })
        },
        prepend: function() {
            return Ja(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = Ea(this, a);
                    b.insertBefore(a, b.firstChild)
                }
            })
        },
        before: function() {
            return Ja(this, arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this)
            })
        },
        after: function() {
            return Ja(this, arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this.nextSibling)
            })
        },
        empty: function() {
            for (var a, b = 0; null != (a = this[b]); b++)
                1 === a.nodeType && (r.cleanData(na(a, !1)),
                a.textContent = "");
            return this
        },
        clone: function(a, b) {
            return a = null != a && a,
            b = null == b ? a : b,
            this.map(function() {
                return r.clone(this, a, b)
            })
        },
        html: function(a) {
            return T(this, function(a) {
                var b = this[0] || {}
                  , c = 0
                  , d = this.length;
                if (void 0 === a && 1 === b.nodeType)
                    return b.innerHTML;
                if ("string" == typeof a && !Aa.test(a) && !ma[(ka.exec(a) || ["", ""])[1].toLowerCase()]) {
                    a = r.htmlPrefilter(a);
                    try {
                        for (; c < d; c++)
                            b = this[c] || {},
                            1 === b.nodeType && (r.cleanData(na(b, !1)),
                            b.innerHTML = a);
                        b = 0
                    } catch (e) {}
                }
                b && this.empty().append(a)
            }, null, a, arguments.length)
        },
        replaceWith: function() {
            var a = [];
            return Ja(this, arguments, function(b) {
                var c = this.parentNode;
                r.inArray(this, a) < 0 && (r.cleanData(na(this)),
                c && c.replaceChild(b, this))
            }, a)
        }
    }),
    r.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(a, b) {
        r.fn[a] = function(a) {
            for (var c, d = [], e = r(a), f = e.length - 1, g = 0; g <= f; g++)
                c = g === f ? this : this.clone(!0),
                r(e[g])[b](c),
                h.apply(d, c.get());
            return this.pushStack(d)
        }
    });
    var La = /^margin/
      , Ma = new RegExp("^(" + aa + ")(?!px)[a-z%]+$","i")
      , Na = function(b) {
        var c = b.ownerDocument.defaultView;
        return c && c.opener || (c = a),
        c.getComputedStyle(b)
    };
    !function() {
        function b() {
            if (i) {
                i.style.cssText = "box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",
                i.innerHTML = "",
                ra.appendChild(h);
                var b = a.getComputedStyle(i);
                c = "1%" !== b.top,
                g = "2px" === b.marginLeft,
                e = "4px" === b.width,
                i.style.marginRight = "50%",
                f = "4px" === b.marginRight,
                ra.removeChild(h),
                i = null
            }
        }
        var c, e, f, g, h = d.createElement("div"), i = d.createElement("div");
        i.style && (i.style.backgroundClip = "content-box",
        i.cloneNode(!0).style.backgroundClip = "",
        o.clearCloneStyle = "content-box" === i.style.backgroundClip,
        h.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",
        h.appendChild(i),
        r.extend(o, {
            pixelPosition: function() {
                return b(),
                c
            },
            boxSizingReliable: function() {
                return b(),
                e
            },
            pixelMarginRight: function() {
                return b(),
                f
            },
            reliableMarginLeft: function() {
                return b(),
                g
            }
        }))
    }();
    function Oa(a, b, c) {
        var d, e, f, g, h = a.style;
        return c = c || Na(a),
        c && (g = c.getPropertyValue(b) || c[b],
        "" !== g || r.contains(a.ownerDocument, a) || (g = r.style(a, b)),
        !o.pixelMarginRight() && Ma.test(g) && La.test(b) && (d = h.width,
        e = h.minWidth,
        f = h.maxWidth,
        h.minWidth = h.maxWidth = h.width = g,
        g = c.width,
        h.width = d,
        h.minWidth = e,
        h.maxWidth = f)),
        void 0 !== g ? g + "" : g
    }
    function Pa(a, b) {
        return {
            get: function() {
                return a() ? void delete this.get : (this.get = b).apply(this, arguments)
            }
        }
    }
    var Qa = /^(none|table(?!-c[ea]).+)/
      , Ra = /^--/
      , Sa = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Ta = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Ua = ["Webkit", "Moz", "ms"]
      , Va = d.createElement("div").style;
    function Wa(a) {
        if (a in Va)
            return a;
        var b = a[0].toUpperCase() + a.slice(1)
          , c = Ua.length;
        while (c--)
            if (a = Ua[c] + b,
            a in Va)
                return a
    }
    function Xa(a) {
        var b = r.cssProps[a];
        return b || (b = r.cssProps[a] = Wa(a) || a),
        b
    }
    function Ya(a, b, c) {
        var d = ba.exec(b);
        return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b
    }
    function Za(a, b, c, d, e) {
        var f, g = 0;
        for (f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0; f < 4; f += 2)
            "margin" === c && (g += r.css(a, c + ca[f], !0, e)),
            d ? ("content" === c && (g -= r.css(a, "padding" + ca[f], !0, e)),
            "margin" !== c && (g -= r.css(a, "border" + ca[f] + "Width", !0, e))) : (g += r.css(a, "padding" + ca[f], !0, e),
            "padding" !== c && (g += r.css(a, "border" + ca[f] + "Width", !0, e)));
        return g
    }
    function $a(a, b, c) {
        var d, e = Na(a), f = Oa(a, b, e), g = "border-box" === r.css(a, "boxSizing", !1, e);
        return Ma.test(f) ? f : (d = g && (o.boxSizingReliable() || f === a.style[b]),
        "auto" === f && (f = a["offset" + b[0].toUpperCase() + b.slice(1)]),
        f = parseFloat(f) || 0,
        f + Za(a, b, c || (g ? "border" : "content"), d, e) + "px")
    }
    r.extend({
        cssHooks: {
            opacity: {
                get: function(a, b) {
                    if (b) {
                        var c = Oa(a, "opacity");
                        return "" === c ? "1" : c
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            "float": "cssFloat"
        },
        style: function(a, b, c, d) {
            if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
                var e, f, g, h = r.camelCase(b), i = Ra.test(b), j = a.style;
                return i || (b = Xa(h)),
                g = r.cssHooks[b] || r.cssHooks[h],
                void 0 === c ? g && "get"in g && void 0 !== (e = g.get(a, !1, d)) ? e : j[b] : (f = typeof c,
                "string" === f && (e = ba.exec(c)) && e[1] && (c = fa(a, b, e),
                f = "number"),
                null != c && c === c && ("number" === f && (c += e && e[3] || (r.cssNumber[h] ? "" : "px")),
                o.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (j[b] = "inherit"),
                g && "set"in g && void 0 === (c = g.set(a, c, d)) || (i ? j.setProperty(b, c) : j[b] = c)),
                void 0)
            }
        },
        css: function(a, b, c, d) {
            var e, f, g, h = r.camelCase(b), i = Ra.test(b);
            return i || (b = Xa(h)),
            g = r.cssHooks[b] || r.cssHooks[h],
            g && "get"in g && (e = g.get(a, !0, c)),
            void 0 === e && (e = Oa(a, b, d)),
            "normal" === e && b in Ta && (e = Ta[b]),
            "" === c || c ? (f = parseFloat(e),
            c === !0 || isFinite(f) ? f || 0 : e) : e
        }
    }),
    r.each(["height", "width"], function(a, b) {
        r.cssHooks[b] = {
            get: function(a, c, d) {
                if (c)
                    return !Qa.test(r.css(a, "display")) || a.getClientRects().length && a.getBoundingClientRect().width ? $a(a, b, d) : ea(a, Sa, function() {
                        return $a(a, b, d)
                    })
            },
            set: function(a, c, d) {
                var e, f = d && Na(a), g = d && Za(a, b, d, "border-box" === r.css(a, "boxSizing", !1, f), f);
                return g && (e = ba.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c,
                c = r.css(a, b)),
                Ya(a, c, g)
            }
        }
    }),
    r.cssHooks.marginLeft = Pa(o.reliableMarginLeft, function(a, b) {
        if (b)
            return (parseFloat(Oa(a, "marginLeft")) || a.getBoundingClientRect().left - ea(a, {
                marginLeft: 0
            }, function() {
                return a.getBoundingClientRect().left
            })) + "px"
    }),
    r.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(a, b) {
        r.cssHooks[a + b] = {
            expand: function(c) {
                for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; d < 4; d++)
                    e[a + ca[d] + b] = f[d] || f[d - 2] || f[0];
                return e
            }
        },
        La.test(a) || (r.cssHooks[a + b].set = Ya)
    }),
    r.fn.extend({
        css: function(a, b) {
            return T(this, function(a, b, c) {
                var d, e, f = {}, g = 0;
                if (Array.isArray(b)) {
                    for (d = Na(a),
                    e = b.length; g < e; g++)
                        f[b[g]] = r.css(a, b[g], !1, d);
                    return f
                }
                return void 0 !== c ? r.style(a, b, c) : r.css(a, b)
            }, a, b, arguments.length > 1)
        }
    });
    function _a(a, b, c, d, e) {
        return new _a.prototype.init(a,b,c,d,e)
    }
    r.Tween = _a,
    _a.prototype = {
        constructor: _a,
        init: function(a, b, c, d, e, f) {
            this.elem = a,
            this.prop = c,
            this.easing = e || r.easing._default,
            this.options = b,
            this.start = this.now = this.cur(),
            this.end = d,
            this.unit = f || (r.cssNumber[c] ? "" : "px")
        },
        cur: function() {
            var a = _a.propHooks[this.prop];
            return a && a.get ? a.get(this) : _a.propHooks._default.get(this)
        },
        run: function(a) {
            var b, c = _a.propHooks[this.prop];
            return this.options.duration ? this.pos = b = r.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a,
            this.now = (this.end - this.start) * b + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            c && c.set ? c.set(this) : _a.propHooks._default.set(this),
            this
        }
    },
    _a.prototype.init.prototype = _a.prototype,
    _a.propHooks = {
        _default: {
            get: function(a) {
                var b;
                return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = r.css(a.elem, a.prop, ""),
                b && "auto" !== b ? b : 0)
            },
            set: function(a) {
                r.fx.step[a.prop] ? r.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[r.cssProps[a.prop]] && !r.cssHooks[a.prop] ? a.elem[a.prop] = a.now : r.style(a.elem, a.prop, a.now + a.unit)
            }
        }
    },
    _a.propHooks.scrollTop = _a.propHooks.scrollLeft = {
        set: function(a) {
            a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now)
        }
    },
    r.easing = {
        linear: function(a) {
            return a
        },
        swing: function(a) {
            return .5 - Math.cos(a * Math.PI) / 2
        },
        _default: "swing"
    },
    r.fx = _a.prototype.init,
    r.fx.step = {};
    var ab, bb, cb = /^(?:toggle|show|hide)$/, db = /queueHooks$/;
    function eb() {
        bb && (d.hidden === !1 && a.requestAnimationFrame ? a.requestAnimationFrame(eb) : a.setTimeout(eb, r.fx.interval),
        r.fx.tick())
    }
    function fb() {
        return a.setTimeout(function() {
            ab = void 0
        }),
        ab = r.now()
    }
    function gb(a, b) {
        var c, d = 0, e = {
            height: a
        };
        for (b = b ? 1 : 0; d < 4; d += 2 - b)
            c = ca[d],
            e["margin" + c] = e["padding" + c] = a;
        return b && (e.opacity = e.width = a),
        e
    }
    function hb(a, b, c) {
        for (var d, e = (kb.tweeners[b] || []).concat(kb.tweeners["*"]), f = 0, g = e.length; f < g; f++)
            if (d = e[f].call(c, b, a))
                return d
    }
    function ib(a, b, c) {
        var d, e, f, g, h, i, j, k, l = "width"in b || "height"in b, m = this, n = {}, o = a.style, p = a.nodeType && da(a), q = W.get(a, "fxshow");
        c.queue || (g = r._queueHooks(a, "fx"),
        null == g.unqueued && (g.unqueued = 0,
        h = g.empty.fire,
        g.empty.fire = function() {
            g.unqueued || h()
        }
        ),
        g.unqueued++,
        m.always(function() {
            m.always(function() {
                g.unqueued--,
                r.queue(a, "fx").length || g.empty.fire()
            })
        }));
        for (d in b)
            if (e = b[d],
            cb.test(e)) {
                if (delete b[d],
                f = f || "toggle" === e,
                e === (p ? "hide" : "show")) {
                    if ("show" !== e || !q || void 0 === q[d])
                        continue;
                    p = !0
                }
                n[d] = q && q[d] || r.style(a, d)
            }
        if (i = !r.isEmptyObject(b),
        i || !r.isEmptyObject(n)) {
            l && 1 === a.nodeType && (c.overflow = [o.overflow, o.overflowX, o.overflowY],
            j = q && q.display,
            null == j && (j = W.get(a, "display")),
            k = r.css(a, "display"),
            "none" === k && (j ? k = j : (ia([a], !0),
            j = a.style.display || j,
            k = r.css(a, "display"),
            ia([a]))),
            ("inline" === k || "inline-block" === k && null != j) && "none" === r.css(a, "float") && (i || (m.done(function() {
                o.display = j
            }),
            null == j && (k = o.display,
            j = "none" === k ? "" : k)),
            o.display = "inline-block")),
            c.overflow && (o.overflow = "hidden",
            m.always(function() {
                o.overflow = c.overflow[0],
                o.overflowX = c.overflow[1],
                o.overflowY = c.overflow[2]
            })),
            i = !1;
            for (d in n)
                i || (q ? "hidden"in q && (p = q.hidden) : q = W.access(a, "fxshow", {
                    display: j
                }),
                f && (q.hidden = !p),
                p && ia([a], !0),
                m.done(function() {
                    p || ia([a]),
                    W.remove(a, "fxshow");
                    for (d in n)
                        r.style(a, d, n[d])
                })),
                i = hb(p ? q[d] : 0, d, m),
                d in q || (q[d] = i.start,
                p && (i.end = i.start,
                i.start = 0))
        }
    }
    function jb(a, b) {
        var c, d, e, f, g;
        for (c in a)
            if (d = r.camelCase(c),
            e = b[d],
            f = a[c],
            Array.isArray(f) && (e = f[1],
            f = a[c] = f[0]),
            c !== d && (a[d] = f,
            delete a[c]),
            g = r.cssHooks[d],
            g && "expand"in g) {
                f = g.expand(f),
                delete a[d];
                for (c in f)
                    c in a || (a[c] = f[c],
                    b[c] = e)
            } else
                b[d] = e
    }
    function kb(a, b, c) {
        var d, e, f = 0, g = kb.prefilters.length, h = r.Deferred().always(function() {
            delete i.elem
        }), i = function() {
            if (e)
                return !1;
            for (var b = ab || fb(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; g < i; g++)
                j.tweens[g].run(f);
            return h.notifyWith(a, [j, f, c]),
            f < 1 && i ? c : (i || h.notifyWith(a, [j, 1, 0]),
            h.resolveWith(a, [j]),
            !1)
        }, j = h.promise({
            elem: a,
            props: r.extend({}, b),
            opts: r.extend(!0, {
                specialEasing: {},
                easing: r.easing._default
            }, c),
            originalProperties: b,
            originalOptions: c,
            startTime: ab || fb(),
            duration: c.duration,
            tweens: [],
            createTween: function(b, c) {
                var d = r.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);
                return j.tweens.push(d),
                d
            },
            stop: function(b) {
                var c = 0
                  , d = b ? j.tweens.length : 0;
                if (e)
                    return this;
                for (e = !0; c < d; c++)
                    j.tweens[c].run(1);
                return b ? (h.notifyWith(a, [j, 1, 0]),
                h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]),
                this
            }
        }), k = j.props;
        for (jb(k, j.opts.specialEasing); f < g; f++)
            if (d = kb.prefilters[f].call(j, a, k, j.opts))
                return r.isFunction(d.stop) && (r._queueHooks(j.elem, j.opts.queue).stop = r.proxy(d.stop, d)),
                d;
        return r.map(k, hb, j),
        r.isFunction(j.opts.start) && j.opts.start.call(a, j),
        j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always),
        r.fx.timer(r.extend(i, {
            elem: a,
            anim: j,
            queue: j.opts.queue
        })),
        j
    }
    r.Animation = r.extend(kb, {
        tweeners: {
            "*": [function(a, b) {
                var c = this.createTween(a, b);
                return fa(c.elem, a, ba.exec(b), c),
                c
            }
            ]
        },
        tweener: function(a, b) {
            r.isFunction(a) ? (b = a,
            a = ["*"]) : a = a.match(L);
            for (var c, d = 0, e = a.length; d < e; d++)
                c = a[d],
                kb.tweeners[c] = kb.tweeners[c] || [],
                kb.tweeners[c].unshift(b)
        },
        prefilters: [ib],
        prefilter: function(a, b) {
            b ? kb.prefilters.unshift(a) : kb.prefilters.push(a)
        }
    }),
    r.speed = function(a, b, c) {
        var d = a && "object" == typeof a ? r.extend({}, a) : {
            complete: c || !c && b || r.isFunction(a) && a,
            duration: a,
            easing: c && b || b && !r.isFunction(b) && b
        };
        return r.fx.off ? d.duration = 0 : "number" != typeof d.duration && (d.duration in r.fx.speeds ? d.duration = r.fx.speeds[d.duration] : d.duration = r.fx.speeds._default),
        null != d.queue && d.queue !== !0 || (d.queue = "fx"),
        d.old = d.complete,
        d.complete = function() {
            r.isFunction(d.old) && d.old.call(this),
            d.queue && r.dequeue(this, d.queue)
        }
        ,
        d
    }
    ,
    r.fn.extend({
        fadeTo: function(a, b, c, d) {
            return this.filter(da).css("opacity", 0).show().end().animate({
                opacity: b
            }, a, c, d)
        },
        animate: function(a, b, c, d) {
            var e = r.isEmptyObject(a)
              , f = r.speed(b, c, d)
              , g = function() {
                var b = kb(this, r.extend({}, a), f);
                (e || W.get(this, "finish")) && b.stop(!0)
            };
            return g.finish = g,
            e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
        },
        stop: function(a, b, c) {
            var d = function(a) {
                var b = a.stop;
                delete a.stop,
                b(c)
            };
            return "string" != typeof a && (c = b,
            b = a,
            a = void 0),
            b && a !== !1 && this.queue(a || "fx", []),
            this.each(function() {
                var b = !0
                  , e = null != a && a + "queueHooks"
                  , f = r.timers
                  , g = W.get(this);
                if (e)
                    g[e] && g[e].stop && d(g[e]);
                else
                    for (e in g)
                        g[e] && g[e].stop && db.test(e) && d(g[e]);
                for (e = f.length; e--; )
                    f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c),
                    b = !1,
                    f.splice(e, 1));
                !b && c || r.dequeue(this, a)
            })
        },
        finish: function(a) {
            return a !== !1 && (a = a || "fx"),
            this.each(function() {
                var b, c = W.get(this), d = c[a + "queue"], e = c[a + "queueHooks"], f = r.timers, g = d ? d.length : 0;
                for (c.finish = !0,
                r.queue(this, a, []),
                e && e.stop && e.stop.call(this, !0),
                b = f.length; b--; )
                    f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0),
                    f.splice(b, 1));
                for (b = 0; b < g; b++)
                    d[b] && d[b].finish && d[b].finish.call(this);
                delete c.finish
            })
        }
    }),
    r.each(["toggle", "show", "hide"], function(a, b) {
        var c = r.fn[b];
        r.fn[b] = function(a, d, e) {
            return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(gb(b, !0), a, d, e)
        }
    }),
    r.each({
        slideDown: gb("show"),
        slideUp: gb("hide"),
        slideToggle: gb("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(a, b) {
        r.fn[a] = function(a, c, d) {
            return this.animate(b, a, c, d)
        }
    }),
    r.timers = [],
    r.fx.tick = function() {
        var a, b = 0, c = r.timers;
        for (ab = r.now(); b < c.length; b++)
            a = c[b],
            a() || c[b] !== a || c.splice(b--, 1);
        c.length || r.fx.stop(),
        ab = void 0
    }
    ,
    r.fx.timer = function(a) {
        r.timers.push(a),
        r.fx.start()
    }
    ,
    r.fx.interval = 13,
    r.fx.start = function() {
        bb || (bb = !0,
        eb())
    }
    ,
    r.fx.stop = function() {
        bb = null
    }
    ,
    r.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    r.fn.delay = function(b, c) {
        return b = r.fx ? r.fx.speeds[b] || b : b,
        c = c || "fx",
        this.queue(c, function(c, d) {
            var e = a.setTimeout(c, b);
            d.stop = function() {
                a.clearTimeout(e)
            }
        })
    }
    ,
    function() {
        var a = d.createElement("input")
          , b = d.createElement("select")
          , c = b.appendChild(d.createElement("option"));
        a.type = "checkbox",
        o.checkOn = "" !== a.value,
        o.optSelected = c.selected,
        a = d.createElement("input"),
        a.value = "t",
        a.type = "radio",
        o.radioValue = "t" === a.value
    }();
    var lb, mb = r.expr.attrHandle;
    r.fn.extend({
        attr: function(a, b) {
            return T(this, r.attr, a, b, arguments.length > 1)
        },
        removeAttr: function(a) {
            return this.each(function() {
                r.removeAttr(this, a)
            })
        }
    }),
    r.extend({
        attr: function(a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f)
                return "undefined" == typeof a.getAttribute ? r.prop(a, b, c) : (1 === f && r.isXMLDoc(a) || (e = r.attrHooks[b.toLowerCase()] || (r.expr.match.bool.test(b) ? lb : void 0)),
                void 0 !== c ? null === c ? void r.removeAttr(a, b) : e && "set"in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""),
                c) : e && "get"in e && null !== (d = e.get(a, b)) ? d : (d = r.find.attr(a, b),
                null == d ? void 0 : d))
        },
        attrHooks: {
            type: {
                set: function(a, b) {
                    if (!o.radioValue && "radio" === b && B(a, "input")) {
                        var c = a.value;
                        return a.setAttribute("type", b),
                        c && (a.value = c),
                        b
                    }
                }
            }
        },
        removeAttr: function(a, b) {
            var c, d = 0, e = b && b.match(L);
            if (e && 1 === a.nodeType)
                while (c = e[d++])
                    a.removeAttribute(c)
        }
    }),
    lb = {
        set: function(a, b, c) {
            return b === !1 ? r.removeAttr(a, c) : a.setAttribute(c, c),
            c
        }
    },
    r.each(r.expr.match.bool.source.match(/\w+/g), function(a, b) {
        var c = mb[b] || r.find.attr;
        mb[b] = function(a, b, d) {
            var e, f, g = b.toLowerCase();
            return d || (f = mb[g],
            mb[g] = e,
            e = null != c(a, b, d) ? g : null,
            mb[g] = f),
            e
        }
    });
    var nb = /^(?:input|select|textarea|button)$/i
      , ob = /^(?:a|area)$/i;
    r.fn.extend({
        prop: function(a, b) {
            return T(this, r.prop, a, b, arguments.length > 1)
        },
        removeProp: function(a) {
            return this.each(function() {
                delete this[r.propFix[a] || a]
            })
        }
    }),
    r.extend({
        prop: function(a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f)
                return 1 === f && r.isXMLDoc(a) || (b = r.propFix[b] || b,
                e = r.propHooks[b]),
                void 0 !== c ? e && "set"in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get"in e && null !== (d = e.get(a, b)) ? d : a[b]
        },
        propHooks: {
            tabIndex: {
                get: function(a) {
                    var b = r.find.attr(a, "tabindex");
                    return b ? parseInt(b, 10) : nb.test(a.nodeName) || ob.test(a.nodeName) && a.href ? 0 : -1
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    }),
    o.optSelected || (r.propHooks.selected = {
        get: function(a) {
            var b = a.parentNode;
            return b && b.parentNode && b.parentNode.selectedIndex,
            null
        },
        set: function(a) {
            var b = a.parentNode;
            b && (b.selectedIndex,
            b.parentNode && b.parentNode.selectedIndex)
        }
    }),
    r.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        r.propFix[this.toLowerCase()] = this
    });
    function pb(a) {
        var b = a.match(L) || [];
        return b.join(" ")
    }
    function qb(a) {
        return a.getAttribute && a.getAttribute("class") || ""
    }
    r.fn.extend({
        addClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (r.isFunction(a))
                return this.each(function(b) {
                    r(this).addClass(a.call(this, b, qb(this)))
                });
            if ("string" == typeof a && a) {
                b = a.match(L) || [];
                while (c = this[i++])
                    if (e = qb(c),
                    d = 1 === c.nodeType && " " + pb(e) + " ") {
                        g = 0;
                        while (f = b[g++])
                            d.indexOf(" " + f + " ") < 0 && (d += f + " ");
                        h = pb(d),
                        e !== h && c.setAttribute("class", h)
                    }
            }
            return this
        },
        removeClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (r.isFunction(a))
                return this.each(function(b) {
                    r(this).removeClass(a.call(this, b, qb(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ("string" == typeof a && a) {
                b = a.match(L) || [];
                while (c = this[i++])
                    if (e = qb(c),
                    d = 1 === c.nodeType && " " + pb(e) + " ") {
                        g = 0;
                        while (f = b[g++])
                            while (d.indexOf(" " + f + " ") > -1)
                                d = d.replace(" " + f + " ", " ");
                        h = pb(d),
                        e !== h && c.setAttribute("class", h)
                    }
            }
            return this
        },
        toggleClass: function(a, b) {
            var c = typeof a;
            return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : r.isFunction(a) ? this.each(function(c) {
                r(this).toggleClass(a.call(this, c, qb(this), b), b)
            }) : this.each(function() {
                var b, d, e, f;
                if ("string" === c) {
                    d = 0,
                    e = r(this),
                    f = a.match(L) || [];
                    while (b = f[d++])
                        e.hasClass(b) ? e.removeClass(b) : e.addClass(b)
                } else
                    void 0 !== a && "boolean" !== c || (b = qb(this),
                    b && W.set(this, "__className__", b),
                    this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : W.get(this, "__className__") || ""))
            })
        },
        hasClass: function(a) {
            var b, c, d = 0;
            b = " " + a + " ";
            while (c = this[d++])
                if (1 === c.nodeType && (" " + pb(qb(c)) + " ").indexOf(b) > -1)
                    return !0;
            return !1
        }
    });
    var rb = /\r/g;
    r.fn.extend({
        val: function(a) {
            var b, c, d, e = this[0];
            {
                if (arguments.length)
                    return d = r.isFunction(a),
                    this.each(function(c) {
                        var e;
                        1 === this.nodeType && (e = d ? a.call(this, c, r(this).val()) : a,
                        null == e ? e = "" : "number" == typeof e ? e += "" : Array.isArray(e) && (e = r.map(e, function(a) {
                            return null == a ? "" : a + ""
                        })),
                        b = r.valHooks[this.type] || r.valHooks[this.nodeName.toLowerCase()],
                        b && "set"in b && void 0 !== b.set(this, e, "value") || (this.value = e))
                    });
                if (e)
                    return b = r.valHooks[e.type] || r.valHooks[e.nodeName.toLowerCase()],
                    b && "get"in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value,
                    "string" == typeof c ? c.replace(rb, "") : null == c ? "" : c)
            }
        }
    }),
    r.extend({
        valHooks: {
            option: {
                get: function(a) {
                    var b = r.find.attr(a, "value");
                    return null != b ? b : pb(r.text(a))
                }
            },
            select: {
                get: function(a) {
                    var b, c, d, e = a.options, f = a.selectedIndex, g = "select-one" === a.type, h = g ? null : [], i = g ? f + 1 : e.length;
                    for (d = f < 0 ? i : g ? f : 0; d < i; d++)
                        if (c = e[d],
                        (c.selected || d === f) && !c.disabled && (!c.parentNode.disabled || !B(c.parentNode, "optgroup"))) {
                            if (b = r(c).val(),
                            g)
                                return b;
                            h.push(b)
                        }
                    return h
                },
                set: function(a, b) {
                    var c, d, e = a.options, f = r.makeArray(b), g = e.length;
                    while (g--)
                        d = e[g],
                        (d.selected = r.inArray(r.valHooks.option.get(d), f) > -1) && (c = !0);
                    return c || (a.selectedIndex = -1),
                    f
                }
            }
        }
    }),
    r.each(["radio", "checkbox"], function() {
        r.valHooks[this] = {
            set: function(a, b) {
                if (Array.isArray(b))
                    return a.checked = r.inArray(r(a).val(), b) > -1
            }
        },
        o.checkOn || (r.valHooks[this].get = function(a) {
            return null === a.getAttribute("value") ? "on" : a.value
        }
        )
    });
    var sb = /^(?:focusinfocus|focusoutblur)$/;
    r.extend(r.event, {
        trigger: function(b, c, e, f) {
            var g, h, i, j, k, m, n, o = [e || d], p = l.call(b, "type") ? b.type : b, q = l.call(b, "namespace") ? b.namespace.split(".") : [];
            if (h = i = e = e || d,
            3 !== e.nodeType && 8 !== e.nodeType && !sb.test(p + r.event.triggered) && (p.indexOf(".") > -1 && (q = p.split("."),
            p = q.shift(),
            q.sort()),
            k = p.indexOf(":") < 0 && "on" + p,
            b = b[r.expando] ? b : new r.Event(p,"object" == typeof b && b),
            b.isTrigger = f ? 2 : 3,
            b.namespace = q.join("."),
            b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + q.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            b.result = void 0,
            b.target || (b.target = e),
            c = null == c ? [b] : r.makeArray(c, [b]),
            n = r.event.special[p] || {},
            f || !n.trigger || n.trigger.apply(e, c) !== !1)) {
                if (!f && !n.noBubble && !r.isWindow(e)) {
                    for (j = n.delegateType || p,
                    sb.test(j + p) || (h = h.parentNode); h; h = h.parentNode)
                        o.push(h),
                        i = h;
                    i === (e.ownerDocument || d) && o.push(i.defaultView || i.parentWindow || a)
                }
                g = 0;
                while ((h = o[g++]) && !b.isPropagationStopped())
                    b.type = g > 1 ? j : n.bindType || p,
                    m = (W.get(h, "events") || {})[b.type] && W.get(h, "handle"),
                    m && m.apply(h, c),
                    m = k && h[k],
                    m && m.apply && U(h) && (b.result = m.apply(h, c),
                    b.result === !1 && b.preventDefault());
                return b.type = p,
                f || b.isDefaultPrevented() || n._default && n._default.apply(o.pop(), c) !== !1 || !U(e) || k && r.isFunction(e[p]) && !r.isWindow(e) && (i = e[k],
                i && (e[k] = null),
                r.event.triggered = p,
                e[p](),
                r.event.triggered = void 0,
                i && (e[k] = i)),
                b.result
            }
        },
        simulate: function(a, b, c) {
            var d = r.extend(new r.Event, c, {
                type: a,
                isSimulated: !0
            });
            r.event.trigger(d, null, b)
        }
    }),
    r.fn.extend({
        trigger: function(a, b) {
            return this.each(function() {
                r.event.trigger(a, b, this)
            })
        },
        triggerHandler: function(a, b) {
            var c = this[0];
            if (c)
                return r.event.trigger(a, b, c, !0)
        }
    }),
    r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(a, b) {
        r.fn[b] = function(a, c) {
            return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b)
        }
    }),
    r.fn.extend({
        hover: function(a, b) {
            return this.mouseenter(a).mouseleave(b || a)
        }
    }),
    o.focusin = "onfocusin"in a,
    o.focusin || r.each({
        focus: "focusin",
        blur: "focusout"
    }, function(a, b) {
        var c = function(a) {
            r.event.simulate(b, a.target, r.event.fix(a))
        };
        r.event.special[b] = {
            setup: function() {
                var d = this.ownerDocument || this
                  , e = W.access(d, b);
                e || d.addEventListener(a, c, !0),
                W.access(d, b, (e || 0) + 1)
            },
            teardown: function() {
                var d = this.ownerDocument || this
                  , e = W.access(d, b) - 1;
                e ? W.access(d, b, e) : (d.removeEventListener(a, c, !0),
                W.remove(d, b))
            }
        }
    });
    var tb = a.location
      , ub = r.now()
      , vb = /\?/;
    r.parseXML = function(b) {
        var c;
        if (!b || "string" != typeof b)
            return null;
        try {
            c = (new a.DOMParser).parseFromString(b, "text/xml")
        } catch (d) {
            c = void 0
        }
        return c && !c.getElementsByTagName("parsererror").length || r.error("Invalid XML: " + b),
        c
    }
    ;
    var wb = /\[\]$/
      , xb = /\r?\n/g
      , yb = /^(?:submit|button|image|reset|file)$/i
      , zb = /^(?:input|select|textarea|keygen)/i;
    function Ab(a, b, c, d) {
        var e;
        if (Array.isArray(b))
            r.each(b, function(b, e) {
                c || wb.test(a) ? d(a, e) : Ab(a + "[" + ("object" == typeof e && null != e ? b : "") + "]", e, c, d)
            });
        else if (c || "object" !== r.type(b))
            d(a, b);
        else
            for (e in b)
                Ab(a + "[" + e + "]", b[e], c, d)
    }
    r.param = function(a, b) {
        var c, d = [], e = function(a, b) {
            var c = r.isFunction(b) ? b() : b;
            d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(null == c ? "" : c)
        };
        if (Array.isArray(a) || a.jquery && !r.isPlainObject(a))
            r.each(a, function() {
                e(this.name, this.value)
            });
        else
            for (c in a)
                Ab(c, a[c], b, e);
        return d.join("&")
    }
    ,
    r.fn.extend({
        serialize: function() {
            return r.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var a = r.prop(this, "elements");
                return a ? r.makeArray(a) : this
            }).filter(function() {
                var a = this.type;
                return this.name && !r(this).is(":disabled") && zb.test(this.nodeName) && !yb.test(a) && (this.checked || !ja.test(a))
            }).map(function(a, b) {
                var c = r(this).val();
                return null == c ? null : Array.isArray(c) ? r.map(c, function(a) {
                    return {
                        name: b.name,
                        value: a.replace(xb, "\r\n")
                    }
                }) : {
                    name: b.name,
                    value: c.replace(xb, "\r\n")
                }
            }).get()
        }
    });
    var Bb = /%20/g
      , Cb = /#.*$/
      , Db = /([?&])_=[^&]*/
      , Eb = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Fb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , Gb = /^(?:GET|HEAD)$/
      , Hb = /^\/\//
      , Ib = {}
      , Jb = {}
      , Kb = "*/".concat("*")
      , Lb = d.createElement("a");
    Lb.href = tb.href;
    function Mb(a) {
        return function(b, c) {
            "string" != typeof b && (c = b,
            b = "*");
            var d, e = 0, f = b.toLowerCase().match(L) || [];
            if (r.isFunction(c))
                while (d = f[e++])
                    "+" === d[0] ? (d = d.slice(1) || "*",
                    (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
        }
    }
    function Nb(a, b, c, d) {
        var e = {}
          , f = a === Jb;
        function g(h) {
            var i;
            return e[h] = !0,
            r.each(a[h] || [], function(a, h) {
                var j = h(b, c, d);
                return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j),
                g(j),
                !1)
            }),
            i
        }
        return g(b.dataTypes[0]) || !e["*"] && g("*")
    }
    function Ob(a, b) {
        var c, d, e = r.ajaxSettings.flatOptions || {};
        for (c in b)
            void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
        return d && r.extend(!0, a, d),
        a
    }
    function Pb(a, b, c) {
        var d, e, f, g, h = a.contents, i = a.dataTypes;
        while ("*" === i[0])
            i.shift(),
            void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
        if (d)
            for (e in h)
                if (h[e] && h[e].test(d)) {
                    i.unshift(e);
                    break
                }
        if (i[0]in c)
            f = i[0];
        else {
            for (e in c) {
                if (!i[0] || a.converters[e + " " + i[0]]) {
                    f = e;
                    break
                }
                g || (g = e)
            }
            f = f || g
        }
        if (f)
            return f !== i[0] && i.unshift(f),
            c[f]
    }
    function Qb(a, b, c, d) {
        var e, f, g, h, i, j = {}, k = a.dataTypes.slice();
        if (k[1])
            for (g in a.converters)
                j[g.toLowerCase()] = a.converters[g];
        f = k.shift();
        while (f)
            if (a.responseFields[f] && (c[a.responseFields[f]] = b),
            !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
            i = f,
            f = k.shift())
                if ("*" === f)
                    f = i;
                else if ("*" !== i && i !== f) {
                    if (g = j[i + " " + f] || j["* " + f],
                    !g)
                        for (e in j)
                            if (h = e.split(" "),
                            h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
                                g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0],
                                k.unshift(h[1]));
                                break
                            }
                    if (g !== !0)
                        if (g && a["throws"])
                            b = g(b);
                        else
                            try {
                                b = g(b)
                            } catch (l) {
                                return {
                                    state: "parsererror",
                                    error: g ? l : "No conversion from " + i + " to " + f
                                }
                            }
                }
        return {
            state: "success",
            data: b
        }
    }
    r.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: tb.href,
            type: "GET",
            isLocal: Fb.test(tb.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Kb,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": r.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(a, b) {
            return b ? Ob(Ob(a, r.ajaxSettings), b) : Ob(r.ajaxSettings, a)
        },
        ajaxPrefilter: Mb(Ib),
        ajaxTransport: Mb(Jb),
        ajax: function(b, c) {
            "object" == typeof b && (c = b,
            b = void 0),
            c = c || {};
            var e, f, g, h, i, j, k, l, m, n, o = r.ajaxSetup({}, c), p = o.context || o, q = o.context && (p.nodeType || p.jquery) ? r(p) : r.event, s = r.Deferred(), t = r.Callbacks("once memory"), u = o.statusCode || {}, v = {}, w = {}, x = "canceled", y = {
                readyState: 0,
                getResponseHeader: function(a) {
                    var b;
                    if (k) {
                        if (!h) {
                            h = {};
                            while (b = Eb.exec(g))
                                h[b[1].toLowerCase()] = b[2]
                        }
                        b = h[a.toLowerCase()]
                    }
                    return null == b ? null : b
                },
                getAllResponseHeaders: function() {
                    return k ? g : null
                },
                setRequestHeader: function(a, b) {
                    return null == k && (a = w[a.toLowerCase()] = w[a.toLowerCase()] || a,
                    v[a] = b),
                    this
                },
                overrideMimeType: function(a) {
                    return null == k && (o.mimeType = a),
                    this
                },
                statusCode: function(a) {
                    var b;
                    if (a)
                        if (k)
                            y.always(a[y.status]);
                        else
                            for (b in a)
                                u[b] = [u[b], a[b]];
                    return this
                },
                abort: function(a) {
                    var b = a || x;
                    return e && e.abort(b),
                    A(0, b),
                    this
                }
            };
            if (s.promise(y),
            o.url = ((b || o.url || tb.href) + "").replace(Hb, tb.protocol + "//"),
            o.type = c.method || c.type || o.method || o.type,
            o.dataTypes = (o.dataType || "*").toLowerCase().match(L) || [""],
            null == o.crossDomain) {
                j = d.createElement("a");
                try {
                    j.href = o.url,
                    j.href = j.href,
                    o.crossDomain = Lb.protocol + "//" + Lb.host != j.protocol + "//" + j.host
                } catch (z) {
                    o.crossDomain = !0
                }
            }
            if (o.data && o.processData && "string" != typeof o.data && (o.data = r.param(o.data, o.traditional)),
            Nb(Ib, o, c, y),
            k)
                return y;
            l = r.event && o.global,
            l && 0 === r.active++ && r.event.trigger("ajaxStart"),
            o.type = o.type.toUpperCase(),
            o.hasContent = !Gb.test(o.type),
            f = o.url.replace(Cb, ""),
            o.hasContent ? o.data && o.processData && 0 === (o.contentType || "").indexOf("application/x-www-form-urlencoded") && (o.data = o.data.replace(Bb, "+")) : (n = o.url.slice(f.length),
            o.data && (f += (vb.test(f) ? "&" : "?") + o.data,
            delete o.data),
            o.cache === !1 && (f = f.replace(Db, "$1"),
            n = (vb.test(f) ? "&" : "?") + "_=" + ub++ + n),
            o.url = f + n),
            o.ifModified && (r.lastModified[f] && y.setRequestHeader("If-Modified-Since", r.lastModified[f]),
            r.etag[f] && y.setRequestHeader("If-None-Match", r.etag[f])),
            (o.data && o.hasContent && o.contentType !== !1 || c.contentType) && y.setRequestHeader("Content-Type", o.contentType),
            y.setRequestHeader("Accept", o.dataTypes[0] && o.accepts[o.dataTypes[0]] ? o.accepts[o.dataTypes[0]] + ("*" !== o.dataTypes[0] ? ", " + Kb + "; q=0.01" : "") : o.accepts["*"]);
            for (m in o.headers)
                y.setRequestHeader(m, o.headers[m]);
            if (o.beforeSend && (o.beforeSend.call(p, y, o) === !1 || k))
                return y.abort();
            if (x = "abort",
            t.add(o.complete),
            y.done(o.success),
            y.fail(o.error),
            e = Nb(Jb, o, c, y)) {
                if (y.readyState = 1,
                l && q.trigger("ajaxSend", [y, o]),
                k)
                    return y;
                o.async && o.timeout > 0 && (i = a.setTimeout(function() {
                    y.abort("timeout")
                }, o.timeout));
                try {
                    k = !1,
                    e.send(v, A)
                } catch (z) {
                    if (k)
                        throw z;
                    A(-1, z)
                }
            } else
                A(-1, "No Transport");
            function A(b, c, d, h) {
                var j, m, n, v, w, x = c;
                k || (k = !0,
                i && a.clearTimeout(i),
                e = void 0,
                g = h || "",
                y.readyState = b > 0 ? 4 : 0,
                j = b >= 200 && b < 300 || 304 === b,
                d && (v = Pb(o, y, d)),
                v = Qb(o, v, y, j),
                j ? (o.ifModified && (w = y.getResponseHeader("Last-Modified"),
                w && (r.lastModified[f] = w),
                w = y.getResponseHeader("etag"),
                w && (r.etag[f] = w)),
                204 === b || "HEAD" === o.type ? x = "nocontent" : 304 === b ? x = "notmodified" : (x = v.state,
                m = v.data,
                n = v.error,
                j = !n)) : (n = x,
                !b && x || (x = "error",
                b < 0 && (b = 0))),
                y.status = b,
                y.statusText = (c || x) + "",
                j ? s.resolveWith(p, [m, x, y]) : s.rejectWith(p, [y, x, n]),
                y.statusCode(u),
                u = void 0,
                l && q.trigger(j ? "ajaxSuccess" : "ajaxError", [y, o, j ? m : n]),
                t.fireWith(p, [y, x]),
                l && (q.trigger("ajaxComplete", [y, o]),
                --r.active || r.event.trigger("ajaxStop")))
            }
            return y
        },
        getJSON: function(a, b, c) {
            return r.get(a, b, c, "json")
        },
        getScript: function(a, b) {
            return r.get(a, void 0, b, "script")
        }
    }),
    r.each(["get", "post"], function(a, b) {
        r[b] = function(a, c, d, e) {
            return r.isFunction(c) && (e = e || d,
            d = c,
            c = void 0),
            r.ajax(r.extend({
                url: a,
                type: b,
                dataType: e,
                data: c,
                success: d
            }, r.isPlainObject(a) && a))
        }
    }),
    r._evalUrl = function(a) {
        return r.ajax({
            url: a,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            "throws": !0
        })
    }
    ,
    r.fn.extend({
        wrapAll: function(a) {
            var b;
            return this[0] && (r.isFunction(a) && (a = a.call(this[0])),
            b = r(a, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && b.insertBefore(this[0]),
            b.map(function() {
                var a = this;
                while (a.firstElementChild)
                    a = a.firstElementChild;
                return a
            }).append(this)),
            this
        },
        wrapInner: function(a) {
            return r.isFunction(a) ? this.each(function(b) {
                r(this).wrapInner(a.call(this, b))
            }) : this.each(function() {
                var b = r(this)
                  , c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a)
            })
        },
        wrap: function(a) {
            var b = r.isFunction(a);
            return this.each(function(c) {
                r(this).wrapAll(b ? a.call(this, c) : a)
            })
        },
        unwrap: function(a) {
            return this.parent(a).not("body").each(function() {
                r(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    r.expr.pseudos.hidden = function(a) {
        return !r.expr.pseudos.visible(a)
    }
    ,
    r.expr.pseudos.visible = function(a) {
        return !!(a.offsetWidth || a.offsetHeight || a.getClientRects().length)
    }
    ,
    r.ajaxSettings.xhr = function() {
        try {
            return new a.XMLHttpRequest
        } catch (b) {}
    }
    ;
    var Rb = {
        0: 200,
        1223: 204
    }
      , Sb = r.ajaxSettings.xhr();
    o.cors = !!Sb && "withCredentials"in Sb,
    o.ajax = Sb = !!Sb,
    r.ajaxTransport(function(b) {
        var c, d;
        if (o.cors || Sb && !b.crossDomain)
            return {
                send: function(e, f) {
                    var g, h = b.xhr();
                    if (h.open(b.type, b.url, b.async, b.username, b.password),
                    b.xhrFields)
                        for (g in b.xhrFields)
                            h[g] = b.xhrFields[g];
                    b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType),
                    b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");
                    for (g in e)
                        h.setRequestHeader(g, e[g]);
                    c = function(a) {
                        return function() {
                            c && (c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null,
                            "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Rb[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? {
                                binary: h.response
                            } : {
                                text: h.responseText
                            }, h.getAllResponseHeaders()))
                        }
                    }
                    ,
                    h.onload = c(),
                    d = h.onerror = c("error"),
                    void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function() {
                        4 === h.readyState && a.setTimeout(function() {
                            c && d()
                        })
                    }
                    ,
                    c = c("abort");
                    try {
                        h.send(b.hasContent && b.data || null)
                    } catch (i) {
                        if (c)
                            throw i
                    }
                },
                abort: function() {
                    c && c()
                }
            }
    }),
    r.ajaxPrefilter(function(a) {
        a.crossDomain && (a.contents.script = !1)
    }),
    r.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(a) {
                return r.globalEval(a),
                a
            }
        }
    }),
    r.ajaxPrefilter("script", function(a) {
        void 0 === a.cache && (a.cache = !1),
        a.crossDomain && (a.type = "GET")
    }),
    r.ajaxTransport("script", function(a) {
        if (a.crossDomain) {
            var b, c;
            return {
                send: function(e, f) {
                    b = r("<script>").prop({
                        charset: a.scriptCharset,
                        src: a.url
                    }).on("load error", c = function(a) {
                        b.remove(),
                        c = null,
                        a && f("error" === a.type ? 404 : 200, a.type)
                    }
                    ),
                    d.head.appendChild(b[0])
                },
                abort: function() {
                    c && c()
                }
            }
        }
    });
    var Tb = []
      , Ub = /(=)\?(?=&|$)|\?\?/;
    r.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var a = Tb.pop() || r.expando + "_" + ub++;
            return this[a] = !0,
            a
        }
    }),
    r.ajaxPrefilter("json jsonp", function(b, c, d) {
        var e, f, g, h = b.jsonp !== !1 && (Ub.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && Ub.test(b.data) && "data");
        if (h || "jsonp" === b.dataTypes[0])
            return e = b.jsonpCallback = r.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback,
            h ? b[h] = b[h].replace(Ub, "$1" + e) : b.jsonp !== !1 && (b.url += (vb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e),
            b.converters["script json"] = function() {
                return g || r.error(e + " was not called"),
                g[0]
            }
            ,
            b.dataTypes[0] = "json",
            f = a[e],
            a[e] = function() {
                g = arguments
            }
            ,
            d.always(function() {
                void 0 === f ? r(a).removeProp(e) : a[e] = f,
                b[e] && (b.jsonpCallback = c.jsonpCallback,
                Tb.push(e)),
                g && r.isFunction(f) && f(g[0]),
                g = f = void 0
            }),
            "script"
    }),
    o.createHTMLDocument = function() {
        var a = d.implementation.createHTMLDocument("").body;
        return a.innerHTML = "<form></form><form></form>",
        2 === a.childNodes.length
    }(),
    r.parseHTML = function(a, b, c) {
        if ("string" != typeof a)
            return [];
        "boolean" == typeof b && (c = b,
        b = !1);
        var e, f, g;
        return b || (o.createHTMLDocument ? (b = d.implementation.createHTMLDocument(""),
        e = b.createElement("base"),
        e.href = d.location.href,
        b.head.appendChild(e)) : b = d),
        f = C.exec(a),
        g = !c && [],
        f ? [b.createElement(f[1])] : (f = qa([a], b, g),
        g && g.length && r(g).remove(),
        r.merge([], f.childNodes))
    }
    ,
    r.fn.load = function(a, b, c) {
        var d, e, f, g = this, h = a.indexOf(" ");
        return h > -1 && (d = pb(a.slice(h)),
        a = a.slice(0, h)),
        r.isFunction(b) ? (c = b,
        b = void 0) : b && "object" == typeof b && (e = "POST"),
        g.length > 0 && r.ajax({
            url: a,
            type: e || "GET",
            dataType: "html",
            data: b
        }).done(function(a) {
            f = arguments,
            g.html(d ? r("<div>").append(r.parseHTML(a)).find(d) : a)
        }).always(c && function(a, b) {
            g.each(function() {
                c.apply(this, f || [a.responseText, b, a])
            })
        }
        ),
        this
    }
    ,
    r.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(a, b) {
        r.fn[b] = function(a) {
            return this.on(b, a)
        }
    }),
    r.expr.pseudos.animated = function(a) {
        return r.grep(r.timers, function(b) {
            return a === b.elem
        }).length
    }
    ,
    r.offset = {
        setOffset: function(a, b, c) {
            var d, e, f, g, h, i, j, k = r.css(a, "position"), l = r(a), m = {};
            "static" === k && (a.style.position = "relative"),
            h = l.offset(),
            f = r.css(a, "top"),
            i = r.css(a, "left"),
            j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1,
            j ? (d = l.position(),
            g = d.top,
            e = d.left) : (g = parseFloat(f) || 0,
            e = parseFloat(i) || 0),
            r.isFunction(b) && (b = b.call(a, c, r.extend({}, h))),
            null != b.top && (m.top = b.top - h.top + g),
            null != b.left && (m.left = b.left - h.left + e),
            "using"in b ? b.using.call(a, m) : l.css(m)
        }
    },
    r.fn.extend({
        offset: function(a) {
            if (arguments.length)
                return void 0 === a ? this : this.each(function(b) {
                    r.offset.setOffset(this, a, b)
                });
            var b, c, d, e, f = this[0];
            if (f)
                return f.getClientRects().length ? (d = f.getBoundingClientRect(),
                b = f.ownerDocument,
                c = b.documentElement,
                e = b.defaultView,
                {
                    top: d.top + e.pageYOffset - c.clientTop,
                    left: d.left + e.pageXOffset - c.clientLeft
                }) : {
                    top: 0,
                    left: 0
                }
        },
        position: function() {
            if (this[0]) {
                var a, b, c = this[0], d = {
                    top: 0,
                    left: 0
                };
                return "fixed" === r.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(),
                b = this.offset(),
                B(a[0], "html") || (d = a.offset()),
                d = {
                    top: d.top + r.css(a[0], "borderTopWidth", !0),
                    left: d.left + r.css(a[0], "borderLeftWidth", !0)
                }),
                {
                    top: b.top - d.top - r.css(c, "marginTop", !0),
                    left: b.left - d.left - r.css(c, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                var a = this.offsetParent;
                while (a && "static" === r.css(a, "position"))
                    a = a.offsetParent;
                return a || ra
            })
        }
    }),
    r.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(a, b) {
        var c = "pageYOffset" === b;
        r.fn[a] = function(d) {
            return T(this, function(a, d, e) {
                var f;
                return r.isWindow(a) ? f = a : 9 === a.nodeType && (f = a.defaultView),
                void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e)
            }, a, d, arguments.length)
        }
    }),
    r.each(["top", "left"], function(a, b) {
        r.cssHooks[b] = Pa(o.pixelPosition, function(a, c) {
            if (c)
                return c = Oa(a, b),
                Ma.test(c) ? r(a).position()[b] + "px" : c
        })
    }),
    r.each({
        Height: "height",
        Width: "width"
    }, function(a, b) {
        r.each({
            padding: "inner" + a,
            content: b,
            "": "outer" + a
        }, function(c, d) {
            r.fn[d] = function(e, f) {
                var g = arguments.length && (c || "boolean" != typeof e)
                  , h = c || (e === !0 || f === !0 ? "margin" : "border");
                return T(this, function(b, c, e) {
                    var f;
                    return r.isWindow(b) ? 0 === d.indexOf("outer") ? b["inner" + a] : b.document.documentElement["client" + a] : 9 === b.nodeType ? (f = b.documentElement,
                    Math.max(b.body["scroll" + a], f["scroll" + a], b.body["offset" + a], f["offset" + a], f["client" + a])) : void 0 === e ? r.css(b, c, h) : r.style(b, c, e, h)
                }, b, g ? e : void 0, g)
            }
        })
    }),
    r.fn.extend({
        bind: function(a, b, c) {
            return this.on(a, null, b, c)
        },
        unbind: function(a, b) {
            return this.off(a, null, b)
        },
        delegate: function(a, b, c, d) {
            return this.on(b, a, c, d)
        },
        undelegate: function(a, b, c) {
            return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c)
        }
    }),
    r.holdReady = function(a) {
        a ? r.readyWait++ : r.ready(!0)
    }
    ,
    r.isArray = Array.isArray,
    r.parseJSON = JSON.parse,
    r.nodeName = B,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return r
    });
    var Vb = a.jQuery
      , Wb = a.$;
    return r.noConflict = function(b) {
        return a.$ === r && (a.$ = Wb),
        b && a.jQuery === r && (a.jQuery = Vb),
        r
    }
    ,
    b || (a.jQuery = a.$ = r),
    r
});

/*============================================================================
  Global - header
==============================================================================*/

var header = {
    init: function() {

        //remove duplicate header on update
        if ($('.mobile-header').length > 1) {
            var nav_menu = $("#nav").data("mmenu");
            nav_menu.close();
            $('.mobile-header:last, #nav:last').remove();
        }

        var $header = $(".header");
        if ($header.hasClass('header_bar') && $header.data("dropdown-position") == "below_header") {
            $('.dropdown').css({
                "top": $('.header').height()
            });
        } else {
            $('.dropdown').css({
                "top": "auto"
            });
        }

        // Only applied when there is a full-width banner across top of page
        var $header = $(".feature_image .header.header-background--false");

        $(window).on("load", function() {

            if ($header.hasClass('sticky-header--true')) {

                $(".index-sections .shopify-section:nth-child(2), .shopify-section:nth-child(2), .main-wrapper, .page-details-block:nth-child(2)").waypoint(function(direction) {

                    if (direction == 'down') {
                        $header.addClass('sticky--active');
                        $header.addClass('fadeInDown');
                        $header.addClass('delay-0s');
                        $header.removeClass('is-absolute');
                        $header.addClass('header_bar');
                        if ($header.hasClass('header_bar') && $header.data("dropdown-position") == "below_header") {
                            $('.dropdown').css({
                                "top": $('.header').height()
                            });
                        } else {
                            $('.dropdown').css({
                                "top": "auto"
                            });
                        }
                    } else if (direction == 'up') {
                        $header.removeClass('sticky--active');
                        $header.removeClass('fadeInDown');
                        $header.removeClass('delay-0s');
                        $header.addClass('is-absolute');
                        $header.removeClass('header_bar');
                        if ($header.hasClass('header_bar') && $header.data("dropdown-position") == "below_header") {
                            $('.dropdown').css({
                                "top": $('.header').height()
                            });
                        } else {
                            $('.dropdown').css({
                                "top": "auto"
                            });
                        }
                    }
                });
            }
        });

        $header.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
            $(this).removeClass('fadeIn');
        });

        $('#cart').mmenu({
            navbar: {
                add: false
            },
            offCanvas: {
                zposition: 'front',
                position: 'right',
                pageSelector: "#content_wrapper"
            },
            "extensions": ["theme-black"]
        });
        $('.cart-button, .icon-menu').on("click", function(e) {
            $('#search').hide();
        });

        $('#nav').mmenu({
            "navbar": {
                add: true,
                title: $('.mobile_logo').html()
            },
            navbars: [{
                "position": "bottom",
                "content": [$(".js-social-icons").html()]
            }],
            searchfield: {
                add: $('#header').data('search-enabled'),
                search: false,
                position: "top",
                placeholder: "Search"
            },
            "extensions": ["theme-black"],
            offCanvas: {
                pageSelector: "#content_wrapper"
            }
        }, {
            searchfield: {
                "form": {
                    "action": "/search"
                },
                "input": {
                    "name": "q"
                }
            }
        });

        $('#nav .mm-search').append('<input type="hidden" name="type" value="product" />');

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 768) {
            $(document).on('click', 'li.sub-menu > a', function(e) {
                e.preventDefault();
                return false;
            });
        }

        $('body').on('mouseover', '.sub-menu', function() {
            $(this).attr('aria-expanded', true);
        });
        $('body').on('mouseout', '.sub-menu', function() {
            $(this).attr('aria-expanded', false);
        });
    },
    unload: function($target) {
    }
}

/*============================================================================
  Home page - featured promotions
==============================================================================*/

var featured_promotions = {
    init: function() {
        animate_content.init();
    },
    unload: function($target) {}
}

/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
    twitter: function() {
        if (window.twttr) {
            window.twttr.ready(function(twttr) {
                twttr.widgets.load();
            });
        }
    },
    unload: function() {
    }
}

/*============================================================================
  Home page - slideshow
==============================================================================*/

var slideshow = {
    init: function() {
        $('.homepage_slider').each(function(index, value) {
            var homepageSlider = $(this);
            var slideshowAnimation = homepageSlider.data('slideshow-animation');
            var slideshowSpeed = homepageSlider.data('slideshow-speed');

            homepageSlider.flexslider({
                touch: true,
                controlNav: true,
                animation: slideshowAnimation,
                slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
                start: function() {
                    $('.homepage_slider').removeClass('slider-loading')
                }
            });

            if ($('.slides li', homepageSlider).length == 1) {
                $('.flex-direction-nav', homepageSlider).hide()
            }
        });

    },
    unload: function($target) {
        var slider = $target.find('.homepage_slider');
        destroySlider(slider);
    }
}

/*============================================================================
  Home page - video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function() {
    return !!document.createElement('video').canPlayType;
}

var homepageVideo = {
    unload: function($target) {
        $target.find('[data-play-video]').off('click');
    },
    getVideoDetails: function(settings) {
        var videoDetails = {
            id: settings.header.attr('data-video-src'),
            aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
            provider: settings.header.attr('data-provider').toLowerCase(),
            videoMP4: settings.header.attr('data-video-mp4'),
            videoOGV: settings.header.attr('data-video-ogv')
        }
        return videoDetails;
    },
    createFrame: function(settings, videoDetails) {

        if (videoDetails.provider === 'youtube') {
            if (settings.autoloop) {
                var autoloop = '1&iv_load_policy=3&playlist=' + videoDetails.id;
            } else {
                var autoloop = 0;
            }

            var html = '<iframe src="//www.youtube.com/embed/' + videoDetails.id + '?&autoplay=1&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
        } else if (videoDetails.provider === 'vimeo') {
            if (settings.autoloop) {
                var autoloop = 1;
            } else {
                var autoloop = 0;
            }
            var html = '<iframe src="//player.vimeo.com/video/' + videoDetails.id + '?loop=' + autoloop + '&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
        } else if (videoDetails.provider === 'html5') {
            if (settings.autoloop) {
                var autoloop = 'loop="loop"';
            }

            var html = '<video autoplay="true" ' + autoloop + ' id="video" onclick="this.paused?this.play():this.pause();"><source src="' + videoDetails.videoMP4 + '" type="video/mp4"><source src="' + videoDetails.videoOGV + '" type="video/ogg" ></video>';
        }
        return html;
    },
    appendFrame: function(settings, videoDetails) {
        var addVideo = function() {

            settings.container.find('iframe').remove();
            settings.container.find('video').remove();
            settings.container.append(homepageVideo.createFrame(settings, videoDetails));
            settings.container.addClass('video-added');

            if (videoDetails.provider != 'html5' && settings.container.find('.mediaWrapper').length < 1) {

                var paddingBottomValue = videoDetails.aspectRatio[1] / videoDetails.aspectRatio[0] * 100 + '%';

                settings.container.find('iframe').mediaWrapper({
                    intrinsic: false,
                    baseWidth: videoDetails.aspectRatio[0],
                    baseHeight: videoDetails.aspectRatio[1]
                });

                settings.container.find('.hsContainer__image').css({
                    paddingBottom: paddingBottomValue
                });

            } else if (settings.container.find('#video').length < 1) {
                settings.container.find('video')[0].play();
            }
        }

        if (!homepageVideo.isMobile()) {
            settings.videoTrigger.removeAttr('data-play-video');
            addVideo();
            var mediaWrapper = settings.container.find('.mediaWrapper');
            settings.posterImage.addClass('fadeOut animated');
            settings.container.parents('.bcg').css('background', 'none');

            if (settings.bannerVideoText) {
                settings.videoText.addClass('text-on-video');
            } else {
                settings.videoText.hide();
            }

            settings.header.next().fadeIn('slow');
            if (videoDetails.provider != 'html5') {
                mediaWrapper.find('iframe').show();
                settings.container.find('.hsContainer__image').hide();
            } else {
                settings.header.next().show();
                settings.container.find('.homepage-video__placeholder').hide();
                settings.container.find('.hsContainer__image').hide();
            }
        }
    },
    isMobile: function() {
        return false;
        //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
            return true;
    }
}

var videoTheme = {
    init: function() {

        //Check for videos that are set to autoplay
        $('.homepage-video').each(function(index, value) {
            if ($('.homepage-video').length && supports_video()) {

                var $videoElement = $(this);
                var settings = {
                    container: $videoElement.find('.hsContainer'),
                    header: $videoElement.find('.homepage-video--media'),
                    uploadedPoster: $videoElement.data('uploadedPoster'),
                    posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
                    videoText: $videoElement.find('.homepage-video--media .caption'),
                    videoTrigger: $videoElement.find("[data-play-video]"),
                    autoPlayVideo: $videoElement.data('autoplay'),
                    bannerVideoText: $videoElement.data('video-text'),
                    autoloop: $videoElement.data('autoloop')
                }
                var videoDetails = homepageVideo.getVideoDetails(settings);

                if (settings.autoPlayVideo && !homepageVideo.isMobile()) {
                    homepageVideo.appendFrame(settings, videoDetails);
                }

            }
        });

        //Attach event listener for videos
        $(document).on('click', '[data-play-video]', function(e) {
            var $videoElement = $(this).parents('.homepage-video');
            var settings = {
                container: $videoElement.find('.hsContainer'),
                header: $videoElement.find('.homepage-video--media'),
                posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
                videoText: $videoElement.find('.homepage-video--media .caption'),
                videoTrigger: $videoElement.find("[data-play-video]"),
                autoPlayVideo: $videoElement.data('autoplay'),
                bannerVideoText: $videoElement.data('video-text'),
                autoloop: $videoElement.data('autoloop')
            }
            var videoDetails = homepageVideo.getVideoDetails(settings);

            homepageVideo.appendFrame(settings, videoDetails);
        });
    }
}

/*============================================================================
  Banner image
==============================================================================*/

var banner_image = {
    init: function() {

        if ($(window).width() >= 768) {

            if ($('body').hasClass('index') || $('.shopify-section.page-details-section').length) {

                var $reorderableFirstSection = $('.index-sections .shopify-section, .page-details-section .page-details-block').first();

                $reorderableFirstSection.attr('style', '');

                if ($reorderableFirstSection.find('.parallax-banner').length) {
                    //('has banner');
                    if ($('.header').hasClass('header-background--true') && $('.header').hasClass('header-transparency--false')) {

                        $reorderableFirstSection.css('padding-top', $('.header').height());
                        $('.header').parent().removeClass('feature_image');
                        $('.header').addClass('header_bar');

                        if ($('.header').hasClass('sticky-header--false')) {
                            $('.header').addClass('is-absolute');
                        } else {
                            $('.header.is-absolute').removeClass('is-absolute');
                        }

                    } else if ($('.header').hasClass('header-background--false') && $('.header').hasClass('header-transparency--true')) {

                        $('.header').parent().addClass('feature_image');
                        $('.header').removeClass('header_bar');
                        $('.header').addClass('is-absolute');

                        if ($('.header').hasClass('sticky-header--true')) {
                            $('.header').addClass('is-absolute');
                        }

                    } else if ($('.header').hasClass('header-background--false') && $('.header').hasClass('header-transparency--false')) {

                        $('.header').parent().addClass('feature_image');
                        $('.header').removeClass('header_bar');
                        $('.header').addClass('is-absolute');

                        if ($('.header').hasClass('sticky-header--true')) {
                            $('.header').addClass('is-absolute');
                        }

                    } else if ($('.header').hasClass('header-background--true') && $('.header').hasClass('header-transparency--true')) {

                        $('.header').parent().removeClass('feature_image');
                        $('.header').addClass('header_bar');

                        if ($('.header').hasClass('sticky-header--false')) {
                            $('.header').addClass('is-absolute');
                        } else {
                            $('.header.is-absolute').removeClass('is-absolute');
                        }

                    }

                } else {
                    //('no banner')
                    $reorderableFirstSection.css('padding-top', $('.header').height());
                    if ($('.header').hasClass('sticky-header--false')) {
                        $('.header').addClass('header_bar');
                        $('.header').addClass('is-absolute');
                    } else {
                        $('.feature_image').removeClass('feature_image');
                        $('.header').addClass('header_bar');
                        $('.header.is-absolute').removeClass('is-absolute');
                    }
                }
            } else {
                var $staticFirstSection = $('.global-wrapper .shopify-section').first();
                if ($staticFirstSection.children().first().hasClass('parallax-banner')) {
                    //(has banner');
                    if ($('.header').hasClass('header-background--true')) {
                        $('.header').parent().addClass('feature_image');
                        $('.header').addClass('header_bar');
                    } else if ($('.header').hasClass('header-background--false')) {
                        $('.header').parent().addClass('feature_image');
                        $('.header').removeClass('header_bar');
                    }

                    if ($('.header').hasClass('header-transparency--false') && $('.header').hasClass('header-background--true')) {
                        $staticFirstSection.css('padding-top', $('.header').height());
                    }

                } else {
                    //('no banner')
                    if ($('.header').hasClass('sticky-header--false')) {
                        $('.header').addClass('header_bar');
                        $('.header').addClass('is-absolute');
                    } else {
                        $('.feature_image').removeClass('feature_image');
                        $('.header').addClass('header_bar');
                        $('.header.is-absolute').removeClass('is-absolute');
                    }
                }
            }
        }

    },
    unload: function($target) {
    }
}

/*============================================================================
  Banner
==============================================================================*/

var banner = {
    init: function() {
        if ($('.parallax-banner').hasClass('parallax_effect--true')) {
            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 768) {
                skrollr.init({
                    forceHeight: false
                });

                var s = skrollr.init({
                    forceHeight: false
                });
                s.refresh($(".bcg"));
                $(".slideshow-section").waypoint(function() {
                    var evt = document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                }, {
                    offset: '100%'
                });
            } else if ($(window).width() >= 768) {
                $('.parallax-banner').removeClass('parallax_effect--true').addClass('parallax_effect--false');
            }
        }

        //promo banner is enabled
        if ($('.promo_banner').length) {
            $('body').addClass('promo_banner--active');
        } else {
            $('body').removeClass('promo_banner--active');
        }

        animate_content.init();
        $(".scroll-arrow").smoothScroll();
    },
    unload: function($target) {}
}

/*============================================================================
  Product
==============================================================================*/

var product = {
    init: function() {
        var thumbnailPosition = $('.product_slider').parents('.product_section').data('thumbnail');
        var slideshowAnimation = $('.product_slider').parents('.product_section').data('slideshow-animation');
        var slideshowSpeed = $('.product_slider').parents('.product_section').data('slideshow-speed');
        var $notify_form = $('.notify_form .contact-form');

        if (slideshowAnimation == 'zoom') {
            CloudZoom.quickStart();
        }

        $('.product_slider').flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: true,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
            start: function(slider) {
                slider.resize();
            }
        });

        if (slideshowAnimation == 'slide') {
            if ($('.product_slider img').data("index") == 0) {
                $('.product_slider .flex-direction-nav').hide()
            }
        } else {
            if ($('.product_slider img').length == 1) {
                $('.product_slider .flex-direction-nav').hide()
            }
        }

        $('form.product_form.product_form_options.init').each(function() {
            new Shopify.OptionSelectors($(this).data("select-id"),{
                product: $(this).data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: $(this).data("enable-state")
            });
        });

        $notify_form.each(function() {
            var $nf = $(this);
            $nf.on("submit", function(e) {
                if ($('input[name="challenge"]', $nf).val() !== "true") {
                    $.ajax({
                        type: $nf.attr('method'),
                        url: $nf.attr('action'),
                        data: $nf.serialize(),
                        success: function(data) {
                            $nf.fadeOut("slow", function() {
                                $nf.before('<p class="message">' + "Thanks! We will notify you when this product becomes available!" + '</p>');
                            });
                        },
                        error: function(data) {
                            $('input[name="challenge"]', $nf).val('true');
                            $nf.submit();
                        }
                    });
                    e.preventDefault();
                }
            });
        });

        animate_content.init();
    },
    unload: function($target) {
        var slider = $target.find('.product_slider');
        destroySlider(slider);
    }
}

/*============================================================================
  Product form
==============================================================================*/

var productFormListeners = {
    init: function() {

        $(document).on("click", ".minus", function(e) {
            var quantity = parseInt($(this).next("input").val());
            quantity -= 1;
            $(this).next("input").val(quantity);

            if (quantity == 0) {
                $(this).closest('li.cart_item').slideUp();
                setTimeout(ajaxSubmitCart, 500);
            } else {
                $(this).next("input").trigger('change');
            }

            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        $(document).on("click", ".plus", function(e) {
            var quantity = parseInt($(this).prev("input").val());
            quantity += 1;
            $(this).prev("input").val(quantity).trigger('change');

            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        $(document).on("change", "#cart_form input[type='number']", function() {
            $("#cart_form").submit();
        });

        if ($('.tos_agree').length) {
            $('body').on('click', 'input[type="submit"]', function() {
                if ($(this).parents('form').find('.tos_agree').length) {
                    if ($(this).parents('form').find('.tos_agree').is(':checked')) {
                        $(this).submit();
                    } else {
                        alert("You must agree with the terms and conditions to checkout.");
                        return false;
                    }
                } else {
                    $(this).submit();
                }
            });
        }
    },
    unload: function() {
    }
}

/*============================================================================
  Collection
==============================================================================*/

var collection = {
    init: function() {

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $(".quick_shop").remove();
        } else {
            $('.thumbnail').hover(function() {
                $(this).find('.quick_shop').show();
            }, function() {
                $(this).find('.quick_shop').hide();
            });

            var modal_width = '870px';
            if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
                modal_width = '1110px'
            }
            $(".quick_shop").fancybox({
                width: modal_width,
                height: 'auto',
                autoSize: false,
                padding: 10,
                afterShow: function(e) {
                    var $gallery = $('.' + $(this.element).data('gallery'));
                    var selector = $('.fancybox-opened').find('.selector-wrapper select');
                    selector.trigger('change');
                },
                beforeShow: function(e) {
                    var $gallery = $('.' + $(this.element).data('gallery'));
                    var $product = $(this.element).data("fancybox-href");
                    var thumbnailPosition = $gallery.parents('.product_section').data('thumbnail');
                    var slideshowAnimation = $gallery.parents('.product_section').data('slideshow-animation');
                    var slideshowSpeed = $gallery.parents('.product_section').data('slideshow-speed');

                    $gallery.flexslider({
                        startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
                        touch: true,
                        pauseOnHover: true,
                        controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
                        directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
                        animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
                        slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
                        slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
                        start: function(slider) {
                            slider.resize();
                        }
                    });

                    if (slideshowAnimation == 'slide') {
                        if ($gallery.data("index") == 0) {
                            $('.flex-direction-nav', $gallery).hide()
                        }
                    } else {
                        if ($gallery.length == 1) {
                            $('.flex-direction-nav', $gallery).hide()
                        }
                    }
                }
            });
        }

        $('#sort-by').val($('#sort-by').data('default-sort'));

        $('body').on('change', '#tag_filter, #sort-by', function() {
            var sortValue = $('#sort-by').val();
            var filterValue = $('#tag_filter').val();

            Shopify.queryParams.sort_by = sortValue;
            sortUrl = $.param(Shopify.queryParams);

            if (sortValue && filterValue) {
                window.location = filterValue + '?sort_by=' + sortValue;
            } else if (sortValue && !filterValue) {
                window.location = '?' + sortUrl;
            } else if (!sortValue && filterValue) {
                window.location = filterValue;
            }
        });

    },
    showSecondaryImage: function() {
        $('body').on("mouseenter", ".thumbnail", function() {
            $(this).addClass('toggle-images');
        });

        $('body').on("mouseleave", ".thumbnail", function() {
            $(this).removeClass('toggle-images');
        });
    },
    unload: function($target) {
        $target.find('.thumbnail').off('mouseenter mouseleave');
        $('body').off('change', '#tag_filter, #sort-by');
        $target.find('.quick_shop').unbind('click.fb');
    }
}

/*============================================================================
  Article
==============================================================================*/

var article = {
    init: function() {
        banner_image.init();
        banner.init();
        if (window.location.pathname.indexOf('/comments') != -1) {
            $('html,body').animate({
                scrollTop: $("#new-comment").offset().top - 140
            }, 'slow');
        }
    },
    unload: function($target) {}
}

/*============================================================================
  Utilities
==============================================================================*/

var toggleSidebarBlocks = function($toggle) {
    if ($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
        $toggle.attr('aria-expanded', false);
    } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
        $toggle.attr('aria-expanded', true);
    }
}

var toggleSidebarMenus = function($toggle) {
    var $content = $toggle.next('ul');
    $content.slideToggle();
    $toggle.toggleClass('active');
    $toggle.attr('aria-expanded', $toggle.attr('aria-expanded') == 'true' ? 'false' : 'true');
}

var animate_content = {
    init: function() {
        if ($(window).width() >= 768 || $(window).width() == 0) {
            $(".animate_right").waypoint(function() {
                $(this.element).addClass("animated fadeInRight");
            }, {
                offset: '80%'
            });
            $(".animate_left").waypoint(function() {
                $(this.element).addClass("animated fadeInLeft");
            }, {
                offset: '80%'
            });
            $(".animate_up").waypoint(function() {
                $(this.element).addClass("animated fadeInUp");
            }, {
                offset: '80%'
            });
            $(".animate_in").waypoint(function() {
                $(this.element).addClass("animated fadeIn");
            }, {
                offset: '80%'
            });
            $(".animate_down").waypoint(function() {
                $(this.element).addClass("animated fadeInDown");
            }, {
                offset: '80%'
            });
        }
    }
}

var sliderBlock = {
    select: function(blockId, $parentSection) {
        var $blocks = $parentSection.find('li[data-block-id]:not(".clone")');
        var blockIdsArray = $blocks.map(function() {
            return String($(this).data('block-id'));
        });
        var slider = $parentSection.find('.flexslider').data('flexslider');

        slider.pause();

        for (var i = 0; i < blockIdsArray.length; i++) {
            if (blockIdsArray[i] === blockId) {
                var currentSlide = i;
                if (currentSlide !== slider.currentSlide) {
                    slider.flexAnimate(parseInt(currentSlide));
                }
            }
        }
    },
    deselect: function($parentSection) {
        var slider = $parentSection.find('.flexslider').data('flexslider');
        if (slider) {
            slider.play();
        }
    }
}

/*============================================================================
  Cart
==============================================================================*/

var cart = {
    init: function() {
        $("#address_country").val($("#address_country").data("default")).change();
    },
    unload: function() {}
}

/*============================================================================
  Start of cart-related functionality
==============================================================================*/

function ajaxSubmitCart() {
    $cart = $("#cart");
    $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $cart.serialize(),
        success: function(data) {
            refreshCart(data);
        }
    });
}

function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {
            quantity: quantity,
            line: lineID
        },
        success: function(data) {
            refreshCart(data);

            var lineIDIndex = lineID - 1;
            var $input = parent.find("input[data-line-id='" + lineID + "']");

            //check to see if there are correct amount of products in array
            if (typeof data.items[lineIDIndex] === "undefined") {
                var updated_quantity = 0;
            } else {
                var updated_quantity = data.items[lineIDIndex].quantity;
            }

            if (quantity > 0 && quantity != updated_quantity) {
                if (updated_quantity == 1) {
                    items_left_text = "item left";
                } else {
                    items_left_text = "items left";
                }

                $('.warning--quantity').remove();

                var warning = '<div class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</div>';

                $input.parent().next().append(warning);
                $input.val(updated_quantity);
            }
        }
    });
}

function refreshCart(cart) {
    if (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined')
        cart = window.BOLD.common.cartDoctor.fix(cart);

    $cartBtn = $(".cart-button span");
    if ($cartBtn && $cartBtn.length) {
        var value = $cartBtn.text() || '0';
        var cart_items_html = "";
        var $cart = $("#cart ul");

        $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
        $cart.find('li:not(:first)').remove();

        if (cart.item_count == 0) {
            $cart.append('<li class="empty_cart">Your Cart is Empty</li>');
        } else {
            $.each(cart.items, function(index, item) {
                var line_id = index + 1;
                cart_items_html += '<li class="cart_item">' + '<p class="mm-counter">' + '<span class="icon-minus minus"></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '"  data-line-id="' + line_id + '" readonly />' + '<span class="icon-plus plus"></span>' + '</p>' + '<a href="' + item.url + '">';
                if (item.image) {
                    cart_items_html += '<div class="cart_image">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</div>';
                }

                cart_items_html += '<div class="item_info">' + item.title;
                if (item.properties_formatted) {
                    cart_items_html += '<div class="line-item">' + item.properties_formatted + '</div>';
                }
                cart_items_html += '<div class="price"><span class="money">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</span>';
                cart_items_html += '<span class="money-template" data-line-index="' + index + '" style="visibility:hidden;"><del><span class="bold-pre-compare-price"></span></del></span></div></div></a></li>'
            });

            cart_items_html += '<li class="mm-label">' + '<p class="mm-counter price"><span class="money">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span></p>' + '<a href="/cart">' + '<strong>Subtotal</strong>' + '</a>' + '</li>' + '<li class="mm-subtitle clearfix">';

            cart_items_html += '<input type="submit" class="action_button right" value="Checkout" />' + '<a href="/cart" class="action_button edit_cart right">View Cart</a>' + '</li>';

            $cart.append(cart_items_html);
            $cart.find('li.cart_item:last').addClass('last_cart_item');

        }
    }

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    }
}

//Document ready
$(function() {

    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.expand = 2000;
    window.lazySizesConfig.loadMode = 2;

    $("body").on("click", '.continue', function() {

        var cart = $("#cart").data("mmenu");
        cart.close();

        var nav = $("#nav").data("mmenu");
        nav.close();

    });

    //Load Accordions
    var allPanels = $('.accordion > dd').hide();

    $('.accordion > dt > a').click(function() {
        if (!$(this).parent().next().is(':visible')) {
            allPanels.slideUp();
            $('.accordion small.right').html('&#9668;');
            $(this).find('small.right').html('&#9660;');
            $(this).parent().next().slideDown();
        }

        return false;
    });

    $('.accordion dd:first-of-type').show();

    //Load sections
    banner_image.init();
    header.init();
    banner.init();
    slideshow.init();
    videoTheme.init();
    product.init();
    collection.init();
    cart.init();
    productFormListeners.init();
    featured_promotions.init();
    animate_content.init();

    var currentWidth = $(window).width();

    if ($('.parallax-banner').hasClass('parallax_effect--true')) {
        $(window).on('resize', function() {
            if ($(window).width() != currentWidth) {
                currentWidth = $(window).width();
                var s = skrollr.init({
                    forceHeight: false
                });
                if ($(window).width() <= 767 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    s.destroy();
                }
            }
        });
    }

    var $header = $(".feature_image .header");

    $(document).on('click', '.icon-search', function(e) {
        $(this).parent('form').submit();
    });

    $(document).on('click', '#search-toggle, .search-close', function(e) {
        $('.search-close, .search-submit').css('padding-top', $('.header').height() + 50 + 'px');

        if ($('#search').is(":visible") && $(window).scrollTop() == 0) {

            $header.removeClass('header-background--true');

        } else {
            $header.addClass('header-background--true');
        }

        if ($('#search').hasClass("fadeIn")) {
            $('#search').removeClass("fadeIn").hide();
        } else {
            $('#search').show().addClass("fadeIn").find('input').focus();
        }

        e.stopPropagation();
        e.preventDefault();
    })

    if ($('.shopify-section.page-details-section').length) {// Don't apply mediaWrapper
    } else if ($('body').hasClass('index')) {
        $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
            intrinsic: true
        });
    } else {
        $('iframe[src*=youtube], iframe[src*=vimeo]').mediaWrapper({
            intrinsic: true
        });
    }

    $('.slider').flexslider({
        controlNav: false,
        animation: "fade"
    });

    if ($('.product_slider img').length == 1) {
        $('.product_slider .flex-direction-nav').hide();
    }

    $('.lightbox').fancybox();

    $(".fancybox").fancybox({
        padding: 0,
        wrapCSS: 'gallery'
    });

    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    var tabs = $('ul.tabs');
    tabs.each(function(i) {
        var tab = $(this).find('> li > a');
        tab.click(function(e) {
            var contentLocation = $(this).attr('href');
            if (contentLocation.charAt(0) == "#") {
                e.preventDefault();
                tab.removeClass('active');
                $(this).addClass('active');
                $(this).parents('ul.tabs').next().find(contentLocation).show().css({
                    'display': 'block'
                }).addClass('active').siblings().hide().removeClass('active');
            }
        });
    });

    //Sidebar toggle
    $(document).on('click', '.menu-toggle', function(e) {
        toggleSidebarMenus($(this));
    });
    var sidebarTouched = false;
    $(document).on('touchstart', '.toggle', function(e) {
        if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
            var $toggle = $(this);
            toggleSidebarBlocks($toggle);
            sidebarTouched = true;
            e.preventDefault();
            return false;
        }
    });
    $(document).on('click', '.toggle', function(e) {
        if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
            var $toggle = $(this);
            if (!sidebarTouched) {
                toggleSidebarBlocks($toggle);
                e.preventDefault();
                return false;
            }
        }
    });

    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function() {
        var $cf = $(this);
        $cf.on('submit', function(e) {
            if ($('input[name="challenge"]', $cf).val() !== "true") {
                $.ajax({
                    type: $cf.attr('method'),
                    url: $cf.attr('action'),
                    data: $cf.serialize(),
                    success: function(data) {
                        $cf.fadeOut("slow", function() {
                            $cf.before('<p class="message">' + "Thank you for joining our mailing list!" + '</p>');
                        });
                    },
                    error: function(data) {
                        $('input[name="challenge"]', $cf).val('true');
                        $cf.submit();
                    }
                });
                e.preventDefault();
            }
        });
    });

    $('.maps').click(function() {
        $('.maps iframe').css("pointer-events", "auto");
    });

    /*============================================================================
    Home page - social media
  ==============================================================================*/

    //Initialize twitter feed
    window.twttr = (function(d, s, id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id))
            return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = {
            _e: [],
            ready: function(f) {
                t._e.push(f)
            }
        });
    }(document, "script", "twitter-wjs"));

    $('.social-feeds-wrap').each(function(index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: $target,
            clientID: $target.data('client-id'),
            limit: $target.data('count')
        });
    });

    $('body').on("change", "#cart input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart'));
    });

    $('body').on("change", "#cart #cart-note", function() {
        ajaxSubmitCart();
    });

});

selectCallback = function(variant, selector) {
  	var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);
    var variantInventory = $productForm.data('variant-inventory');

    if (variant && variant.featured_image && $product.is(":visible")) {
        var $sliders = $('.product_gallery', $product);
        $sliders.each(function() {
            var $slider = $(this);
            if ($slider.is(":visible")) {
                $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
            }
        });
    }

    if (variant) {
        if (variantInventory) {
            variantInventory.forEach(function(v) {
                if (v.id === variant.id) {
                    variant.inventory_quantity = v.inventory_quantity;
                    variant.inventory_management = v.inventory_management;
                    variant.inventory_policy = v.inventory_policy;
                }
            });
        }

        $('.sku span', $product).text(variant.sku);
        $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

    }

    if (variant && variant.available == true) {

        if (variant.price < variant.compare_at_price) {
            $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
        } else {
            $('.was_price', $product).html('<span class="money-template" data-product-id="' + variant.id + '" style="visibility:hidden;">{{#has_saved}}<del>{{original}}</del>{{/has_saved}}</span>');
        }

        if (variant.inventory_management && variant.inventory_quantity > 0) {
        } else {
            $('.items_left', $product).text('');
            $('.quantity', $product).removeAttr('max');
        }

        $('.sold_out', $product).text('');

        if (variant.price > 0) {
            $('.current_price', $product).html('<span class="money" data-variant-id="' + variant.id + '">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
        } else {
            $('.current_price', $product).html("Free");
        }
        $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
        $notify_form.hide();
    } else {
        var message = variant ? "Sold Out" : "Unavailable";
        $('.was_price', $product).html('');
        $('.current_price', $product).html('');
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
        $('.sold_out', $product).text(message);
        $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
        $notify_form.fadeIn();
    }

    $productForm.removeClass("init");

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed');
    }
}
;

function htmlEncode(value) {
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

/* option_selection.js */
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if ("undefined" == typeof Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var o = 0; o < t.length; o++)
        e(t[o], o)
}
,
Shopify.map = function(t, e) {
    for (var o = [], i = 0; i < t.length; i++)
        o.push(e(t[i], i));
    return o
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var o = 0; o < t.length; o++)
        if (t[o] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], o = 0; o < t.length; o++)
        Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}
,
Shopify.isDefined = function(t) {
    return "undefined" == typeof t ? !1 : !0
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function o() {}
    o.prototype = e.prototype,
    t.prototype = new o,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e,
    o + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, function(e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void (e = o) : void 0
    }),
    e)
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id)
            return o
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function i(t, e, i, r) {
        if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var n = t.split(".")
          , a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i)
          , s = n[1] ? r + n[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
    case "amount":
        r = i(t, 2);
        break;
    case "amount_no_decimals":
        r = i(t, 0);
        break;
    case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}
,
Shopify.OptionSelectors = function(t, e) {  
  	if(typeof e.product !== "object")
      e.product = JSON.parse(e.product);
  
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    }
      , e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function() {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , o = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        o.insertBefore(t, e)
    }),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var o = this.product.getVariantById(t);
    if (null == o)
        return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element
          , n = r.getAttribute("data-option")
          , a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var o = 0; o < t.options.length; o++)
        if (t.options[o].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        o.appendChild(t)
    })
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1,
        this.selectors.push(e)
    }
    var o = this.selectorDivClass
      , i = this.product.optionNames()
      , r = Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", o),
        i.length > 1) {
            var r = document.createElement("label");
            r.htmlFor = t.element.id,
            r.innerHTML = t.name,
            e.appendChild(r)
        }
        return e.appendChild(t.element),
        e
    });
    return r
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var o = this.selectedValues()
      , i = this.product.getVariant(o);
    i ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = i.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(i, this, e),
    null != this.historyState && this.historyState.onVariantChange(i, this, e)
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var o = e.optionNames || []
      , i = e.priceFieldExists || !0
      , r = e.delimiter || "/"
      , n = this.createProductFromSelector(t, o, i, r);
    e.product = n,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, o, i) {
    if (!Shopify.isDefined(o))
        var o = !0;
    if (!Shopify.isDefined(i))
        var i = "/";
    var r = document.getElementById(t)
      , n = r.childNodes
      , a = (r.parentNode,
    e.length)
      , s = [];
    Shopify.each(n, function(t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a)
              , l = o ? n[a] : ""
              , c = (t.getAttribute("value"),
            {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2]
            });
            s.push(c)
        }
    });
    var p = {
        variants: s
    };
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++)
            p.options[l] = "option " + (l + 1)
    } else
        p.options = e;
    return p
}
,
Shopify.SingleOptionSelector = function(t, e, o, i) {
    this.multiSelector = t,
    this.values = i,
    this.index = e,
    this.name = o,
    this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {
        var n = document.createElement("option");
        n.value = i[r],
        n.innerHTML = i[r],
        this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(o, i) {
        i = i || {},
        t.updateSelectors(e, i)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src)
              , r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0])
              , r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;

// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com

!function(t) {
    t.fn.mediaWrapper = function(i) {
        var e = t.extend({
            intrinsic: !0,
            baseWidth: 16,
            baseHeight: 9
        }, i);
        return this.each(function() {
            var i = "";
            i = 1 == e.intrinsic && "" !== t(this).attr("width") && "" !== t(this).attr("height") ? t(this).attr("height") / t(this).attr("width") * 100 : e.baseHeight / e.baseWidth * 100,
            t(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + i + '% 0 0 0; " />').css({
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0"
            })
        })
    }
}(jQuery);

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function(r, G, f, v) {
    var J = f("html")
      , n = f(r)
      , p = f(G)
      , b = f.fancybox = function() {
        b.open.apply(this, arguments)
    }
      , I = navigator.userAgent.match(/msie/i)
      , B = null
      , s = G.createTouch !== v
      , t = function(a) {
        return a && a.hasOwnProperty && a instanceof f
    }
      , q = function(a) {
        return a && "string" === f.type(a)
    }
      , E = function(a) {
        return q(a) && 0 < a.indexOf("%")
    }
      , l = function(a, d) {
        var e = parseInt(a, 10) || 0;
        d && E(a) && (e *= b.getViewport()[d] / 100);
        return Math.ceil(e)
    }
      , w = function(a, b) {
        return l(a, b) + "px"
    };
    f.extend(b, {
        version: "2.1.5",
        defaults: {
            padding: 15,
            margin: 20,
            width: 800,
            height: 600,
            minWidth: 100,
            minHeight: 100,
            maxWidth: 9999,
            maxHeight: 9999,
            pixelRatio: 1,
            autoSize: !0,
            autoHeight: !1,
            autoWidth: !1,
            autoResize: !0,
            autoCenter: !s,
            fitToView: !0,
            aspectRatio: !1,
            topRatio: 0.5,
            leftRatio: 0.5,
            scrolling: "auto",
            wrapCSS: "",
            arrows: !0,
            closeBtn: !0,
            closeClick: !1,
            nextClick: !1,
            mouseWheel: !0,
            autoPlay: !1,
            playSpeed: 3E3,
            preload: 3,
            modal: !1,
            loop: !0,
            ajax: {
                dataType: "html",
                headers: {
                    "X-fancyBox": !0
                }
            },
            iframe: {
                scrolling: "auto",
                preload: !0
            },
            swf: {
                wmode: "transparent",
                allowfullscreen: "true",
                allowscriptaccess: "always"
            },
            keys: {
                next: {
                    13: "left",
                    34: "up",
                    39: "left",
                    40: "up"
                },
                prev: {
                    8: "right",
                    33: "down",
                    37: "right",
                    38: "down"
                },
                close: [27],
                play: [32],
                toggle: [70]
            },
            direction: {
                next: "left",
                prev: "right"
            },
            scrollOutside: !0,
            index: 0,
            type: null,
            href: null,
            content: null,
            title: null,
            tpl: {
                wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                image: '<img class="fancybox-image" src="{href}" alt="" />',
                iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (I ? ' allowtransparency="true"' : "") + "></iframe>",
                error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                closeBtn: '<a title="Close" class="fancybox-item fancybox-close ss-icon" href="javascript:;"></a>',
                next: '<a title="Next" class="fancybox-nav fancybox-next ss-icon" href="javascript:;"><span class="icon-circle-right"></span></a>',
                prev: '<a title="Previous" class="fancybox-nav fancybox-prev ss-icon" href="javascript:;"><span class="icon-circle-left"></span></a>'
            },
            openEffect: "fade",
            openSpeed: 250,
            openEasing: "swing",
            openOpacity: !0,
            openMethod: "zoomIn",
            closeEffect: "fade",
            closeSpeed: 250,
            closeEasing: "swing",
            closeOpacity: !0,
            closeMethod: "zoomOut",
            nextEffect: "elastic",
            nextSpeed: 250,
            nextEasing: "swing",
            nextMethod: "changeIn",
            prevEffect: "elastic",
            prevSpeed: 250,
            prevEasing: "swing",
            prevMethod: "changeOut",
            helpers: {
                overlay: !0,
                title: !0
            },
            onCancel: f.noop,
            beforeLoad: f.noop,
            afterLoad: f.noop,
            beforeShow: f.noop,
            afterShow: f.noop,
            beforeChange: f.noop,
            beforeClose: f.noop,
            afterClose: f.noop
        },
        group: {},
        opts: {},
        previous: null,
        coming: null,
        current: null,
        isActive: !1,
        isOpen: !1,
        isOpened: !1,
        wrap: null,
        skin: null,
        outer: null,
        inner: null,
        player: {
            timer: null,
            isActive: !1
        },
        ajaxLoad: null,
        imgPreload: null,
        transitions: {},
        helpers: {},
        open: function(a, d) {
            if (a && (f.isPlainObject(d) || (d = {}),
            !1 !== b.close(!0)))
                return f.isArray(a) || (a = t(a) ? f(a).get() : [a]),
                f.each(a, function(e, c) {
                    var k = {}, g, h, j, m, l;
                    "object" === f.type(c) && (c.nodeType && (c = f(c)),
                    t(c) ? (k = {
                        href: c.data("fancybox-href") || c.attr("href"),
                        title: c.data("fancybox-title") || c.attr("title"),
                        isDom: !0,
                        element: c
                    },
                    f.metadata && f.extend(!0, k, c.metadata())) : k = c);
                    g = d.href || k.href || (q(c) ? c : null);
                    h = d.title !== v ? d.title : k.title || "";
                    m = (j = d.content || k.content) ? "html" : d.type || k.type;
                    !m && k.isDom && (m = c.data("fancybox-type"),
                    m || (m = (m = c.prop("class").match(/fancybox\.(\w+)/)) ? m[1] : null));
                    q(g) && (m || (b.isImage(g) ? m = "image" : b.isSWF(g) ? m = "swf" : "#" === g.charAt(0) ? m = "inline" : q(c) && (m = "html",
                    j = c)),
                    "ajax" === m && (l = g.split(/\s+/, 2),
                    g = l.shift(),
                    l = l.shift()));
                    j || ("inline" === m ? g ? j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, "") : g) : k.isDom && (j = c) : "html" === m ? j = g : !m && (!g && k.isDom) && (m = "inline",
                    j = c));
                    f.extend(k, {
                        href: g,
                        type: m,
                        content: j,
                        title: h,
                        selector: l
                    });
                    a[e] = k
                }),
                b.opts = f.extend(!0, {}, b.defaults, d),
                d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1),
                b.group = a,
                b._start(b.opts.index)
        },
        cancel: function() {
            var a = b.coming;
            a && !1 !== b.trigger("onCancel") && (b.hideLoading(),
            b.ajaxLoad && b.ajaxLoad.abort(),
            b.ajaxLoad = null,
            b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null),
            a.wrap && a.wrap.stop(!0, !0).trigger("onReset").remove(),
            b.coming = null,
            b.current || b._afterZoomOut(a))
        },
        close: function(a) {
            b.cancel();
            !1 !== b.trigger("beforeClose") && (b.unbindEvents(),
            b.isActive && (!b.isOpen || !0 === a ? (f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),
            b._afterZoomOut()) : (b.isOpen = b.isOpened = !1,
            b.isClosing = !0,
            f(".fancybox-item, .fancybox-nav").remove(),
            b.wrap.stop(!0, !0).removeClass("fancybox-opened"),
            b.transitions[b.current.closeMethod]())))
        },
        play: function(a) {
            var d = function() {
                clearTimeout(b.player.timer)
            }
              , e = function() {
                d();
                b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed))
            }
              , c = function() {
                d();
                p.unbind(".player");
                b.player.isActive = !1;
                b.trigger("onPlayEnd")
            };
            if (!0 === a || !b.player.isActive && !1 !== a) {
                if (b.current && (b.current.loop || b.current.index < b.group.length - 1))
                    b.player.isActive = !0,
                    p.bind({
                        "onCancel.player beforeClose.player": c,
                        "onUpdate.player": e,
                        "beforeLoad.player": d
                    }),
                    e(),
                    b.trigger("onPlayStart")
            } else
                c()
        },
        next: function(a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.next),
            b.jumpto(d.index + 1, a, "next"))
        },
        prev: function(a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.prev),
            b.jumpto(d.index - 1, a, "prev"))
        },
        jumpto: function(a, d, e) {
            var c = b.current;
            c && (a = l(a),
            b.direction = d || c.direction[a >= c.index ? "next" : "prev"],
            b.router = e || "jumpto",
            c.loop && (0 > a && (a = c.group.length + a % c.group.length),
            a %= c.group.length),
            c.group[a] !== v && (b.cancel(),
            b._start(a)))
        },
        reposition: function(a, d) {
            var e = b.current, c = e ? e.wrap : null, k;
            c && (k = b._getPosition(d),
            a && "scroll" === a.type ? (delete k.position,
            c.stop(!0, !0).animate(k, 200)) : (c.css(k),
            e.pos = f.extend({}, e.dim, k)))
        },
        update: function(a) {
            var d = a && a.type
              , e = !d || "orientationchange" === d;
            e && (clearTimeout(B),
            B = null);
            b.isOpen && !B && (B = setTimeout(function() {
                var c = b.current;
                c && !b.isClosing && (b.wrap.removeClass("fancybox-tmp"),
                (e || "load" === d || "resize" === d && c.autoResize) && b._setDimension(),
                "scroll" === d && c.canShrink || b.reposition(a),
                b.trigger("onUpdate"),
                B = null)
            }, e && !s ? 0 : 300))
        },
        toggle: function(a) {
            b.isOpen && (b.current.fitToView = "boolean" === f.type(a) ? a : !b.current.fitToView,
            s && (b.wrap.removeAttr("style").addClass("fancybox-tmp"),
            b.trigger("onUpdate")),
            b.update())
        },
        hideLoading: function() {
            p.unbind(".loading");
            f("#fancybox-loading").remove()
        },
        showLoading: function() {
            var a, d;
            b.hideLoading();
            a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");
            p.bind("keydown.loading", function(a) {
                if (27 === (a.which || a.keyCode))
                    a.preventDefault(),
                    b.cancel()
            });
            b.defaults.fixed || (d = b.getViewport(),
            a.css({
                position: "absolute",
                top: 0.5 * d.h + d.y,
                left: 0.5 * d.w + d.x
            }))
        },
        getViewport: function() {
            var a = b.current && b.current.locked || !1
              , d = {
                x: n.scrollLeft(),
                y: n.scrollTop()
            };
            a ? (d.w = a[0].clientWidth,
            d.h = a[0].clientHeight) : (d.w = s && r.innerWidth ? r.innerWidth : n.width(),
            d.h = s && r.innerHeight ? r.innerHeight : n.height());
            return d
        },
        unbindEvents: function() {
            b.wrap && t(b.wrap) && b.wrap.unbind(".fb");
            p.unbind(".fb");
            n.unbind(".fb")
        },
        bindEvents: function() {
            var a = b.current, d;
            a && (n.bind("orientationchange.fb" + (s ? "" : " resize.fb") + (a.autoCenter && !a.locked ? " scroll.fb" : ""), b.update),
            (d = a.keys) && p.bind("keydown.fb", function(e) {
                var c = e.which || e.keyCode
                  , k = e.target || e.srcElement;
                if (27 === c && b.coming)
                    return !1;
                !e.ctrlKey && (!e.altKey && !e.shiftKey && !e.metaKey && (!k || !k.type && !f(k).is("[contenteditable]"))) && f.each(d, function(d, k) {
                    if (1 < a.group.length && k[c] !== v)
                        return b[d](k[c]),
                        e.preventDefault(),
                        !1;
                    if (-1 < f.inArray(c, k))
                        return b[d](),
                        e.preventDefault(),
                        !1
                })
            }),
            f.fn.mousewheel && a.mouseWheel && b.wrap.bind("mousewheel.fb", function(d, c, k, g) {
                for (var h = f(d.target || null), j = !1; h.length && !j && !h.is(".fancybox-skin") && !h.is(".fancybox-wrap"); )
                    j = h[0] && !(h[0].style.overflow && "hidden" === h[0].style.overflow) && (h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth || h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight),
                    h = f(h).parent();
                if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
                    if (0 < g || 0 < k)
                        b.prev(0 < g ? "down" : "left");
                    else if (0 > g || 0 > k)
                        b.next(0 > g ? "up" : "right");
                    d.preventDefault()
                }
            }))
        },
        trigger: function(a, d) {
            var e, c = d || b.coming || b.current;
            if (c) {
                f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));
                if (!1 === e)
                    return !1;
                c.helpers && f.each(c.helpers, function(d, e) {
                    if (e && b.helpers[d] && f.isFunction(b.helpers[d][a]))
                        b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c)
                });
                p.trigger(a)
            }
        },
        isImage: function(a) {
            return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
        },
        isSWF: function(a) {
            return q(a) && a.match(/\.(swf)((\?|#).*)?$/i)
        },
        _start: function(a) {
            var d = {}, e, c;
            a = l(a);
            e = b.group[a] || null;
            if (!e)
                return !1;
            d = f.extend(!0, {}, b.opts, e);
            e = d.margin;
            c = d.padding;
            "number" === f.type(e) && (d.margin = [e, e, e, e]);
            "number" === f.type(c) && (d.padding = [c, c, c, c]);
            d.modal && f.extend(!0, d, {
                closeBtn: !1,
                closeClick: !1,
                nextClick: !1,
                arrows: !1,
                mouseWheel: !1,
                keys: null,
                helpers: {
                    overlay: {
                        closeClick: !1
                    }
                }
            });
            d.autoSize && (d.autoWidth = d.autoHeight = !0);
            "auto" === d.width && (d.autoWidth = !0);
            "auto" === d.height && (d.autoHeight = !0);
            d.group = b.group;
            d.index = a;
            b.coming = d;
            if (!1 === b.trigger("beforeLoad"))
                b.coming = null;
            else {
                c = d.type;
                e = d.href;
                if (!c)
                    return b.coming = null,
                    b.current && b.router && "jumpto" !== b.router ? (b.current.index = a,
                    b[b.router](b.direction)) : !1;
                b.isActive = !0;
                if ("image" === c || "swf" === c)
                    d.autoHeight = d.autoWidth = !1,
                    d.scrolling = "visible";
                "image" === c && (d.aspectRatio = !0);
                "iframe" === c && s && (d.scrolling = "scroll");
                d.wrap = f(d.tpl.wrap).addClass("fancybox-" + (s ? "mobile" : "desktop") + " fancybox-type-" + c + " fancybox-tmp " + d.wrapCSS).appendTo(d.parent || "body");
                f.extend(d, {
                    skin: f(".fancybox-skin", d.wrap),
                    outer: f(".fancybox-outer", d.wrap),
                    inner: f(".fancybox-inner", d.wrap)
                });
                f.each(["Top", "Right", "Bottom", "Left"], function(a, b) {
                    d.skin.css("padding" + b, w(d.padding[a]))
                });
                b.trigger("onReady");
                if ("inline" === c || "html" === c) {
                    if (!d.content || !d.content.length)
                        return b._error("content")
                } else if (!e)
                    return b._error("href");
                "image" === c ? b._loadImage() : "ajax" === c ? b._loadAjax() : "iframe" === c ? b._loadIframe() : b._afterLoad()
            }
        },
        _error: function(a) {
            f.extend(b.coming, {
                type: "html",
                autoWidth: !0,
                autoHeight: !0,
                minWidth: 0,
                minHeight: 0,
                scrolling: "no",
                hasError: a,
                content: b.coming.tpl.error
            });
            b._afterLoad()
        },
        _loadImage: function() {
            var a = b.imgPreload = new Image;
            a.onload = function() {
                this.onload = this.onerror = null;
                b.coming.width = this.width / b.opts.pixelRatio;
                b.coming.height = this.height / b.opts.pixelRatio;
                b._afterLoad()
            }
            ;
            a.onerror = function() {
                this.onload = this.onerror = null;
                b._error("image")
            }
            ;
            a.src = b.coming.href;
            !0 !== a.complete && b.showLoading()
        },
        _loadAjax: function() {
            var a = b.coming;
            b.showLoading();
            b.ajaxLoad = f.ajax(f.extend({}, a.ajax, {
                url: a.href,
                error: function(a, e) {
                    b.coming && "abort" !== e ? b._error("ajax", a) : b.hideLoading()
                },
                success: function(d, e) {
                    "success" === e && (a.content = d,
                    b._afterLoad())
                }
            }))
        },
        _loadIframe: function() {
            var a = b.coming
              , d = f(a.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", s ? "auto" : a.iframe.scrolling).attr("src", a.href);
            f(a.wrap).bind("onReset", function() {
                try {
                    f(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                } catch (a) {}
            });
            a.iframe.preload && (b.showLoading(),
            d.one("load", function() {
                f(this).data("ready", 1);
                s || f(this).bind("load.fb", b.update);
                f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();
                b._afterLoad()
            }));
            a.content = d.appendTo(a.inner);
            a.iframe.preload || b._afterLoad()
        },
        _preloadImages: function() {
            var a = b.group, d = b.current, e = a.length, c = d.preload ? Math.min(d.preload, e - 1) : 0, f, g;
            for (g = 1; g <= c; g += 1)
                f = a[(d.index + g) % e],
                "image" === f.type && f.href && ((new Image).src = f.href)
        },
        _afterLoad: function() {
            var a = b.coming, d = b.current, e, c, k, g, h;
            b.hideLoading();
            if (a && !1 !== b.isActive)
                if (!1 === b.trigger("afterLoad", a, d))
                    a.wrap.stop(!0).trigger("onReset").remove(),
                    b.coming = null;
                else {
                    d && (b.trigger("beforeChange", d),
                    d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());
                    b.unbindEvents();
                    e = a.content;
                    c = a.type;
                    k = a.scrolling;
                    f.extend(b, {
                        wrap: a.wrap,
                        skin: a.skin,
                        outer: a.outer,
                        inner: a.inner,
                        current: a,
                        previous: d
                    });
                    g = a.href;
                    switch (c) {
                    case "inline":
                    case "ajax":
                    case "html":
                        a.selector ? e = f("<div>").html(e).find(a.selector) : t(e) && (e.data("fancybox-placeholder") || e.data("fancybox-placeholder", f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),
                        e = e.show().detach(),
                        a.wrap.bind("onReset", function() {
                            f(this).find(e).length && e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder", !1)
                        }));
                        break;
                    case "image":
                        e = a.tpl.image.replace("{href}", g);
                        break;
                    case "swf":
                        e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + g + '"></param>',
                        h = "",
                        f.each(a.swf, function(a, b) {
                            e += '<param name="' + a + '" value="' + b + '"></param>';
                            h += " " + a + '="' + b + '"'
                        }),
                        e += '<embed src="' + g + '" type="application/x-shockwave-flash" width="100%" height="100%"' + h + "></embed></object>"
                    }
                    (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);
                    b.trigger("beforeShow");
                    a.inner.css("overflow", "yes" === k ? "scroll" : "no" === k ? "hidden" : k);
                    b._setDimension();
                    b.reposition();
                    b.isOpen = !1;
                    b.coming = null;
                    b.bindEvents();
                    if (b.isOpened) {
                        if (d.prevMethod)
                            b.transitions[d.prevMethod]()
                    } else
                        f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();
                    b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();
                    b._preloadImages()
                }
        },
        _setDimension: function() {
            var a = b.getViewport(), d = 0, e = !1, c = !1, e = b.wrap, k = b.skin, g = b.inner, h = b.current, c = h.width, j = h.height, m = h.minWidth, u = h.minHeight, n = h.maxWidth, p = h.maxHeight, s = h.scrolling, q = h.scrollOutside ? h.scrollbarWidth : 0, x = h.margin, y = l(x[1] + x[3]), r = l(x[0] + x[2]), v, z, t, C, A, F, B, D, H;
            e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");
            x = l(k.outerWidth(!0) - k.width());
            v = l(k.outerHeight(!0) - k.height());
            z = y + x;
            t = r + v;
            C = E(c) ? (a.w - z) * l(c) / 100 : c;
            A = E(j) ? (a.h - t) * l(j) / 100 : j;
            if ("iframe" === h.type) {
                if (H = h.content,
                h.autoHeight && 1 === H.data("ready"))
                    try {
                        H[0].contentWindow.document.location && (g.width(C).height(9999),
                        F = H.contents().find("body"),
                        q && F.css("overflow-x", "hidden"),
                        A = F.outerHeight(!0))
                    } catch (G) {}
            } else if (h.autoWidth || h.autoHeight)
                g.addClass("fancybox-tmp"),
                h.autoWidth || g.width(C),
                h.autoHeight || g.height(A),
                h.autoWidth && (C = g.width()),
                h.autoHeight && (A = g.height()),
                g.removeClass("fancybox-tmp");
            c = l(C);
            j = l(A);
            D = C / A;
            m = l(E(m) ? l(m, "w") - z : m);
            n = l(E(n) ? l(n, "w") - z : n);
            u = l(E(u) ? l(u, "h") - t : u);
            p = l(E(p) ? l(p, "h") - t : p);
            F = n;
            B = p;
            h.fitToView && (n = Math.min(a.w - z, n),
            p = Math.min(a.h - t, p));
            z = a.w - y;
            r = a.h - r;
            h.aspectRatio ? (c > n && (c = n,
            j = l(c / D)),
            j > p && (j = p,
            c = l(j * D)),
            c < m && (c = m,
            j = l(c / D)),
            j < u && (j = u,
            c = l(j * D))) : (c = Math.max(m, Math.min(c, n)),
            h.autoHeight && "iframe" !== h.type && (g.width(c),
            j = g.height()),
            j = Math.max(u, Math.min(j, p)));
            if (h.fitToView)
                if (g.width(c).height(j),
                e.width(c + x),
                a = e.width(),
                y = e.height(),
                h.aspectRatio)
                    for (; (a > z || y > r) && (c > m && j > u) && !(19 < d++); )
                        j = Math.max(u, Math.min(p, j - 10)),
                        c = l(j * D),
                        c < m && (c = m,
                        j = l(c / D)),
                        c > n && (c = n,
                        j = l(c / D)),
                        g.width(c).height(j),
                        e.width(c + x),
                        a = e.width(),
                        y = e.height();
                else
                    c = Math.max(m, Math.min(c, c - (a - z))),
                    j = Math.max(u, Math.min(j, j - (y - r)));
            q && ("auto" === s && j < A && c + x + q < z) && (c += q);
            g.width(c).height(j);
            e.width(c + x);
            a = e.width();
            y = e.height();
            e = (a > z || y > r) && c > m && j > u;
            c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A);
            f.extend(h, {
                dim: {
                    width: w(a),
                    height: w(y)
                },
                origWidth: C,
                origHeight: A,
                canShrink: e,
                canExpand: c,
                wPadding: x,
                hPadding: v,
                wrapSpace: y - k.outerHeight(!0),
                skinSpace: k.height() - j
            });
            !H && (h.autoHeight && j > u && j < p && !c) && g.height("auto")
        },
        _getPosition: function(a) {
            var d = b.current
              , e = b.getViewport()
              , c = d.margin
              , f = b.wrap.width() + c[1] + c[3]
              , g = b.wrap.height() + c[0] + c[2]
              , c = {
                position: "absolute",
                top: c[0],
                left: c[3]
            };
            d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w ? c.position = "fixed" : d.locked || (c.top += e.y,
            c.left += e.x);
            c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));
            c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));
            return c
        },
        _afterZoomIn: function() {
            var a = b.current;
            a && (b.isOpen = b.isOpened = !0,
            b.wrap.css("overflow", "visible").addClass("fancybox-opened"),
            b.update(),
            (a.closeClick || a.nextClick && 1 < b.group.length) && b.inner.css("cursor", "pointer").bind("click.fb", function(d) {
                !f(d.target).is("a") && !f(d.target).parent().is("a") && (d.preventDefault(),
                b[a.closeClick ? "close" : "next"]())
            }),
            a.closeBtn && f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb", function(a) {
                a.preventDefault();
                b.close()
            }),
            a.arrows && 1 < b.group.length && ((a.loop || 0 < a.index) && f(a.tpl.prev).appendTo(b.outer).bind("click.fb", b.prev),
            (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).bind("click.fb", b.next)),
            b.trigger("afterShow"),
            !a.loop && a.index === a.group.length - 1 ? b.play(!1) : b.opts.autoPlay && !b.player.isActive && (b.opts.autoPlay = !1,
            b.play()))
        },
        _afterZoomOut: function(a) {
            a = a || b.current;
            f(".fancybox-wrap").trigger("onReset").remove();
            f.extend(b, {
                group: {},
                opts: {},
                router: !1,
                current: null,
                isActive: !1,
                isOpened: !1,
                isOpen: !1,
                isClosing: !1,
                wrap: null,
                skin: null,
                outer: null,
                inner: null
            });
            b.trigger("afterClose", a)
        }
    });
    b.transitions = {
        getOrigPosition: function() {
            var a = b.current
              , d = a.element
              , e = a.orig
              , c = {}
              , f = 50
              , g = 50
              , h = a.hPadding
              , j = a.wPadding
              , m = b.getViewport();
            !e && (a.isDom && d.is(":visible")) && (e = d.find("img:first"),
            e.length || (e = d));
            t(e) ? (c = e.offset(),
            e.is("img") && (f = e.outerWidth(),
            g = e.outerHeight())) : (c.top = m.y + (m.h - g) * a.topRatio,
            c.left = m.x + (m.w - f) * a.leftRatio);
            if ("fixed" === b.wrap.css("position") || a.locked)
                c.top -= m.y,
                c.left -= m.x;
            return c = {
                top: w(c.top - h * a.topRatio),
                left: w(c.left - j * a.leftRatio),
                width: w(f + j),
                height: w(g + h)
            }
        },
        step: function(a, d) {
            var e, c, f = d.prop;
            c = b.current;
            var g = c.wrapSpace
              , h = c.skinSpace;
            if ("width" === f || "height" === f)
                e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start),
                b.isClosing && (e = 1 - e),
                c = "width" === f ? c.wPadding : c.hPadding,
                c = a - c,
                b.skin[f](l("width" === f ? c : c - g * e)),
                b.inner[f](l("width" === f ? c : c - g * e - h * e))
        },
        zoomIn: function() {
            var a = b.current
              , d = a.pos
              , e = a.openEffect
              , c = "elastic" === e
              , k = f.extend({
                opacity: 1
            }, d);
            delete k.position;
            c ? (d = this.getOrigPosition(),
            a.openOpacity && (d.opacity = 0.1)) : "fade" === e && (d.opacity = 0.1);
            b.wrap.css(d).animate(k, {
                duration: "none" === e ? 0 : a.openSpeed,
                easing: a.openEasing,
                step: c ? this.step : null,
                complete: b._afterZoomIn
            })
        },
        zoomOut: function() {
            var a = b.current
              , d = a.closeEffect
              , e = "elastic" === d
              , c = {
                opacity: 0.1
            };
            e && (c = this.getOrigPosition(),
            a.closeOpacity && (c.opacity = 0.1));
            b.wrap.animate(c, {
                duration: "none" === d ? 0 : a.closeSpeed,
                easing: a.closeEasing,
                step: e ? this.step : null,
                complete: b._afterZoomOut
            })
        },
        changeIn: function() {
            var a = b.current, d = a.nextEffect, e = a.pos, c = {
                opacity: 1
            }, f = b.direction, g;
            e.opacity = 0.1;
            "elastic" === d && (g = "down" === f || "up" === f ? "top" : "left",
            "down" === f || "right" === f ? (e[g] = w(l(e[g]) - 200),
            c[g] = "+=200px") : (e[g] = w(l(e[g]) + 200),
            c[g] = "-=200px"));
            "none" === d ? b._afterZoomIn() : b.wrap.css(e).animate(c, {
                duration: a.nextSpeed,
                easing: a.nextEasing,
                complete: b._afterZoomIn
            })
        },
        changeOut: function() {
            var a = b.previous
              , d = a.prevEffect
              , e = {
                opacity: 0.1
            }
              , c = b.direction;
            "elastic" === d && (e["down" === c || "up" === c ? "top" : "left"] = ("up" === c || "left" === c ? "-" : "+") + "=200px");
            a.wrap.animate(e, {
                duration: "none" === d ? 0 : a.prevSpeed,
                easing: a.prevEasing,
                complete: function() {
                    f(this).trigger("onReset").remove()
                }
            })
        }
    };
    b.helpers.overlay = {
        defaults: {
            closeClick: !0,
            speedOut: 200,
            showEarly: !0,
            css: {},
            locked: !s,
            fixed: !0
        },
        overlay: null,
        fixed: !1,
        el: f("html"),
        create: function(a) {
            a = f.extend({}, this.defaults, a);
            this.overlay && this.close();
            this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent);
            this.fixed = !1;
            a.fixed && b.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"),
            this.fixed = !0)
        },
        open: function(a) {
            var d = this;
            a = f.extend({}, this.defaults, a);
            this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(a);
            this.fixed || (n.bind("resize.overlay", f.proxy(this.update, this)),
            this.update());
            a.closeClick && this.overlay.bind("click.overlay", function(a) {
                if (f(a.target).hasClass("fancybox-overlay"))
                    return b.isActive ? b.close() : d.close(),
                    !1
            });
            this.overlay.css(a.css).show()
        },
        close: function() {
            var a, b;
            n.unbind("resize.overlay");
            this.el.hasClass("fancybox-lock") && (f(".fancybox-margin").removeClass("fancybox-margin"),
            a = n.scrollTop(),
            b = n.scrollLeft(),
            this.el.removeClass("fancybox-lock"),
            n.scrollTop(a).scrollLeft(b));
            f(".fancybox-overlay").remove().hide();
            f.extend(this, {
                overlay: null,
                fixed: !1
            })
        },
        update: function() {
            var a = "100%", b;
            this.overlay.width(a).height("100%");
            I ? (b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth),
            p.width() > b && (a = p.width())) : p.width() > n.width() && (a = p.width());
            this.overlay.width(a).height(p.height())
        },
        onReady: function(a, b) {
            var e = this.overlay;
            f(".fancybox-overlay").stop(!0, !0);
            e || this.create(a);
            a.locked && (this.fixed && b.fixed) && (e || (this.margin = p.height() > n.height() ? f("html").css("margin-right").replace("px", "") : !1),
            b.locked = this.overlay.append(b.wrap),
            b.fixed = !1);
            !0 === a.showEarly && this.beforeShow.apply(this, arguments)
        },
        beforeShow: function(a, b) {
            var e, c;
            b.locked && (!1 !== this.margin && (f("*").filter(function() {
                return "fixed" === f(this).css("position") && !f(this).hasClass("fancybox-overlay") && !f(this).hasClass("fancybox-wrap")
            }).addClass("fancybox-margin"),
            this.el.addClass("fancybox-margin")),
            e = n.scrollTop(),
            c = n.scrollLeft(),
            this.el.addClass("fancybox-lock"),
            n.scrollTop(e).scrollLeft(c));
            this.open(a)
        },
        onUpdate: function() {
            this.fixed || this.update()
        },
        afterClose: function(a) {
            this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this))
        }
    };
    b.helpers.title = {
        defaults: {
            type: "float",
            position: "bottom"
        },
        beforeShow: function(a) {
            var d = b.current
              , e = d.title
              , c = a.type;
            f.isFunction(e) && (e = e.call(d.element, d));
            if (q(e) && "" !== f.trim(e)) {
                d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + "</div>");
                switch (c) {
                case "inside":
                    c = b.skin;
                    break;
                case "outside":
                    c = b.wrap;
                    break;
                case "over":
                    c = b.inner;
                    break;
                default:
                    c = b.skin,
                    d.appendTo("body"),
                    I && d.width(d.width()),
                    d.wrapInner('<span class="child"></span>'),
                    b.current.margin[2] += Math.abs(l(d.css("margin-bottom")))
                }
                d["top" === a.position ? "prependTo" : "appendTo"](c)
            }
        }
    };
    f.fn.fancybox = function(a) {
        var d, e = f(this), c = this.selector || "", k = function(g) {
            var h = f(this).blur(), j = d, k, l;
            !g.ctrlKey && (!g.altKey && !g.shiftKey && !g.metaKey) && !h.is(".fancybox-wrap") && (k = a.groupAttr || "data-fancybox-group",
            l = h.attr(k),
            l || (k = "rel",
            l = h.get(0)[k]),
            l && ("" !== l && "nofollow" !== l) && (h = c.length ? f(c) : e,
            h = h.filter("[" + k + '="' + l + '"]'),
            j = h.index(this)),
            a.index = j,
            !1 !== b.open(h, a) && g.preventDefault())
        };
        a = a || {};
        d = a.index || 0;
        !c || !1 === a.live ? e.unbind("click.fb-start").bind("click.fb-start", k) : p.undelegate(c, "click.fb-start").delegate(c + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", k);
        this.filter("[data-fancybox-start=1]").trigger("click");
        return this
    }
    ;
    p.ready(function() {
        var a, d;
        f.scrollbarWidth === v && (f.scrollbarWidth = function() {
            var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body")
              , b = a.children()
              , b = b.innerWidth() - b.height(99).innerWidth();
            a.remove();
            return b
        }
        );
        if (f.support.fixedPosition === v) {
            a = f.support;
            d = f('<div style="position:fixed;top:20px;"></div>').appendTo("body");
            var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
            d.remove();
            a.fixedPosition = e
        }
        f.extend(b.defaults, {
            scrollbarWidth: f.scrollbarWidth(),
            fixed: f.support.fixedPosition,
            parent: f("body")
        });
        a = f(r).width();
        J.addClass("fancybox-lock-test");
        d = f(r).width();
        J.removeClass("fancybox-lock-test");
        f("<style type='text/css'>.fancybox-margin{margin-right:" + (d - a) + "px;}</style>").appendTo("head")
    })
}
)(window, document, jQuery);

/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

function PointerEventsPolyfill(t) {
    if (this.options = {
        selector: "*",
        mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
        usePolyfillIf: function() {
            if ("Microsoft Internet Explorer" == navigator.appName) {
                var t = navigator.userAgent;
                if (null != t.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)) {
                    var e = parseFloat(RegExp.$1);
                    if (11 > e)
                        return !0
                }
            }
            return !1
        }
    },
    t) {
        var e = this;
        $.each(t, function(t, n) {
            e.options[t] = n
        })
    }
    this.options.usePolyfillIf() && this.register_mouse_events()
}
PointerEventsPolyfill.initialize = function(t) {
    return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(t)),
    PointerEventsPolyfill.singleton
}
,
PointerEventsPolyfill.prototype.register_mouse_events = function() {
    $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(t) {
        if ("none" == $(this).css("pointer-events")) {
            var e = $(this).css("display");
            $(this).css("display", "none");
            var n = document.elementFromPoint(t.clientX, t.clientY);
            return e ? $(this).css("display", e) : $(this).css("display", ""),
            t.target = n,
            $(n).trigger(t),
            !1
        }
        return !0
    })
}
;

/*
 * jQuery FlexSlider v2.5.0
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function($) {
    $.flexslider = function(e, t) {
        var a = $(e);
        a.vars = $.extend({}, $.flexslider.defaults, t);
        var n = a.vars.namespace, i = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, s = ("ontouchstart"in window || i || window.DocumentTouch && document instanceof DocumentTouch) && a.vars.touch, r = "click touchend MSPointerUp keyup", o = "", l, c = "vertical" === a.vars.direction, d = a.vars.reverse, u = a.vars.itemWidth > 0, v = "fade" === a.vars.animation, p = "" !== a.vars.asNavFor, m = {}, f = !0;
        $.data(e, "flexslider", a),
        m = {
            init: function() {
                a.animating = !1,
                a.currentSlide = parseInt(a.vars.startAt ? a.vars.startAt : 0, 10),
                isNaN(a.currentSlide) && (a.currentSlide = 0),
                a.animatingTo = a.currentSlide,
                a.atEnd = 0 === a.currentSlide || a.currentSlide === a.last,
                a.containerSelector = a.vars.selector.substr(0, a.vars.selector.search(" ")),
                a.slides = $(a.vars.selector, a),
                a.container = $(a.containerSelector, a),
                a.count = a.slides.length,
                a.syncExists = $(a.vars.sync).length > 0,
                "slide" === a.vars.animation && (a.vars.animation = "swing"),
                a.prop = c ? "top" : "marginLeft",
                a.args = {},
                a.manualPause = !1,
                a.stopped = !1,
                a.started = !1,
                a.startTimeout = null,
                a.transitions = !a.vars.video && !v && a.vars.useCSS && function() {
                    var e = document.createElement("div")
                      , t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                    for (var n in t)
                        if (void 0 !== e.style[t[n]])
                            return a.pfx = t[n].replace("Perspective", "").toLowerCase(),
                            a.prop = "-" + a.pfx + "-transform",
                            !0;
                    return !1
                }(),
                a.ensureAnimationEnd = "",
                "" !== a.vars.controlsContainer && (a.controlsContainer = $(a.vars.controlsContainer).length > 0 && $(a.vars.controlsContainer)),
                "" !== a.vars.manualControls && (a.manualControls = $(a.vars.manualControls).length > 0 && $(a.vars.manualControls)),
                "" !== a.vars.customDirectionNav && (a.customDirectionNav = 2 === $(a.vars.customDirectionNav).length && $(a.vars.customDirectionNav)),
                a.vars.randomize && (a.slides.sort(function() {
                    return Math.round(Math.random()) - .5
                }),
                a.container.empty().append(a.slides)),
                a.doMath(),
                a.setup("init"),
                a.vars.controlNav && m.controlNav.setup(),
                a.vars.directionNav && m.directionNav.setup(),
                a.vars.keyboard && (1 === $(a.containerSelector).length || a.vars.multipleKeyboard) && $(document).bind("keyup", function(e) {
                    var t = e.keyCode;
                    if (!a.animating && (39 === t || 37 === t)) {
                        var n = 39 === t ? a.getTarget("next") : 37 === t ? a.getTarget("prev") : !1;
                        a.flexAnimate(n, a.vars.pauseOnAction)
                    }
                }),
                a.vars.mousewheel && a.bind("mousewheel", function(e, t, n, i) {
                    e.preventDefault();
                    var s = a.getTarget(0 > t ? "next" : "prev");
                    a.flexAnimate(s, a.vars.pauseOnAction)
                }),
                a.vars.pausePlay && m.pausePlay.setup(),
                a.vars.slideshow && a.vars.pauseInvisible && m.pauseInvisible.init(),
                a.vars.slideshow && (a.vars.pauseOnHover && a.hover(function() {
                    a.manualPlay || a.manualPause || a.pause()
                }, function() {
                    a.manualPause || a.manualPlay || a.stopped || a.play()
                }),
                a.vars.pauseInvisible && m.pauseInvisible.isHidden() || (a.vars.initDelay > 0 ? a.startTimeout = setTimeout(a.play, a.vars.initDelay) : a.play())),
                p && m.asNav.setup(),
                s && a.vars.touch && m.touch(),
                (!v || v && a.vars.smoothHeight) && $(window).bind("resize orientationchange focus", m.resize),
                a.find("img").attr("draggable", "false"),
                setTimeout(function() {
                    a.vars.start(a)
                }, 200)
            },
            asNav: {
                setup: function() {
                    a.asNav = !0,
                    a.animatingTo = Math.floor(a.currentSlide / a.move),
                    a.currentItem = a.currentSlide,
                    a.slides.removeClass(n + "active-slide").eq(a.currentItem).addClass(n + "active-slide"),
                    i ? (e._slider = a,
                    a.slides.each(function() {
                        var e = this;
                        e._gesture = new MSGesture,
                        e._gesture.target = e,
                        e.addEventListener("MSPointerDown", function(e) {
                            e.preventDefault(),
                            e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId)
                        }, !1),
                        e.addEventListener("MSGestureTap", function(e) {
                            e.preventDefault();
                            var t = $(this)
                              , n = t.index();
                            $(a.vars.asNavFor).data("flexslider").animating || t.hasClass("active") || (a.direction = a.currentItem < n ? "next" : "prev",
                            a.flexAnimate(n, a.vars.pauseOnAction, !1, !0, !0))
                        })
                    })) : a.slides.on(r, function(e) {
                        e.preventDefault();
                        var t = $(this)
                          , i = t.index()
                          , s = t.offset().left - $(a).scrollLeft();
                        0 >= s && t.hasClass(n + "active-slide") ? a.flexAnimate(a.getTarget("prev"), !0) : $(a.vars.asNavFor).data("flexslider").animating || t.hasClass(n + "active-slide") || (a.direction = a.currentItem < i ? "next" : "prev",
                        a.flexAnimate(i, a.vars.pauseOnAction, !1, !0, !0))
                    })
                }
            },
            controlNav: {
                setup: function() {
                    a.manualControls ? m.controlNav.setupManual() : m.controlNav.setupPaging()
                },
                setupPaging: function() {
                    var e = "thumbnails" === a.vars.controlNav ? "control-thumbs" : "control-paging", t = 1, i, s;
                    if (a.controlNavScaffold = $('<ol class="' + n + "control-nav " + n + e + '"></ol>'),
                    a.pagingCount > 1)
                        for (var l = 0; l < a.pagingCount; l++) {
                            if (s = a.slides.eq(l),
                            i = "thumbnails" === a.vars.controlNav ? '<img src="' + s.attr("data-thumb") + '"/>' : "<a>" + t + "</a>",
                            "thumbnails" === a.vars.controlNav && !0 === a.vars.thumbCaptions) {
                                var c = s.attr("data-thumbcaption");
                                "" !== c && void 0 !== c && (i += '<span class="' + n + 'caption">' + c + "</span>")
                            }
                            a.controlNavScaffold.append("<li>" + i + "</li>"),
                            t++
                        }
                    a.controlsContainer ? $(a.controlsContainer).append(a.controlNavScaffold) : a.append(a.controlNavScaffold),
                    m.controlNav.set(),
                    m.controlNav.active(),
                    a.controlNavScaffold.delegate("a, img", r, function(e) {
                        if (e.preventDefault(),
                        "" === o || o === e.type) {
                            var t = $(this)
                              , i = a.controlNav.index(t);
                            t.hasClass(n + "active") || (a.direction = i > a.currentSlide ? "next" : "prev",
                            a.flexAnimate(i, a.vars.pauseOnAction))
                        }
                        "" === o && (o = e.type),
                        m.setToClearWatchedEvent()
                    })
                },
                setupManual: function() {
                    a.controlNav = a.manualControls,
                    m.controlNav.active(),
                    a.controlNav.bind(r, function(e) {
                        if (e.preventDefault(),
                        "" === o || o === e.type) {
                            var t = $(this)
                              , i = a.controlNav.index(t);
                            t.hasClass(n + "active") || (a.direction = i > a.currentSlide ? "next" : "prev",
                            a.flexAnimate(i, a.vars.pauseOnAction))
                        }
                        "" === o && (o = e.type),
                        m.setToClearWatchedEvent()
                    })
                },
                set: function() {
                    var e = "thumbnails" === a.vars.controlNav ? "img" : "a";
                    a.controlNav = $("." + n + "control-nav li " + e, a.controlsContainer ? a.controlsContainer : a)
                },
                active: function() {
                    a.controlNav.removeClass(n + "active").eq(a.animatingTo).addClass(n + "active")
                },
                update: function(e, t) {
                    a.pagingCount > 1 && "add" === e ? a.controlNavScaffold.append($("<li><a>" + a.count + "</a></li>")) : 1 === a.pagingCount ? a.controlNavScaffold.find("li").remove() : a.controlNav.eq(t).closest("li").remove(),
                    m.controlNav.set(),
                    a.pagingCount > 1 && a.pagingCount !== a.controlNav.length ? a.update(t, e) : m.controlNav.active()
                }
            },
            directionNav: {
                setup: function() {
                    var e = $('<ul class="' + n + 'direction-nav"><li class="' + n + 'nav-prev"><a class="' + n + 'prev ss-icon" href="#"><span class="icon-circle-left"></span></a></li><li class="' + n + 'nav-next"><a class="' + n + 'next ss-icon" href="#"><span class="icon-circle-right"></span></a></li></ul>');
                    a.customDirectionNav ? a.directionNav = a.customDirectionNav : a.controlsContainer ? ($(a.controlsContainer).append(e),
                    a.directionNav = $("." + n + "direction-nav li a", a.controlsContainer)) : (a.append(e),
                    a.directionNav = $("." + n + "direction-nav li a", a)),
                    m.directionNav.update(),
                    a.directionNav.bind(r, function(e) {
                        e.preventDefault();
                        var t;
                        ("" === o || o === e.type) && (t = a.getTarget($(this).hasClass(n + "next") ? "next" : "prev"),
                        a.flexAnimate(t, a.vars.pauseOnAction)),
                        "" === o && (o = e.type),
                        m.setToClearWatchedEvent()
                    })
                },
                update: function() {
                    var e = n + "disabled";
                    1 === a.pagingCount ? a.directionNav.addClass(e).attr("tabindex", "-1") : a.vars.animationLoop ? a.directionNav.removeClass(e).removeAttr("tabindex") : 0 === a.animatingTo ? a.directionNav.removeClass(e).filter("." + n + "prev").addClass(e).attr("tabindex", "-1") : a.animatingTo === a.last ? a.directionNav.removeClass(e).filter("." + n + "next").addClass(e).attr("tabindex", "-1") : a.directionNav.removeClass(e).removeAttr("tabindex")
                }
            },
            pausePlay: {
                setup: function() {
                    var e = $('<div class="' + n + 'pauseplay"><a></a></div>');
                    a.controlsContainer ? (a.controlsContainer.append(e),
                    a.pausePlay = $("." + n + "pauseplay a", a.controlsContainer)) : (a.append(e),
                    a.pausePlay = $("." + n + "pauseplay a", a)),
                    m.pausePlay.update(a.vars.slideshow ? n + "pause" : n + "play"),
                    a.pausePlay.bind(r, function(e) {
                        e.preventDefault(),
                        ("" === o || o === e.type) && ($(this).hasClass(n + "pause") ? (a.manualPause = !0,
                        a.manualPlay = !1,
                        a.pause()) : (a.manualPause = !1,
                        a.manualPlay = !0,
                        a.play())),
                        "" === o && (o = e.type),
                        m.setToClearWatchedEvent()
                    })
                },
                update: function(e) {
                    "play" === e ? a.pausePlay.removeClass(n + "pause").addClass(n + "play").html(a.vars.playText) : a.pausePlay.removeClass(n + "play").addClass(n + "pause").html(a.vars.pauseText)
                }
            },
            touch: function() {
                function t(t) {
                    t.stopPropagation(),
                    a.animating ? t.preventDefault() : (a.pause(),
                    e._gesture.addPointer(t.pointerId),
                    w = 0,
                    p = c ? a.h : a.w,
                    f = Number(new Date),
                    l = u && d && a.animatingTo === a.last ? 0 : u && d ? a.limit - (a.itemW + a.vars.itemMargin) * a.move * a.animatingTo : u && a.currentSlide === a.last ? a.limit : u ? (a.itemW + a.vars.itemMargin) * a.move * a.currentSlide : d ? (a.last - a.currentSlide + a.cloneOffset) * p : (a.currentSlide + a.cloneOffset) * p)
                }
                function n(t) {
                    t.stopPropagation();
                    var a = t.target._slider;
                    if (a) {
                        var n = -t.translationX
                          , i = -t.translationY;
                        return w += c ? i : n,
                        m = w,
                        y = c ? Math.abs(w) < Math.abs(-n) : Math.abs(w) < Math.abs(-i),
                        t.detail === t.MSGESTURE_FLAG_INERTIA ? void setImmediate(function() {
                            e._gesture.stop()
                        }) : void ((!y || Number(new Date) - f > 500) && (t.preventDefault(),
                        !v && a.transitions && (a.vars.animationLoop || (m = w / (0 === a.currentSlide && 0 > w || a.currentSlide === a.last && w > 0 ? Math.abs(w) / p + 2 : 1)),
                        a.setProps(l + m, "setTouch"))))
                    }
                }
                function s(e) {
                    e.stopPropagation();
                    var t = e.target._slider;
                    if (t) {
                        if (t.animatingTo === t.currentSlide && !y && null !== m) {
                            var a = d ? -m : m
                              , n = t.getTarget(a > 0 ? "next" : "prev");
                            t.canAdvance(n) && (Number(new Date) - f < 550 && Math.abs(a) > 50 || Math.abs(a) > p / 2) ? t.flexAnimate(n, t.vars.pauseOnAction) : v || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0)
                        }
                        r = null,
                        o = null,
                        m = null,
                        l = null,
                        w = 0
                    }
                }
                var r, o, l, p, m, f, g, h, S, y = !1, x = 0, b = 0, w = 0;
                i ? (e.style.msTouchAction = "none",
                e._gesture = new MSGesture,
                e._gesture.target = e,
                e.addEventListener("MSPointerDown", t, !1),
                e._slider = a,
                e.addEventListener("MSGestureChange", n, !1),
                e.addEventListener("MSGestureEnd", s, !1)) : (g = function(t) {
                    a.animating ? t.preventDefault() : (window.navigator.msPointerEnabled || 1 === t.touches.length) && (a.pause(),
                    p = c ? a.h : a.w,
                    f = Number(new Date),
                    x = t.touches[0].pageX,
                    b = t.touches[0].pageY,
                    l = u && d && a.animatingTo === a.last ? 0 : u && d ? a.limit - (a.itemW + a.vars.itemMargin) * a.move * a.animatingTo : u && a.currentSlide === a.last ? a.limit : u ? (a.itemW + a.vars.itemMargin) * a.move * a.currentSlide : d ? (a.last - a.currentSlide + a.cloneOffset) * p : (a.currentSlide + a.cloneOffset) * p,
                    r = c ? b : x,
                    o = c ? x : b,
                    e.addEventListener("touchmove", h, !1),
                    e.addEventListener("touchend", S, !1))
                }
                ,
                h = function(e) {
                    x = e.touches[0].pageX,
                    b = e.touches[0].pageY,
                    m = c ? r - b : r - x,
                    y = c ? Math.abs(m) < Math.abs(x - o) : Math.abs(m) < Math.abs(b - o);
                    var t = 500;
                    (!y || Number(new Date) - f > t) && (e.preventDefault(),
                    !v && a.transitions && (a.vars.animationLoop || (m /= 0 === a.currentSlide && 0 > m || a.currentSlide === a.last && m > 0 ? Math.abs(m) / p + 2 : 1),
                    a.setProps(l + m, "setTouch")))
                }
                ,
                S = function(t) {
                    if (e.removeEventListener("touchmove", h, !1),
                    a.animatingTo === a.currentSlide && !y && null !== m) {
                        var n = d ? -m : m
                          , i = a.getTarget(n > 0 ? "next" : "prev");
                        a.canAdvance(i) && (Number(new Date) - f < 550 && Math.abs(n) > 50 || Math.abs(n) > p / 2) ? a.flexAnimate(i, a.vars.pauseOnAction) : v || a.flexAnimate(a.currentSlide, a.vars.pauseOnAction, !0)
                    }
                    e.removeEventListener("touchend", S, !1),
                    r = null,
                    o = null,
                    m = null,
                    l = null
                }
                ,
                e.addEventListener("touchstart", g, !1))
            },
            resize: function() {
                !a.animating && a.is(":visible") && (u || a.doMath(),
                v ? m.smoothHeight() : u ? (a.slides.width(a.computedW),
                a.update(a.pagingCount),
                a.setProps()) : c ? (a.viewport.height(a.h),
                a.setProps(a.h, "setTotal")) : (a.vars.smoothHeight && m.smoothHeight(),
                a.newSlides.width(a.computedW),
                a.setProps(a.computedW, "setTotal")))
            },
            smoothHeight: function(e) {
                if (!c || v) {
                    var t = v ? a : a.viewport;
                    e ? t.animate({
                        height: a.slides.eq(a.animatingTo).height()
                    }, e) : t.height(a.slides.eq(a.animatingTo).height())
                }
            },
            sync: function(e) {
                var t = $(a.vars.sync).data("flexslider")
                  , n = a.animatingTo;
                switch (e) {
                case "animate":
                    t.flexAnimate(n, a.vars.pauseOnAction, !1, !0);
                    break;
                case "play":
                    t.playing || t.asNav || t.play();
                    break;
                case "pause":
                    t.pause()
                }
            },
            uniqueID: function(e) {
                return e.filter("[id]").add(e.find("[id]")).each(function() {
                    var e = $(this);
                    e.attr("id", e.attr("id") + "_clone")
                }),
                e
            },
            pauseInvisible: {
                visProp: null,
                init: function() {
                    var e = m.pauseInvisible.getHiddenProp();
                    if (e) {
                        var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(t, function() {
                            m.pauseInvisible.isHidden() ? a.startTimeout ? clearTimeout(a.startTimeout) : a.pause() : a.started ? a.play() : a.vars.initDelay > 0 ? setTimeout(a.play, a.vars.initDelay) : a.play()
                        })
                    }
                },
                isHidden: function() {
                    var e = m.pauseInvisible.getHiddenProp();
                    return e ? document[e] : !1
                },
                getHiddenProp: function() {
                    var e = ["webkit", "moz", "ms", "o"];
                    if ("hidden"in document)
                        return "hidden";
                    for (var t = 0; t < e.length; t++)
                        if (e[t] + "Hidden"in document)
                            return e[t] + "Hidden";
                    return null
                }
            },
            setToClearWatchedEvent: function() {
                clearTimeout(l),
                l = setTimeout(function() {
                    o = ""
                }, 3e3)
            }
        },
        a.flexAnimate = function(e, t, i, r, o) {
            if (a.vars.animationLoop || e === a.currentSlide || (a.direction = e > a.currentSlide ? "next" : "prev"),
            p && 1 === a.pagingCount && (a.direction = a.currentItem < e ? "next" : "prev"),
            !a.animating && (a.canAdvance(e, o) || i) && a.is(":visible")) {
                if (p && r) {
                    var l = $(a.vars.asNavFor).data("flexslider");
                    if (a.atEnd = 0 === e || e === a.count - 1,
                    l.flexAnimate(e, !0, !1, !0, o),
                    a.direction = a.currentItem < e ? "next" : "prev",
                    l.direction = a.direction,
                    Math.ceil((e + 1) / a.visible) - 1 === a.currentSlide || 0 === e)
                        return a.currentItem = e,
                        a.slides.removeClass(n + "active-slide").eq(e).addClass(n + "active-slide"),
                        !1;
                    a.currentItem = e,
                    a.slides.removeClass(n + "active-slide").eq(e).addClass(n + "active-slide"),
                    e = Math.floor(e / a.visible)
                }
                if (a.animating = !0,
                a.animatingTo = e,
                t && a.pause(),
                a.vars.before(a),
                a.syncExists && !o && m.sync("animate"),
                a.vars.controlNav && m.controlNav.active(),
                u || a.slides.removeClass(n + "active-slide").eq(e).addClass(n + "active-slide"),
                a.atEnd = 0 === e || e === a.last,
                a.vars.directionNav && m.directionNav.update(),
                e === a.last && (a.vars.end(a),
                a.vars.animationLoop || a.pause()),
                v)
                    s ? (a.slides.eq(a.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    }),
                    a.slides.eq(e).css({
                        opacity: 1,
                        zIndex: 2
                    }),
                    a.wrapup(f)) : (a.slides.eq(a.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, a.vars.animationSpeed, a.vars.easing),
                    a.slides.eq(e).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, a.vars.animationSpeed, a.vars.easing, a.wrapup));
                else {
                    var f = c ? a.slides.filter(":first").height() : a.computedW, g, h, S;
                    u ? (g = a.vars.itemMargin,
                    S = (a.itemW + g) * a.move * a.animatingTo,
                    h = S > a.limit && 1 !== a.visible ? a.limit : S) : h = 0 === a.currentSlide && e === a.count - 1 && a.vars.animationLoop && "next" !== a.direction ? d ? (a.count + a.cloneOffset) * f : 0 : a.currentSlide === a.last && 0 === e && a.vars.animationLoop && "prev" !== a.direction ? d ? 0 : (a.count + 1) * f : d ? (a.count - 1 - e + a.cloneOffset) * f : (e + a.cloneOffset) * f,
                    a.setProps(h, "", a.vars.animationSpeed),
                    a.transitions ? (a.vars.animationLoop && a.atEnd || (a.animating = !1,
                    a.currentSlide = a.animatingTo),
                    a.container.unbind("webkitTransitionEnd transitionend"),
                    a.container.bind("webkitTransitionEnd transitionend", function() {
                        clearTimeout(a.ensureAnimationEnd),
                        a.wrapup(f)
                    }),
                    clearTimeout(a.ensureAnimationEnd),
                    a.ensureAnimationEnd = setTimeout(function() {
                        a.wrapup(f)
                    }, a.vars.animationSpeed + 100)) : a.container.animate(a.args, a.vars.animationSpeed, a.vars.easing, function() {
                        a.wrapup(f)
                    })
                }
                a.vars.smoothHeight && m.smoothHeight(a.vars.animationSpeed)
            }
        }
        ,
        a.wrapup = function(e) {
            v || u || (0 === a.currentSlide && a.animatingTo === a.last && a.vars.animationLoop ? a.setProps(e, "jumpEnd") : a.currentSlide === a.last && 0 === a.animatingTo && a.vars.animationLoop && a.setProps(e, "jumpStart")),
            a.animating = !1,
            a.currentSlide = a.animatingTo,
            a.vars.after(a)
        }
        ,
        a.animateSlides = function() {
            !a.animating && f && a.flexAnimate(a.getTarget("next"))
        }
        ,
        a.pause = function() {
            clearInterval(a.animatedSlides),
            a.animatedSlides = null,
            a.playing = !1,
            a.vars.pausePlay && m.pausePlay.update("play"),
            a.syncExists && m.sync("pause")
        }
        ,
        a.play = function() {
            a.playing && clearInterval(a.animatedSlides),
            a.animatedSlides = a.animatedSlides || setInterval(a.animateSlides, a.vars.slideshowSpeed),
            a.started = a.playing = !0,
            a.vars.pausePlay && m.pausePlay.update("pause"),
            a.syncExists && m.sync("play")
        }
        ,
        a.stop = function() {
            a.pause(),
            a.stopped = !0
        }
        ,
        a.canAdvance = function(e, t) {
            var n = p ? a.pagingCount - 1 : a.last;
            return t ? !0 : p && a.currentItem === a.count - 1 && 0 === e && "prev" === a.direction ? !0 : p && 0 === a.currentItem && e === a.pagingCount - 1 && "next" !== a.direction ? !1 : e !== a.currentSlide || p ? a.vars.animationLoop ? !0 : a.atEnd && 0 === a.currentSlide && e === n && "next" !== a.direction ? !1 : a.atEnd && a.currentSlide === n && 0 === e && "next" === a.direction ? !1 : !0 : !1
        }
        ,
        a.getTarget = function(e) {
            return a.direction = e,
            "next" === e ? a.currentSlide === a.last ? 0 : a.currentSlide + 1 : 0 === a.currentSlide ? a.last : a.currentSlide - 1
        }
        ,
        a.setProps = function(e, t, n) {
            var i = function() {
                var n = e ? e : (a.itemW + a.vars.itemMargin) * a.move * a.animatingTo
                  , i = function() {
                    if (u)
                        return "setTouch" === t ? e : d && a.animatingTo === a.last ? 0 : d ? a.limit - (a.itemW + a.vars.itemMargin) * a.move * a.animatingTo : a.animatingTo === a.last ? a.limit : n;
                    switch (t) {
                    case "setTotal":
                        return d ? (a.count - 1 - a.currentSlide + a.cloneOffset) * e : (a.currentSlide + a.cloneOffset) * e;
                    case "setTouch":
                        return d ? e : e;
                    case "jumpEnd":
                        return d ? e : a.count * e;
                    case "jumpStart":
                        return d ? a.count * e : e;
                    default:
                        return e
                    }
                }();
                return -1 * i + "px"
            }();
            a.transitions && (i = c ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)",
            n = void 0 !== n ? n / 1e3 + "s" : "0s",
            a.container.css("-" + a.pfx + "-transition-duration", n),
            a.container.css("transition-duration", n)),
            a.args[a.prop] = i,
            (a.transitions || void 0 === n) && a.container.css(a.args),
            a.container.css("transform", i)
        }
        ,
        a.setup = function(e) {
            if (v)
                a.slides.css({
                    width: "100%",
                    "float": "left",
                    marginRight: "-100%",
                    position: "relative"
                }),
                "init" === e && (s ? a.slides.css({
                    opacity: 0,
                    display: "block",
                    webkitTransition: "opacity " + a.vars.animationSpeed / 1e3 + "s ease",
                    zIndex: 1
                }).eq(a.currentSlide).css({
                    opacity: 1,
                    zIndex: 2
                }) : 0 == a.vars.fadeFirstSlide ? a.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(a.currentSlide).css({
                    zIndex: 2
                }).css({
                    opacity: 1
                }) : a.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(a.currentSlide).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, a.vars.animationSpeed, a.vars.easing)),
                a.vars.smoothHeight && m.smoothHeight();
            else {
                var t, i;
                "init" === e && (a.viewport = $('<div class="' + n + 'viewport"></div>').css({
                    overflow: "hidden",
                    position: "relative"
                }).appendTo(a).append(a.container),
                a.cloneCount = 0,
                a.cloneOffset = 0,
                d && (i = $.makeArray(a.slides).reverse(),
                a.slides = $(i),
                a.container.empty().append(a.slides))),
                a.vars.animationLoop && !u && (a.cloneCount = 2,
                a.cloneOffset = 1,
                "init" !== e && a.container.find(".clone").remove(),
                a.container.append(m.uniqueID(a.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(m.uniqueID(a.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))),
                a.newSlides = $(a.vars.selector, a),
                t = d ? a.count - 1 - a.currentSlide + a.cloneOffset : a.currentSlide + a.cloneOffset,
                c && !u ? (a.container.height(200 * (a.count + a.cloneCount) + "%").css("position", "absolute").width("100%"),
                setTimeout(function() {
                    a.newSlides.css({
                        display: "block"
                    }),
                    a.doMath(),
                    a.viewport.height(a.h),
                    a.setProps(t * a.h, "init")
                }, "init" === e ? 100 : 0)) : (a.container.width(200 * (a.count + a.cloneCount) + "%"),
                a.setProps(t * a.computedW, "init"),
                setTimeout(function() {
                    a.doMath(),
                    a.newSlides.css({
                        width: a.computedW,
                        "float": "left",
                        display: "block"
                    }),
                    a.vars.smoothHeight && m.smoothHeight()
                }, "init" === e ? 100 : 0))
            }
            u || a.slides.removeClass(n + "active-slide").eq(a.currentSlide).addClass(n + "active-slide"),
            a.vars.init(a)
        }
        ,
        a.doMath = function() {
            var e = a.slides.first()
              , t = a.vars.itemMargin
              , n = a.vars.minItems
              , i = a.vars.maxItems;
            a.w = void 0 === a.viewport ? a.width() : a.viewport.width(),
            a.h = e.height(),
            a.boxPadding = e.outerWidth() - e.width(),
            u ? (a.itemT = a.vars.itemWidth + t,
            a.minW = n ? n * a.itemT : a.w,
            a.maxW = i ? i * a.itemT - t : a.w,
            a.itemW = a.minW > a.w ? (a.w - t * (n - 1)) / n : a.maxW < a.w ? (a.w - t * (i - 1)) / i : a.vars.itemWidth > a.w ? a.w : a.vars.itemWidth,
            a.visible = Math.floor(a.w / a.itemW),
            a.move = a.vars.move > 0 && a.vars.move < a.visible ? a.vars.move : a.visible,
            a.pagingCount = Math.ceil((a.count - a.visible) / a.move + 1),
            a.last = a.pagingCount - 1,
            a.limit = 1 === a.pagingCount ? 0 : a.vars.itemWidth > a.w ? a.itemW * (a.count - 1) + t * (a.count - 1) : (a.itemW + t) * a.count - a.w - t) : (a.itemW = a.w,
            a.pagingCount = a.count,
            a.last = a.count - 1),
            a.computedW = a.itemW - a.boxPadding
        }
        ,
        a.update = function(e, t) {
            a.doMath(),
            u || (e < a.currentSlide ? a.currentSlide += 1 : e <= a.currentSlide && 0 !== e && (a.currentSlide -= 1),
            a.animatingTo = a.currentSlide),
            a.vars.controlNav && !a.manualControls && ("add" === t && !u || a.pagingCount > a.controlNav.length ? m.controlNav.update("add") : ("remove" === t && !u || a.pagingCount < a.controlNav.length) && (u && a.currentSlide > a.last && (a.currentSlide -= 1,
            a.animatingTo -= 1),
            m.controlNav.update("remove", a.last))),
            a.vars.directionNav && m.directionNav.update()
        }
        ,
        a.addSlide = function(e, t) {
            var n = $(e);
            a.count += 1,
            a.last = a.count - 1,
            c && d ? void 0 !== t ? a.slides.eq(a.count - t).after(n) : a.container.prepend(n) : void 0 !== t ? a.slides.eq(t).before(n) : a.container.append(n),
            a.update(t, "add"),
            a.slides = $(a.vars.selector + ":not(.clone)", a),
            a.setup(),
            a.vars.added(a)
        }
        ,
        a.removeSlide = function(e) {
            var t = isNaN(e) ? a.slides.index($(e)) : e;
            a.count -= 1,
            a.last = a.count - 1,
            isNaN(e) ? $(e, a.slides).remove() : c && d ? a.slides.eq(a.last).remove() : a.slides.eq(e).remove(),
            a.doMath(),
            a.update(t, "remove"),
            a.slides = $(a.vars.selector + ":not(.clone)", a),
            a.setup(),
            a.vars.removed(a)
        }
        ,
        m.init()
    }
    ,
    $(window).blur(function(e) {
        focused = !1
    }).focus(function(e) {
        focused = !0
    }),
    $.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "&#x25C5;",
        nextText: "&#x25BB;",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        start: function() {},
        before: function() {},
        after: function() {},
        end: function() {},
        added: function() {},
        removed: function() {},
        init: function() {}
    },
    $.fn.flexslider = function(e) {
        if (void 0 === e && (e = {}),
        "object" == typeof e)
            return this.each(function() {
                var t = $(this)
                  , a = e.selector ? e.selector : ".slides > li"
                  , n = t.find(a);
                1 === n.length && e.allowOneSlide === !0 || 0 === n.length ? (n.fadeIn(400),
                e.start && e.start(t)) : void 0 === t.data("flexslider") && new $.flexslider(this,e)
            });
        var t = $(this).data("flexslider");
        switch (e) {
        case "play":
            t.play();
            break;
        case "pause":
            t.pause();
            break;
        case "stop":
            t.stop();
            break;
        case "next":
            t.flexAnimate(t.getTarget("next"), !0);
            break;
        case "prev":
        case "previous":
            t.flexAnimate(t.getTarget("prev"), !0);
            break;
        default:
            "number" == typeof e && t.flexAnimate(e, !0)
        }
    }
}(jQuery);

/*
 * jQuery mmenu v5.7.8
 * @requires jQuery 1.7.0 or later
 *
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-NC-4.0
 * http://creativecommons.org/licenses/by-nc/4.0/
 */
!function(e) {
    function n() {
        e[t].glbl || (r = {
            $wndw: e(window),
            $docu: e(document),
            $html: e("html"),
            $body: e("body")
        },
        s = {},
        a = {},
        o = {},
        e.each([s, a, o], function(e, n) {
            n.add = function(e) {
                e = e.split(" ");
                for (var t = 0, i = e.length; t < i; t++)
                    n[e[t]] = n.mm(e[t])
            }
        }),
        s.mm = function(e) {
            return "mm-" + e
        }
        ,
        s.add("wrapper menu panels panel nopanel current highest opened subopened navbar hasnavbar title btn prev next listview nolistview inset vertical selected divider spacer hidden fullsubopen"),
        s.umm = function(e) {
            return "mm-" == e.slice(0, 3) && (e = e.slice(3)),
            e
        }
        ,
        a.mm = function(e) {
            return "mm-" + e
        }
        ,
        a.add("parent child"),
        o.mm = function(e) {
            return e + ".mm"
        }
        ,
        o.add("transitionend webkitTransitionEnd click scroll keydown mousedown mouseup touchstart touchmove touchend orientationchange"),
        e[t]._c = s,
        e[t]._d = a,
        e[t]._e = o,
        e[t].glbl = r)
    }
    var t = "mmenu"
      , i = "5.7.8";
    if (!(e[t] && e[t].version > i)) {
        e[t] = function(e, n, t) {
            this.$menu = e,
            this._api = ["bind", "getInstance", "update", "initPanels", "openPanel", "closePanel", "closeAllPanels", "setSelected"],
            this.opts = n,
            this.conf = t,
            this.vars = {},
            this.cbck = {},
            "function" == typeof this.___deprecated && this.___deprecated(),
            this._initMenu(),
            this._initAnchors();
            var i = this.$pnls.children();
            return this._initAddons(),
            this.initPanels(i),
            "function" == typeof this.___debug && this.___debug(),
            this
        }
        ,
        e[t].version = i,
        e[t].addons = {},
        e[t].uniqueId = 0,
        e[t].defaults = {
            extensions: [],
            initMenu: function() {},
            initPanels: function() {},
            navbar: {
                add: !0,
                title: "Menu",
                titleLink: "panel"
            },
            onClick: {
                setSelected: !0
            },
            slidingSubmenus: !0
        },
        e[t].configuration = {
            classNames: {
                divider: "Divider",
                inset: "Inset",
                panel: "Panel",
                selected: "Selected",
                spacer: "Spacer",
                vertical: "Vertical"
            },
            clone: !1,
            openingInterval: 25,
            panelNodetype: "ul, ol, div",
            transitionDuration: 400
        },
        e[t].prototype = {
            init: function(e) {
                this.initPanels(e)
            },
            getInstance: function() {
                return this
            },
            update: function() {
                this.trigger("update")
            },
            initPanels: function(e) {
                e = e.not("." + s.nopanel),
                e = this._initPanels(e),
                this.opts.initPanels.call(this, e),
                this.trigger("initPanels", e),
                this.trigger("update")
            },
            openPanel: function(n) {
                var i = n.parent()
                  , a = this;
                if (i.hasClass(s.vertical)) {
                    var o = i.parents("." + s.subopened);
                    if (o.length)
                        return void this.openPanel(o.first());
                    i.addClass(s.opened),
                    this.trigger("openPanel", n),
                    this.trigger("openingPanel", n),
                    this.trigger("openedPanel", n)
                } else {
                    if (n.hasClass(s.current))
                        return;
                    var r = this.$pnls.children("." + s.panel)
                      , l = r.filter("." + s.current);
                    r.removeClass(s.highest).removeClass(s.current).not(n).not(l).not("." + s.vertical).addClass(s.hidden),
                    e[t].support.csstransitions || l.addClass(s.hidden),
                    n.hasClass(s.opened) ? n.nextAll("." + s.opened).addClass(s.highest).removeClass(s.opened).removeClass(s.subopened) : (n.addClass(s.highest),
                    l.addClass(s.subopened)),
                    n.removeClass(s.hidden).addClass(s.current),
                    a.trigger("openPanel", n),
                    setTimeout(function() {
                        n.removeClass(s.subopened).addClass(s.opened),
                        a.trigger("openingPanel", n),
                        a.__transitionend(n, function() {
                            a.trigger("openedPanel", n)
                        }, a.conf.transitionDuration)
                    }, this.conf.openingInterval)
                }
            },
            closePanel: function(e) {
                var n = e.parent();
                n.hasClass(s.vertical) && (n.removeClass(s.opened),
                this.trigger("closePanel", e),
                this.trigger("closingPanel", e),
                this.trigger("closedPanel", e))
            },
            closeAllPanels: function() {
                this.$menu.find("." + s.listview).children().removeClass(s.selected).filter("." + s.vertical).removeClass(s.opened);
                var e = this.$pnls.children("." + s.panel)
                  , n = e.first();
                this.$pnls.children("." + s.panel).not(n).removeClass(s.subopened).removeClass(s.opened).removeClass(s.current).removeClass(s.highest).addClass(s.hidden),
                this.openPanel(n)
            },
            togglePanel: function(e) {
                var n = e.parent();
                n.hasClass(s.vertical) && this[n.hasClass(s.opened) ? "closePanel" : "openPanel"](e)
            },
            setSelected: function(e) {
                this.$menu.find("." + s.listview).children("." + s.selected).removeClass(s.selected),
                e.addClass(s.selected),
                this.trigger("setSelected", e)
            },
            bind: function(e, n) {
                e = "init" == e ? "initPanels" : e,
                this.cbck[e] = this.cbck[e] || [],
                this.cbck[e].push(n)
            },
            trigger: function() {
                var e = this
                  , n = Array.prototype.slice.call(arguments)
                  , t = n.shift();
                if (t = "init" == t ? "initPanels" : t,
                this.cbck[t])
                    for (var i = 0, s = this.cbck[t].length; i < s; i++)
                        this.cbck[t][i].apply(e, n)
            },
            _initMenu: function() {
                this.conf.clone && (this.$orig = this.$menu,
                this.$menu = this.$orig.clone(!0),
                this.$menu.add(this.$menu.find("[id]")).filter("[id]").each(function() {
                    e(this).attr("id", s.mm(e(this).attr("id")))
                })),
                this.opts.initMenu.call(this, this.$menu, this.$orig),
                this.$menu.attr("id", this.$menu.attr("id") || this.__getUniqueId()),
                this.$pnls = e('<div class="' + s.panels + '" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu),
                this.$menu.parent().addClass(s.wrapper);
                var n = [s.menu];
                this.opts.slidingSubmenus || n.push(s.vertical),
                this.opts.extensions = this.opts.extensions.length ? "mm-" + this.opts.extensions.join(" mm-") : "",
                this.opts.extensions && n.push(this.opts.extensions),
                this.$menu.addClass(n.join(" ")),
                this.trigger("_initMenu")
            },
            _initPanels: function(n) {
                var i = this
                  , o = this.__findAddBack(n, "ul, ol");
                this.__refactorClass(o, this.conf.classNames.inset, "inset").addClass(s.nolistview + " " + s.nopanel),
                o.not("." + s.nolistview).addClass(s.listview);
                var r = this.__findAddBack(n, "." + s.listview).children();
                this.__refactorClass(r, this.conf.classNames.selected, "selected"),
                this.__refactorClass(r, this.conf.classNames.divider, "divider"),
                this.__refactorClass(r, this.conf.classNames.spacer, "spacer"),
                this.__refactorClass(this.__findAddBack(n, "." + this.conf.classNames.panel), this.conf.classNames.panel, "panel");
                var l = e()
                  , d = n.add(n.find("." + s.panel)).add(this.__findAddBack(n, "." + s.listview).children().children(this.conf.panelNodetype)).not("." + s.nopanel);
                this.__refactorClass(d, this.conf.classNames.vertical, "vertical"),
                this.opts.slidingSubmenus || d.addClass(s.vertical),
                d.each(function() {
                    var n = e(this)
                      , t = n;
                    n.is("ul, ol") ? (n.wrap('<div class="' + s.panel + '" />'),
                    t = n.parent()) : t.addClass(s.panel);
                    var a = n.attr("id");
                    n.removeAttr("id"),
                    t.attr("id", a || i.__getUniqueId()),
                    n.hasClass(s.vertical) && (n.removeClass(i.conf.classNames.vertical),
                    t.add(t.parent()).addClass(s.vertical)),
                    l = l.add(t)
                });
                var c = e("." + s.panel, this.$menu);
                l.each(function(n) {
                    var o, r, l = e(this), d = l.parent(), c = d.children("a, span").first();
                    if (d.is("." + s.panels) || (d.data(a.child, l),
                    l.data(a.parent, d)),
                    d.children("." + s.next).length || d.parent().is("." + s.listview) && (o = l.attr("id"),
                    r = e('<a class="' + s.next + '" href="#' + o + '" data-target="#' + o + '" />').insertBefore(c),
                    c.is("span") && r.addClass(s.fullsubopen)),
                    !l.children("." + s.navbar).length && !d.hasClass(s.vertical)) {
                        d.parent().is("." + s.listview) ? d = d.closest("." + s.panel) : (c = d.closest("." + s.panel).find('a[href="#' + l.attr("id") + '"]').first(),
                        d = c.closest("." + s.panel));
                        var h = !1
                          , u = e('<div class="' + s.navbar + '" />');
                        if (i.opts.navbar.add && l.addClass(s.hasnavbar),
                        d.length) {
                            switch (o = d.attr("id"),
                            i.opts.navbar.titleLink) {
                            case "anchor":
                                h = c.attr("href");
                                break;
                            case "panel":
                            case "parent":
                                h = "#" + o;
                                break;
                            default:
                                h = !1
                            }
                            u.append('<a class="' + s.btn + " " + s.prev + '" href="#' + o + '" data-target="#' + o + '" />').append(e('<a class="' + s.title + '"' + (h ? ' href="' + h + '"' : "") + " />").text(c.text())).prependTo(l)
                        } else
                            i.opts.navbar.title && u.append('<a class="' + s.title + '">' + e[t].i18n(i.opts.navbar.title) + "</a>").prependTo(l)
                    }
                });
                var h = this.__findAddBack(n, "." + s.listview).children("." + s.selected).removeClass(s.selected).last().addClass(s.selected);
                h.add(h.parentsUntil("." + s.menu, "li")).filter("." + s.vertical).addClass(s.opened).end().each(function() {
                    e(this).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).addClass(s.subopened)
                }),
                h.children("." + s.panel).not("." + s.vertical).addClass(s.opened).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).addClass(s.subopened);
                var u = c.filter("." + s.opened);
                return u.length || (u = l.first()),
                u.addClass(s.opened).last().addClass(s.current),
                l.not("." + s.vertical).not(u.last()).addClass(s.hidden).end().filter(function() {
                    return !e(this).parent().hasClass(s.panels)
                }).appendTo(this.$pnls),
                this.trigger("_initPanels", l),
                l
            },
            _initAnchors: function() {
                var n = this;
                r.$body.on(o.click + "-oncanvas", "a[href]", function(i) {
                    var a = e(this)
                      , o = !1
                      , r = n.$menu.find(a).length;
                    for (var l in e[t].addons)
                        if (e[t].addons[l].clickAnchor.call(n, a, r)) {
                            o = !0;
                            break
                        }
                    var d = a.attr("href");
                    if (!o && r && d.length > 1 && "#" == d.slice(0, 1))
                        try {
                            var c = e(d, n.$menu);
                            c.is("." + s.panel) && (o = !0,
                            n[a.parent().hasClass(s.vertical) ? "togglePanel" : "openPanel"](c))
                        } catch (h) {}
                    if (o && i.preventDefault(),
                    !o && r && a.is("." + s.listview + " > li > a") && !a.is('[rel="external"]') && !a.is('[target="_blank"]')) {
                        n.__valueOrFn(n.opts.onClick.setSelected, a) && n.setSelected(e(i.target).parent());
                        var u = n.__valueOrFn(n.opts.onClick.preventDefault, a, "#" == d.slice(0, 1));
                        u && i.preventDefault(),
                        n.__valueOrFn(n.opts.onClick.close, a, u) && n.close()
                    }
                }),
                this.trigger("_initAnchors")
            },
            _initAddons: function() {
                var n;
                for (n in e[t].addons)
                    e[t].addons[n].add.call(this),
                    e[t].addons[n].add = function() {}
                    ;
                for (n in e[t].addons)
                    e[t].addons[n].setup.call(this);
                this.trigger("_initAddons")
            },
            _getOriginalMenuId: function() {
                var e = this.$menu.attr("id");
                return e && e.length && this.conf.clone && (e = s.umm(e)),
                e
            },
            __api: function() {
                var n = this
                  , t = {};
                return e.each(this._api, function(e) {
                    var i = this;
                    t[i] = function() {
                        var e = n[i].apply(n, arguments);
                        return "undefined" == typeof e ? t : e
                    }
                }),
                t
            },
            __valueOrFn: function(e, n, t) {
                return "function" == typeof e ? e.call(n[0]) : "undefined" == typeof e && "undefined" != typeof t ? t : e
            },
            __refactorClass: function(e, n, t) {
                return e.filter("." + n).removeClass(n).addClass(s[t])
            },
            __findAddBack: function(e, n) {
                return e.find(n).add(e.filter(n))
            },
            __filterListItems: function(e) {
                return e.not("." + s.divider).not("." + s.hidden)
            },
            __transitionend: function(n, t, i) {
                var s = !1
                  , a = function(i) {
                    if ("undefined" != typeof i) {
                        if (!e(i.target).is(n))
                            return !1;
                        n.unbind(o.transitionend),
                        n.unbind(o.webkitTransitionEnd)
                    }
                    s || t.call(n[0]),
                    s = !0
                };
                n.on(o.transitionend, a),
                n.on(o.webkitTransitionEnd, a),
                setTimeout(a, 1.1 * i)
            },
            __getUniqueId: function() {
                return s.mm(e[t].uniqueId++)
            }
        },
        e.fn[t] = function(i, s) {
            n(),
            i = e.extend(!0, {}, e[t].defaults, i),
            s = e.extend(!0, {}, e[t].configuration, s);
            var a = e();
            return this.each(function() {
                var n = e(this);
                if (!n.data(t)) {
                    var o = new e[t](n,i,s);
                    o.$menu.data(t, o.__api()),
                    a = a.add(o.$menu)
                }
            }),
            a
        }
        ,
        e[t].i18n = function() {
            var n = {};
            return function(t) {
                switch (typeof t) {
                case "object":
                    return e.extend(n, t),
                    n;
                case "string":
                    return n[t] || t;
                case "undefined":
                default:
                    return n
                }
            }
        }(),
        e[t].support = {
            touch: "ontouchstart"in window || navigator.msMaxTouchPoints || !1,
            csstransitions: function() {
                if ("undefined" != typeof Modernizr && "undefined" != typeof Modernizr.csstransitions)
                    return Modernizr.csstransitions;
                var e = document.body || document.documentElement
                  , n = e.style
                  , t = "transition";
                if ("string" == typeof n[t])
                    return !0;
                var i = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
                t = t.charAt(0).toUpperCase() + t.substr(1);
                for (var s = 0; s < i.length; s++)
                    if ("string" == typeof n[i[s] + t])
                        return !0;
                return !1
            }(),
            csstransforms: function() {
                return "undefined" == typeof Modernizr || "undefined" == typeof Modernizr.csstransforms || Modernizr.csstransforms
            }(),
            csstransforms3d: function() {
                return "undefined" == typeof Modernizr || "undefined" == typeof Modernizr.csstransforms3d || Modernizr.csstransforms3d
            }()
        };
        var s, a, o, r
    }
}(jQuery),
/*
 * jQuery mmenu offCanvas add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e) {
    var n = "mmenu"
      , t = "offCanvas";
    e[n].addons[t] = {
        setup: function() {
            if (this.opts[t]) {
                var s = this.opts[t]
                  , a = this.conf[t];
                o = e[n].glbl,
                this._api = e.merge(this._api, ["open", "close", "setPage"]),
                "top" != s.position && "bottom" != s.position || (s.zposition = "front"),
                "string" != typeof a.pageSelector && (a.pageSelector = "> " + a.pageNodetype),
                o.$allMenus = (o.$allMenus || e()).add(this.$menu),
                this.vars.opened = !1;
                var r = [i.offcanvas];
                "left" != s.position && r.push(i.mm(s.position)),
                "back" != s.zposition && r.push(i.mm(s.zposition)),
                this.$menu.addClass(r.join(" ")).parent().removeClass(i.wrapper),
                e[n].support.csstransforms || this.$menu.addClass(i["no-csstransforms"]),
                e[n].support.csstransforms3d || this.$menu.addClass(i["no-csstransforms3d"]),
                this.setPage(o.$page),
                this._initBlocker(),
                this["_initWindow_" + t](),
                this.$menu[a.menuInjectMethod + "To"](a.menuWrapperSelector);
                var l = window.location.hash;
                if (l) {
                    var d = this._getOriginalMenuId();
                    d && d == l.slice(1) && this.open()
                }
            }
        },
        add: function() {
            i = e[n]._c,
            s = e[n]._d,
            a = e[n]._e,
            i.add("offcanvas slideout blocking modal background opening blocker page no-csstransforms3d"),
            s.add("style"),
            a.add("resize")
        },
        clickAnchor: function(e, n) {
            var s = this;
            if (this.opts[t]) {
                var a = this._getOriginalMenuId();
                if (a && e.is('[href="#' + a + '"]')) {
                    if (n)
                        return !0;
                    var r = e.closest("." + i.menu);
                    if (r.length) {
                        var l = r.data("mmenu");
                        if (l && l.close)
                            return l.close(),
                            s.__transitionend(r, function() {
                                s.open()
                            }, s.conf.transitionDuration),
                            !0
                    }
                    return this.open(),
                    !0
                }
                if (o.$page)
                    return a = o.$page.first().attr("id"),
                    a && e.is('[href="#' + a + '"]') ? (this.close(),
                    !0) : void 0
            }
        }
    },
    e[n].defaults[t] = {
        position: "left",
        zposition: "back",
        blockUI: !0,
        moveBackground: !0
    },
    e[n].configuration[t] = {
        pageNodetype: "div",
        pageSelector: null,
        noPageSelector: [],
        wrapPageIfNeeded: !0,
        menuWrapperSelector: "body",
        menuInjectMethod: "prepend"
    },
    e[n].prototype.open = function() {
        if (!this.vars.opened) {
            var e = this;
            this._openSetup(),
            setTimeout(function() {
                e._openFinish()
            }, this.conf.openingInterval),
            this.trigger("open")
        }
    }
    ,
    e[n].prototype._openSetup = function() {
        var n = this
          , r = this.opts[t];
        this.closeAllOthers(),
        o.$page.each(function() {
            e(this).data(s.style, e(this).attr("style") || "")
        }),
        o.$wndw.trigger(a.resize + "-" + t, [!0]);
        var l = [i.opened];
        r.blockUI && l.push(i.blocking),
        "modal" == r.blockUI && l.push(i.modal),
        r.moveBackground && l.push(i.background),
        "left" != r.position && l.push(i.mm(this.opts[t].position)),
        "back" != r.zposition && l.push(i.mm(this.opts[t].zposition)),
        this.opts.extensions && l.push(this.opts.extensions),
        o.$html.addClass(l.join(" ")),
        setTimeout(function() {
            n.vars.opened = !0
        }, this.conf.openingInterval),
        this.$menu.addClass(i.current + " " + i.opened)
    }
    ,
    e[n].prototype._openFinish = function() {
        var e = this;
        this.__transitionend(o.$page.first(), function() {
            e.trigger("opened")
        }, this.conf.transitionDuration),
        o.$html.addClass(i.opening),
        this.trigger("opening")
    }
    ,
    e[n].prototype.close = function() {
        if (this.vars.opened) {
            var n = this;
            this.__transitionend(o.$page.first(), function() {
                n.$menu.removeClass(i.current + " " + i.opened);
                var a = [i.opened, i.blocking, i.modal, i.background, i.mm(n.opts[t].position), i.mm(n.opts[t].zposition)];
                n.opts.extensions && a.push(n.opts.extensions),
                o.$html.removeClass(a.join(" ")),
                o.$page.each(function() {
                    e(this).attr("style", e(this).data(s.style))
                }),
                n.vars.opened = !1,
                n.trigger("closed")
            }, this.conf.transitionDuration),
            o.$html.removeClass(i.opening),
            this.trigger("close"),
            this.trigger("closing")
        }
    }
    ,
    e[n].prototype.closeAllOthers = function() {
        o.$allMenus.not(this.$menu).each(function() {
            var t = e(this).data(n);
            t && t.close && t.close()
        })
    }
    ,
    e[n].prototype.setPage = function(n) {
        var s = this
          , a = this.conf[t];
        n && n.length || (n = o.$body.find(a.pageSelector),
        a.noPageSelector.length && (n = n.not(a.noPageSelector.join(", "))),
        n.length > 1 && a.wrapPageIfNeeded && (n = n.wrapAll("<" + this.conf[t].pageNodetype + " />").parent())),
        n.each(function() {
            e(this).attr("id", e(this).attr("id") || s.__getUniqueId())
        }),
        n.addClass(i.page + " " + i.slideout),
        o.$page = n,
        this.trigger("setPage", n)
    }
    ,
    e[n].prototype["_initWindow_" + t] = function() {
        o.$wndw.off(a.keydown + "-" + t).on(a.keydown + "-" + t, function(e) {
            if (o.$html.hasClass(i.opened) && 9 == e.keyCode)
                return e.preventDefault(),
                !1
        });
        var e = 0;
        o.$wndw.off(a.resize + "-" + t).on(a.resize + "-" + t, function(n, t) {
            if (1 == o.$page.length && (t || o.$html.hasClass(i.opened))) {
                var s = o.$wndw.height();
                (t || s != e) && (e = s,
                o.$page.css("minHeight", s))
            }
        })
    }
    ,
    e[n].prototype._initBlocker = function() {
        var n = this;
        this.opts[t].blockUI && (o.$blck || (o.$blck = e('<div id="' + i.blocker + '" class="' + i.slideout + '" />')),
        o.$blck.appendTo(o.$body).off(a.touchstart + "-" + t + " " + a.touchmove + "-" + t).on(a.touchstart + "-" + t + " " + a.touchmove + "-" + t, function(e) {
            e.preventDefault(),
            e.stopPropagation(),
            o.$blck.trigger(a.mousedown + "-" + t)
        }).off(a.mousedown + "-" + t).on(a.mousedown + "-" + t, function(e) {
            e.preventDefault(),
            o.$html.hasClass(i.modal) || (n.closeAllOthers(),
            n.close())
        }))
    }
    ;
    var i, s, a, o
}(jQuery),
/*

* jQuery mmenu searchfield add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e) {
    function n(e) {
        switch (e) {
        case 9:
        case 16:
        case 17:
        case 18:
        case 37:
        case 38:
        case 39:
        case 40:
            return !0
        }
        return !1
    }
    var t = "mmenu"
      , i = "searchfield";
    e[t].addons[i] = {
        setup: function() {
            var l = this
              , d = this.opts[i]
              , c = this.conf[i];
            r = e[t].glbl,
            "boolean" == typeof d && (d = {
                add: d
            }),
            "object" != typeof d && (d = {}),
            "boolean" == typeof d.resultsPanel && (d.resultsPanel = {
                add: d.resultsPanel
            }),
            d = this.opts[i] = e.extend(!0, {}, e[t].defaults[i], d),
            c = this.conf[i] = e.extend(!0, {}, e[t].configuration[i], c),
            this.bind("close", function() {
                this.$menu.find("." + s.search).find("input").blur()
            }),
            this.bind("initPanels", function(r) {
                if (d.add) {
                    var h;
                    switch (d.addTo) {
                    case "panels":
                        h = r;
                        break;
                    default:
                        h = this.$menu.find(d.addTo)
                    }
                    if (h.each(function() {
                        var n = e(this);
                        if (!n.is("." + s.panel) || !n.is("." + s.vertical)) {
                            if (!n.children("." + s.search).length) {
                                var i = l.__valueOrFn(c.clear, n)
                                  , a = l.__valueOrFn(c.form, n)
                                  , r = l.__valueOrFn(c.input, n)
                                  , h = l.__valueOrFn(c.submit, n)
                                  , u = e("<" + (a ? "form" : "div") + ' class="' + s.search + '" />')
                                  , f = e('<input placeholder="' + e[t].i18n(d.placeholder) + '" type="text" autocomplete="off" />');
                                u.append(f);
                                var p;
                                if (r)
                                    for (p in r)
                                        f.attr(p, r[p]);
                                if (i && e('<a class="' + s.btn + " " + s.clear + '" href="#" />').appendTo(u).on(o.click + "-searchfield", function(e) {
                                    e.preventDefault(),
                                    f.val("").trigger(o.keyup + "-searchfield")
                                }),
                                a) {
                                    for (p in a)
                                        u.attr(p, a[p]);
                                    h && !i && e('<a class="' + s.btn + " " + s.next + '" href="#" />').appendTo(u).on(o.click + "-searchfield", function(e) {
                                        e.preventDefault(),
                                        u.submit()
                                    })
                                }
                                n.hasClass(s.search) ? n.replaceWith(u) : n.prepend(u).addClass(s.hassearch)
                            }
                            if (d.noResults) {
                                var v = n.closest("." + s.panel).length;
                                if (v || (n = l.$pnls.children("." + s.panel).first()),
                                !n.children("." + s.noresultsmsg).length) {
                                    var m = n.children("." + s.listview).first();
                                    e('<div class="' + s.noresultsmsg + " " + s.hidden + '" />').append(e[t].i18n(d.noResults))[m.length ? "insertAfter" : "prependTo"](m.length ? m : n)
                                }
                            }
                        }
                    }),
                    d.search) {
                        if (d.resultsPanel.add) {
                            d.showSubPanels = !1;
                            var u = this.$pnls.children("." + s.resultspanel);
                            u.length || (u = e('<div class="' + s.panel + " " + s.resultspanel + " " + s.hidden + '" />').appendTo(this.$pnls).append('<div class="' + s.navbar + " " + s.hidden + '"><a class="' + s.title + '">' + e[t].i18n(d.resultsPanel.title) + "</a></div>").append('<ul class="' + s.listview + '" />').append(this.$pnls.find("." + s.noresultsmsg).first().clone()),
                            this.initPanels(u))
                        }
                        this.$menu.find("." + s.search).each(function() {
                            var t, r, c = e(this), h = c.closest("." + s.panel).length;
                            h ? (t = c.closest("." + s.panel),
                            r = t) : (t = e("." + s.panel, l.$menu),
                            r = l.$menu),
                            d.resultsPanel.add && (t = t.not(u));
                            var f = c.children("input")
                              , p = l.__findAddBack(t, "." + s.listview).children("li")
                              , v = p.filter("." + s.divider)
                              , m = l.__filterListItems(p)
                              , g = "a"
                              , b = g + ", span"
                              , _ = ""
                              , C = function() {
                                var n = f.val().toLowerCase();
                                if (n != _) {
                                    if (_ = n,
                                    d.resultsPanel.add && u.children("." + s.listview).empty(),
                                    t.scrollTop(0),
                                    m.add(v).addClass(s.hidden).find("." + s.fullsubopensearch).removeClass(s.fullsubopen + " " + s.fullsubopensearch),
                                    m.each(function() {
                                        var n = e(this)
                                          , t = g;
                                        (d.showTextItems || d.showSubPanels && n.find("." + s.next)) && (t = b);
                                        var i = n.data(a.searchtext) || n.children(t).text();
                                        i.toLowerCase().indexOf(_) > -1 && n.add(n.prevAll("." + s.divider).first()).removeClass(s.hidden)
                                    }),
                                    d.showSubPanels && t.each(function(n) {
                                        var t = e(this);
                                        l.__filterListItems(t.find("." + s.listview).children()).each(function() {
                                            var n = e(this)
                                              , t = n.data(a.child);
                                            n.removeClass(s.nosubresults),
                                            t && t.find("." + s.listview).children().removeClass(s.hidden)
                                        })
                                    }),
                                    d.resultsPanel.add)
                                        if ("" === _)
                                            this.closeAllPanels(),
                                            this.openPanel(this.$pnls.children("." + s.subopened).last());
                                        else {
                                            var i = e();
                                            t.each(function() {
                                                var n = l.__filterListItems(e(this).find("." + s.listview).children()).not("." + s.hidden).clone(!0);
                                                n.length && (d.resultsPanel.dividers && (i = i.add('<li class="' + s.divider + '">' + e(this).children("." + s.navbar).text() + "</li>")),
                                                i = i.add(n))
                                            }),
                                            i.find("." + s.next).remove(),
                                            u.children("." + s.listview).append(i),
                                            this.openPanel(u)
                                        }
                                    else
                                        e(t.get().reverse()).each(function(n) {
                                            var t = e(this)
                                              , i = t.data(a.parent);
                                            i && (l.__filterListItems(t.find("." + s.listview).children()).length ? (i.hasClass(s.hidden) && i.children("." + s.next).not("." + s.fullsubopen).addClass(s.fullsubopen).addClass(s.fullsubopensearch),
                                            i.removeClass(s.hidden).removeClass(s.nosubresults).prevAll("." + s.divider).first().removeClass(s.hidden)) : h || (t.hasClass(s.opened) && setTimeout(function() {
                                                l.openPanel(i.closest("." + s.panel))
                                            }, (n + 1) * (1.5 * l.conf.openingInterval)),
                                            i.addClass(s.nosubresults)))
                                        });
                                    r.find("." + s.noresultsmsg)[m.not("." + s.hidden).length ? "addClass" : "removeClass"](s.hidden),
                                    this.update()
                                }
                            };
                            f.off(o.keyup + "-" + i + " " + o.change + "-" + i).on(o.keyup + "-" + i, function(e) {
                                n(e.keyCode) || C.call(l)
                            }).on(o.change + "-" + i, function(e) {
                                C.call(l)
                            });
                            var y = c.children("." + s.btn);
                            y.length && f.on(o.keyup + "-" + i, function(e) {
                                y[f.val().length ? "removeClass" : "addClass"](s.hidden)
                            }),
                            f.trigger(o.keyup + "-" + i)
                        })
                    }
                }
            })
        },
        add: function() {
            s = e[t]._c,
            a = e[t]._d,
            o = e[t]._e,
            s.add("clear search hassearch resultspanel noresultsmsg noresults nosubresults fullsubopensearch"),
            a.add("searchtext"),
            o.add("change keyup")
        },
        clickAnchor: function(e, n) {}
    },
    e[t].defaults[i] = {
        add: !1,
        addTo: "panels",
        placeholder: "Search",
        noResults: "No results found.",
        resultsPanel: {
            add: !1,
            dividers: !0,
            title: "Search results"
        },
        search: !0,
        showTextItems: !1,
        showSubPanels: !0
    },
    e[t].configuration[i] = {
        clear: !1,
        form: !1,
        input: !1,
        submit: !1
    };
    var s, a, o, r
}(jQuery)
/*

/*
 * jQuery mmenu fixedElements add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(s) {
    var i = "mmenu"
      , t = "fixedElements";
    s[i].addons[t] = {
        setup: function() {
            if (this.opts.offCanvas) {
                var n = this.opts[t];
                this.conf[t];
                d = s[i].glbl,
                n = this.opts[t] = s.extend(!0, {}, s[i].defaults[t], n);
                var a = function(s) {
                    var i = this.conf.classNames[t].fixed;
                    this.__refactorClass(s.find("." + i), i, "slideout").appendTo(d.$body)
                };
                a.call(this, d.$page),
                this.bind("setPage", a)
            }
        },
        add: function() {
            n = s[i]._c,
            a = s[i]._d,
            e = s[i]._e,
            n.add("fixed")
        },
        clickAnchor: function(s, i) {}
    },
    s[i].configuration.classNames[t] = {
        fixed: "Fixed"
    };
    var n, a, e, d
}(jQuery);

/*
 * jQuery mmenu navbar add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(n) {
    var a = "mmenu"
      , t = "navbars";
    n[a].addons[t] = {
        setup: function() {
            var r = this
              , s = this.opts[t]
              , c = this.conf[t];
            if (i = n[a].glbl,
            "undefined" != typeof s) {
                s instanceof Array || (s = [s]);
                var o = {};
                if (s.length) {
                    n.each(s, function(i) {
                        var l = s[i];
                        "boolean" == typeof l && l && (l = {}),
                        "object" != typeof l && (l = {}),
                        "undefined" == typeof l.content && (l.content = ["prev", "title"]),
                        l.content instanceof Array || (l.content = [l.content]),
                        l = n.extend(!0, {}, r.opts.navbar, l);
                        var d = l.position
                          , h = l.height;
                        "number" != typeof h && (h = 1),
                        h = Math.min(4, Math.max(1, h)),
                        "bottom" != d && (d = "top"),
                        o[d] || (o[d] = 0),
                        o[d]++;
                        var f = n("<div />").addClass(e.navbar + " " + e.navbar + "-" + d + " " + e.navbar + "-" + d + "-" + o[d] + " " + e.navbar + "-size-" + h);
                        o[d] += h - 1;
                        for (var v = 0, u = 0, p = l.content.length; u < p; u++) {
                            var b = n[a].addons[t][l.content[u]] || !1;
                            b ? v += b.call(r, f, l, c) : (b = l.content[u],
                            b instanceof n || (b = n(l.content[u])),
                            f.append(b))
                        }
                        v += Math.ceil(f.children().not("." + e.btn).length / h),
                        v > 1 && f.addClass(e.navbar + "-content-" + v),
                        f.children("." + e.btn).length && f.addClass(e.hasbtns),
                        f.prependTo(r.$menu)
                    });
                    for (var l in o)
                        r.$menu.addClass(e.hasnavbar + "-" + l + "-" + o[l])
                }
            }
        },
        add: function() {
            e = n[a]._c,
            r = n[a]._d,
            s = n[a]._e,
            e.add("close hasbtns")
        },
        clickAnchor: function(n, a) {}
    },
    n[a].configuration[t] = {
        breadcrumbSeparator: "/"
    },
    n[a].configuration.classNames[t] = {};
    var e, r, s, i
}(jQuery),
/*
 * jQuery mmenu navbar add-on breadcrumbs content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "breadcrumbs";
    n[a].addons[t][e] = function(t, e, r) {
        var s = n[a]._c
          , i = n[a]._d;
        s.add("breadcrumbs separator");
        var c = n('<span class="' + s.breadcrumbs + '" />').appendTo(t);
        this.bind("initPanels", function(a) {
            a.removeClass(s.hasnavbar).each(function() {
                for (var a = [], t = n(this), e = n('<span class="' + s.breadcrumbs + '"></span>'), c = n(this).children().first(), o = !0; c && c.length; ) {
                    c.is("." + s.panel) || (c = c.closest("." + s.panel));
                    var l = c.children("." + s.navbar).children("." + s.title).text();
                    a.unshift(o ? "<span>" + l + "</span>" : '<a href="#' + c.attr("id") + '">' + l + "</a>"),
                    o = !1,
                    c = c.data(i.parent)
                }
                e.append(a.join('<span class="' + s.separator + '">' + r.breadcrumbSeparator + "</span>")).appendTo(t.children("." + s.navbar))
            })
        });
        var o = function() {
            c.html(this.$pnls.children("." + s.current).children("." + s.navbar).children("." + s.breadcrumbs).html())
        };
        return this.bind("openPanel", o),
        this.bind("initPanels", o),
        0
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on close content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "close";
    n[a].addons[t][e] = function(t, e) {
        var r = n[a]._c
          , s = n[a].glbl
          , i = n('<a class="' + r.close + " " + r.btn + '" href="#" />').appendTo(t)
          , c = function(n) {
            i.attr("href", "#" + n.attr("id"))
        };
        return c.call(this, s.$page),
        this.bind("setPage", c),
        -1
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on next content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "next";
    n[a].addons[t][e] = function(e, r) {
        var s, i, c, o = n[a]._c, l = n('<a class="' + o.next + " " + o.btn + '" href="#" />').appendTo(e), d = function(n) {
            n = n || this.$pnls.children("." + o.current);
            var a = n.find("." + this.conf.classNames[t].panelNext);
            s = a.attr("href"),
            c = a.attr("aria-owns"),
            i = a.html(),
            l[s ? "attr" : "removeAttr"]("href", s),
            l[c ? "attr" : "removeAttr"]("aria-owns", c),
            l[s || i ? "removeClass" : "addClass"](o.hidden),
            l.html(i)
        };
        return this.bind("openPanel", d),
        this.bind("initPanels", function() {
            d.call(this)
        }),
        -1
    }
    ,
    n[a].configuration.classNames[t].panelNext = "Next"
}(jQuery),
/*
 * jQuery mmenu navbar add-on prev content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "prev";
    n[a].addons[t][e] = function(e, r) {
        var s = n[a]._c
          , i = n('<a class="' + s.prev + " " + s.btn + '" href="#" />').appendTo(e);
        this.bind("initPanels", function(n) {
            n.removeClass(s.hasnavbar).children("." + s.navbar).addClass(s.hidden)
        });
        var c, o, l, d = function(n) {
            if (n = n || this.$pnls.children("." + s.current),
            !n.hasClass(s.vertical)) {
                var a = n.find("." + this.conf.classNames[t].panelPrev);
                a.length || (a = n.children("." + s.navbar).children("." + s.prev)),
                c = a.attr("href"),
                l = a.attr("aria-owns"),
                o = a.html(),
                i[c ? "attr" : "removeAttr"]("href", c),
                i[l ? "attr" : "removeAttr"]("aria-owns", l),
                i[c || o ? "removeClass" : "addClass"](s.hidden),
                i.html(o)
            }
        };
        return this.bind("openPanel", d),
        this.bind("initPanels", function() {
            d.call(this)
        }),
        -1
    }
    ,
    n[a].configuration.classNames[t].panelPrev = "Prev"
}(jQuery),
/*
 * jQuery mmenu navbar add-on searchfield content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "searchfield";
    n[a].addons[t][e] = function(t, e) {
        var r = n[a]._c
          , s = n('<div class="' + r.search + '" />').appendTo(t);
        return "object" != typeof this.opts.searchfield && (this.opts.searchfield = {}),
        this.opts.searchfield.add = !0,
        this.opts.searchfield.addTo = s,
        0
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on title content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "title";
    n[a].addons[t][e] = function(e, r) {
        var s, i, c = n[a]._c, o = n('<a class="' + c.title + '" />').appendTo(e), l = function(n) {
            if (n = n || this.$pnls.children("." + c.current),
            !n.hasClass(c.vertical)) {
                var a = n.find("." + this.conf.classNames[t].panelTitle);
                a.length || (a = n.children("." + c.navbar).children("." + c.title)),
                s = a.attr("href"),
                i = a.html() || r.title,
                o[s ? "attr" : "removeAttr"]("href", s),
                o[s || i ? "removeClass" : "addClass"](c.hidden),
                o.html(i)
            }
        };
        return this.bind("openPanel", l),
        this.bind("initPanels", function(n) {
            l.call(this)
        }),
        0
    }
    ,
    n[a].configuration.classNames[t].panelTitle = "Title"
}(jQuery);

/*
 * jQuery mmenu screenReader add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(i) {
    var t = "mmenu"
      , n = "screenReader";
    i[t].addons[n] = {
        setup: function() {
            var a = this
              , h = this.opts[n]
              , o = this.conf[n];
            s = i[t].glbl,
            "boolean" == typeof h && (h = {
                aria: h,
                text: h
            }),
            "object" != typeof h && (h = {}),
            h = this.opts[n] = i.extend(!0, {}, i[t].defaults[n], h),
            h.aria && (this.bind("initAddons:after", function() {
                this.bind("initMenu:after", function() {
                    this.trigger("initMenu:after:sr-aria")
                }),
                this.bind("initNavbar:after", function() {
                    this.trigger("initNavbar:after:sr-aria", arguments[0])
                }),
                this.bind("openPanel:start", function() {
                    this.trigger("openPanel:start:sr-aria", arguments[0])
                }),
                this.bind("close:start", function() {
                    this.trigger("close:start:sr-aria")
                }),
                this.bind("close:finish", function() {
                    this.trigger("close:finish:sr-aria")
                }),
                this.bind("open:start", function() {
                    this.trigger("open:start:sr-aria")
                }),
                this.bind("open:finish", function() {
                    this.trigger("open:finish:sr-aria")
                })
            }),
            this.bind("updateListview", function() {
                this.$pnls.find("." + e.listview).children().each(function() {
                    a.__sr_aria(i(this), "hidden", i(this).is("." + e.hidden))
                })
            }),
            this.bind("openPanel:start", function(i) {
                var t = this.$menu.find("." + e.panel).not(i).not(i.parents("." + e.panel))
                  , n = i.add(i.find("." + e.vertical + "." + e.opened).children("." + e.panel));
                this.__sr_aria(t, "hidden", !0),
                this.__sr_aria(n, "hidden", !1)
            }),
            this.bind("closePanel", function(i) {
                this.__sr_aria(i, "hidden", !0)
            }),
            this.bind("initPanels:after", function(t) {
                var n = t.find("." + e.prev + ", ." + e.next).each(function() {
                    a.__sr_aria(i(this), "owns", i(this).attr("href").replace("#", ""))
                });
                this.__sr_aria(n, "haspopup", !0)
            }),
            this.bind("initNavbar:after", function(i) {
                var t = i.children("." + e.navbar);
                this.__sr_aria(t, "hidden", !i.hasClass(e.hasnavbar))
            }),
            h.text && (this.bind("initlistview:after", function(i) {
                var t = i.find("." + e.listview).find("." + e.fullsubopen).parent().children("span");
                this.__sr_aria(t, "hidden", !0)
            }),
            "parent" == this.opts.navbar.titleLink && this.bind("initNavbar:after", function(i) {
                var t = i.children("." + e.navbar)
                  , n = !!t.children("." + e.prev).length;
                this.__sr_aria(t.children("." + e.title), "hidden", n)
            }))),
            h.text && (this.bind("initAddons:after", function() {
                this.bind("setPage:after", function() {
                    this.trigger("setPage:after:sr-text", arguments[0])
                })
            }),
            this.bind("initNavbar:after", function(n) {
                var r = n.children("." + e.navbar)
                  , a = r.children("." + e.title).text()
                  , s = i[t].i18n(o.text.closeSubmenu);
                a && (s += " (" + a + ")"),
                r.children("." + e.prev).html(this.__sr_text(s))
            }),
            this.bind("initListview:after", function(n) {
                var s = n.data(r.parent);
                if (s && s.length) {
                    var h = s.children("." + e.next)
                      , d = h.nextAll("span, a").first().text()
                      , f = i[t].i18n(o.text[h.parent().is("." + e.vertical) ? "toggleSubmenu" : "openSubmenu"]);
                    d && (f += " (" + d + ")"),
                    h.html(a.__sr_text(f))
                }
            }))
        },
        add: function() {
            e = i[t]._c,
            r = i[t]._d,
            a = i[t]._e,
            e.add("sronly")
        },
        clickAnchor: function(i, t) {}
    },
    i[t].defaults[n] = {
        aria: !0,
        text: !0
    },
    i[t].configuration[n] = {
        text: {
            closeMenu: "Close menu",
            closeSubmenu: "Close submenu",
            openSubmenu: "Open submenu",
            toggleSubmenu: "Toggle submenu"
        }
    },
    i[t].prototype.__sr_aria = function(i, t, n) {
        i.prop("aria-" + t, n)[n ? "attr" : "removeAttr"]("aria-" + t, n)
    }
    ,
    i[t].prototype.__sr_text = function(i) {
        return '<span class="' + e.sronly + '">' + i + "</span>"
    }
    ;
    var e, r, a, s
}(jQuery);

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
}
;

/*!
 * jQuery Smooth Scroll - v2.2.0 - 2017-05-05
 * https://github.com/kswedberg/jquery-smooth-scroll
 * Copyright (c) 2017 Karl Swedberg
 * Licensed MIT
 */

!function(a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof module && module.exports ? require("jquery") : jQuery)
}(function(a) {
    var b = {}
      , c = {
        exclude: [],
        excludeWithin: [],
        offset: 0,
        direction: "top",
        delegateSelector: null,
        scrollElement: null,
        scrollTarget: null,
        autoFocus: !1,
        beforeScroll: function() {},
        afterScroll: function() {},
        easing: "swing",
        speed: 400,
        autoCoefficient: 2,
        preventDefault: !0
    }
      , d = function(b) {
        var c = []
          , d = !1
          , e = b.dir && "left" === b.dir ? "scrollLeft" : "scrollTop";
        return this.each(function() {
            var b = a(this);
            if (this !== document && this !== window)
                return !document.scrollingElement || this !== document.documentElement && this !== document.body ? void (b[e]() > 0 ? c.push(this) : (b[e](1),
                d = b[e]() > 0,
                d && c.push(this),
                b[e](0))) : (c.push(document.scrollingElement),
                !1)
        }),
        c.length || this.each(function() {
            this === document.documentElement && "smooth" === a(this).css("scrollBehavior") && (c = [this]),
            c.length || "BODY" !== this.nodeName || (c = [this])
        }),
        "first" === b.el && c.length > 1 && (c = [c[0]]),
        c
    }
      , e = /^([\-\+]=)(\d+)/;
    a.fn.extend({
        scrollable: function(a) {
            var b = d.call(this, {
                dir: a
            });
            return this.pushStack(b)
        },
        firstScrollable: function(a) {
            var b = d.call(this, {
                el: "first",
                dir: a
            });
            return this.pushStack(b)
        },
        smoothScroll: function(b, c) {
            if ("options" === (b = b || {}))
                return c ? this.each(function() {
                    var b = a(this)
                      , d = a.extend(b.data("ssOpts") || {}, c);
                    a(this).data("ssOpts", d)
                }) : this.first().data("ssOpts");
            var d = a.extend({}, a.fn.smoothScroll.defaults, b)
              , e = function(b) {
                var c = function(a) {
                    return a.replace(/(:|\.|\/)/g, "\\$1")
                }
                  , e = this
                  , f = a(this)
                  , g = a.extend({}, d, f.data("ssOpts") || {})
                  , h = d.exclude
                  , i = g.excludeWithin
                  , j = 0
                  , k = 0
                  , l = !0
                  , m = {}
                  , n = a.smoothScroll.filterPath(location.pathname)
                  , o = a.smoothScroll.filterPath(e.pathname)
                  , p = location.hostname === e.hostname || !e.hostname
                  , q = g.scrollTarget || o === n
                  , r = c(e.hash);
                if (r && !a(r).length && (l = !1),
                g.scrollTarget || p && q && r) {
                    for (; l && j < h.length; )
                        f.is(c(h[j++])) && (l = !1);
                    for (; l && k < i.length; )
                        f.closest(i[k++]).length && (l = !1)
                } else
                    l = !1;
                l && (g.preventDefault && b.preventDefault(),
                a.extend(m, g, {
                    scrollTarget: g.scrollTarget || r,
                    link: e
                }),
                a.smoothScroll(m))
            };
            return null !== b.delegateSelector ? this.off("click.smoothscroll", b.delegateSelector).on("click.smoothscroll", b.delegateSelector, e) : this.off("click.smoothscroll").on("click.smoothscroll", e),
            this
        }
    });
    var f = function(a) {
        var b = {
            relative: ""
        }
          , c = "string" == typeof a && e.exec(a);
        return "number" == typeof a ? b.px = a : c && (b.relative = c[1],
        b.px = parseFloat(c[2]) || 0),
        b
    }
      , g = function(b) {
        var c = a(b.scrollTarget);
        b.autoFocus && c.length && (c[0].focus(),
        c.is(document.activeElement) || (c.prop({
            tabIndex: -1
        }),
        c[0].focus())),
        b.afterScroll.call(b.link, b)
    };
    a.smoothScroll = function(c, d) {
        if ("options" === c && "object" == typeof d)
            return a.extend(b, d);
        var e, h, i, j, k = f(c), l = {}, m = 0, n = "offset", o = "scrollTop", p = {}, q = {};
        k.px ? e = a.extend({
            link: null
        }, a.fn.smoothScroll.defaults, b) : (e = a.extend({
            link: null
        }, a.fn.smoothScroll.defaults, c || {}, b),
        e.scrollElement && (n = "position",
        "static" === e.scrollElement.css("position") && e.scrollElement.css("position", "relative")),
        d && (k = f(d))),
        o = "left" === e.direction ? "scrollLeft" : o,
        e.scrollElement ? (h = e.scrollElement,
        k.px || /^(?:HTML|BODY)$/.test(h[0].nodeName) || (m = h[o]())) : h = a("html, body").firstScrollable(e.direction),
        e.beforeScroll.call(h, e),
        l = k.px ? k : {
            relative: "",
            px: a(e.scrollTarget)[n]() && a(e.scrollTarget)[n]()[e.direction] || 0
        },
        p[o] = l.relative + (l.px + m + e.offset),
        i = e.speed,
        "auto" === i && (j = Math.abs(p[o] - h[o]()),
        i = j / e.autoCoefficient),
        q = {
            duration: i,
            easing: e.easing,
            complete: function() {
                g(e)
            }
        },
        e.step && (q.step = e.step),
        h.length ? h.stop().animate(p, q) : g(e)
    }
    ,
    a.smoothScroll.version = "2.2.0",
    a.smoothScroll.filterPath = function(a) {
        return a = a || "",
        a.replace(/^\//, "").replace(/(?:index|default).[a-zA-Z]{3,4}$/, "").replace(/\/$/, "")
    }
    ,
    a.fn.smoothScroll.defaults = c
});

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function() {
    "use strict";
    function t(o) {
        if (!o)
            throw new Error("No options passed to Waypoint constructor");
        if (!o.element)
            throw new Error("No element option passed to Waypoint constructor");
        if (!o.handler)
            throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e,
        this.options = t.Adapter.extend({}, t.defaults, o),
        this.element = this.options.element,
        this.adapter = new t.Adapter(this.element),
        this.callback = o.handler,
        this.axis = this.options.horizontal ? "horizontal" : "vertical",
        this.enabled = this.options.enabled,
        this.triggerPoint = null,
        this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }),
        this.context = t.Context.findOrCreateByElement(this.options.context),
        t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        i[this.key] = this,
        e += 1
    }
    var e = 0
      , i = {};
    t.prototype.queueTrigger = function(t) {
        this.group.queueTrigger(this, t)
    }
    ,
    t.prototype.trigger = function(t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }
    ,
    t.prototype.destroy = function() {
        this.context.remove(this),
        this.group.remove(this),
        delete i[this.key]
    }
    ,
    t.prototype.disable = function() {
        return this.enabled = !1,
        this
    }
    ,
    t.prototype.enable = function() {
        return this.context.refresh(),
        this.enabled = !0,
        this
    }
    ,
    t.prototype.next = function() {
        return this.group.next(this)
    }
    ,
    t.prototype.previous = function() {
        return this.group.previous(this)
    }
    ,
    t.invokeAll = function(t) {
        var e = [];
        for (var o in i)
            e.push(i[o]);
        for (var n = 0, r = e.length; r > n; n++)
            e[n][t]()
    }
    ,
    t.destroyAll = function() {
        t.invokeAll("destroy")
    }
    ,
    t.disableAll = function() {
        t.invokeAll("disable")
    }
    ,
    t.enableAll = function() {
        t.Context.refreshAll();
        for (var e in i)
            i[e].enabled = !0;
        return this
    }
    ,
    t.refreshAll = function() {
        t.Context.refreshAll()
    }
    ,
    t.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight
    }
    ,
    t.viewportWidth = function() {
        return document.documentElement.clientWidth
    }
    ,
    t.adapters = [],
    t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    },
    t.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight()
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    },
    window.Waypoint = t
}(),
function() {
    "use strict";
    function t(t) {
        window.setTimeout(t, 1e3 / 60)
    }
    function e(t) {
        this.element = t,
        this.Adapter = n.Adapter,
        this.adapter = new this.Adapter(t),
        this.key = "waypoint-context-" + i,
        this.didScroll = !1,
        this.didResize = !1,
        this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        },
        this.waypoints = {
            vertical: {},
            horizontal: {}
        },
        t.waypointContextKey = this.key,
        o[t.waypointContextKey] = this,
        i += 1,
        n.windowContext || (n.windowContext = !0,
        n.windowContext = new e(window)),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var i = 0
      , o = {}
      , n = window.Waypoint
      , r = window.onload;
    e.prototype.add = function(t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t,
        this.refresh()
    }
    ,
    e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal)
          , e = this.Adapter.isEmptyObject(this.waypoints.vertical)
          , i = this.element == this.element.window;
        t && e && !i && (this.adapter.off(".waypoints"),
        delete o[this.key])
    }
    ,
    e.prototype.createThrottledResizeHandler = function() {
        function t() {
            e.handleResize(),
            e.didResize = !1
        }
        var e = this;
        this.adapter.on("resize.waypoints", function() {
            e.didResize || (e.didResize = !0,
            n.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.createThrottledScrollHandler = function() {
        function t() {
            e.handleScroll(),
            e.didScroll = !1
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function() {
            (!e.didScroll || n.isTouch) && (e.didScroll = !0,
            n.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.handleResize = function() {
        n.Context.refreshAll()
    }
    ,
    e.prototype.handleScroll = function() {
        var t = {}
          , e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var i in e) {
            var o = e[i]
              , n = o.newScroll > o.oldScroll
              , r = n ? o.forward : o.backward;
            for (var s in this.waypoints[i]) {
                var a = this.waypoints[i][s];
                if (null !== a.triggerPoint) {
                    var l = o.oldScroll < a.triggerPoint
                      , h = o.newScroll >= a.triggerPoint
                      , p = l && h
                      , u = !l && !h;
                    (p || u) && (a.queueTrigger(r),
                    t[a.group.id] = a.group)
                }
            }
        }
        for (var c in t)
            t[c].flushTriggers();
        this.oldScroll = {
            x: e.horizontal.newScroll,
            y: e.vertical.newScroll
        }
    }
    ,
    e.prototype.innerHeight = function() {
        return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
    }
    ,
    e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key],
        this.checkEmpty()
    }
    ,
    e.prototype.innerWidth = function() {
        return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
    }
    ,
    e.prototype.destroy = function() {
        var t = [];
        for (var e in this.waypoints)
            for (var i in this.waypoints[e])
                t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; n > o; o++)
            t[o].destroy()
    }
    ,
    e.prototype.refresh = function() {
        var t, e = this.element == this.element.window, i = e ? void 0 : this.adapter.offset(), o = {};
        this.handleScroll(),
        t = {
            horizontal: {
                contextOffset: e ? 0 : i.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: e ? 0 : i.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for (var r in t) {
            var s = t[r];
            for (var a in this.waypoints[r]) {
                var l, h, p, u, c, d = this.waypoints[r][a], f = d.options.offset, w = d.triggerPoint, y = 0, g = null == w;
                d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]),
                "function" == typeof f ? f = f.apply(d) : "string" == typeof f && (f = parseFloat(f),
                d.options.offset.indexOf("%") > -1 && (f = Math.ceil(s.contextDimension * f / 100))),
                l = s.contextScroll - s.contextOffset,
                d.triggerPoint = Math.floor(y + l - f),
                h = w < s.oldScroll,
                p = d.triggerPoint >= s.oldScroll,
                u = h && p,
                c = !h && !p,
                !g && u ? (d.queueTrigger(s.backward),
                o[d.group.id] = d.group) : !g && c ? (d.queueTrigger(s.forward),
                o[d.group.id] = d.group) : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward),
                o[d.group.id] = d.group)
            }
        }
        return n.requestAnimationFrame(function() {
            for (var t in o)
                o[t].flushTriggers()
        }),
        this
    }
    ,
    e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t)
    }
    ,
    e.refreshAll = function() {
        for (var t in o)
            o[t].refresh()
    }
    ,
    e.findByElement = function(t) {
        return o[t.waypointContextKey]
    }
    ,
    window.onload = function() {
        r && r(),
        e.refreshAll()
    }
    ,
    n.requestAnimationFrame = function(e) {
        var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
        i.call(window, e)
    }
    ,
    n.Context = e
}(),
function() {
    "use strict";
    function t(t, e) {
        return t.triggerPoint - e.triggerPoint
    }
    function e(t, e) {
        return e.triggerPoint - t.triggerPoint
    }
    function i(t) {
        this.name = t.name,
        this.axis = t.axis,
        this.id = this.name + "-" + this.axis,
        this.waypoints = [],
        this.clearTriggerQueues(),
        o[this.axis][this.name] = this
    }
    var o = {
        vertical: {},
        horizontal: {}
    }
      , n = window.Waypoint;
    i.prototype.add = function(t) {
        this.waypoints.push(t)
    }
    ,
    i.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        }
    }
    ,
    i.prototype.flushTriggers = function() {
        for (var i in this.triggerQueues) {
            var o = this.triggerQueues[i]
              , n = "up" === i || "left" === i;
            o.sort(n ? e : t);
            for (var r = 0, s = o.length; s > r; r += 1) {
                var a = o[r];
                (a.options.continuous || r === o.length - 1) && a.trigger([i])
            }
        }
        this.clearTriggerQueues()
    }
    ,
    i.prototype.next = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints)
          , o = i === this.waypoints.length - 1;
        return o ? null : this.waypoints[i + 1]
    }
    ,
    i.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null
    }
    ,
    i.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t)
    }
    ,
    i.prototype.remove = function(t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1)
    }
    ,
    i.prototype.first = function() {
        return this.waypoints[0]
    }
    ,
    i.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1]
    }
    ,
    i.findOrCreate = function(t) {
        return o[t.axis][t.name] || new i(t)
    }
    ,
    n.Group = i
}(),
function() {
    "use strict";
    function t(t) {
        this.$element = e(t)
    }
    var e = window.jQuery
      , i = window.Waypoint;
    e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(e, i) {
        t.prototype[i] = function() {
            var t = Array.prototype.slice.call(arguments);
            return this.$element[i].apply(this.$element, t)
        }
    }),
    e.each(["extend", "inArray", "isEmptyObject"], function(i, o) {
        t[o] = e[o]
    }),
    i.adapters.push({
        name: "jquery",
        Adapter: t
    }),
    i.Adapter = t
}(),
function() {
    "use strict";
    function t(t) {
        return function() {
            var i = []
              , o = arguments[0];
            return t.isFunction(arguments[0]) && (o = t.extend({}, arguments[1]),
            o.handler = arguments[0]),
            this.each(function() {
                var n = t.extend({}, o, {
                    element: this
                });
                "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]),
                i.push(new e(n))
            }),
            i
        }
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
    window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}();

/*! skrollr 0.6.30 (2015-08-12) | Alexander Prinzhorn - https://github.com/Prinzhorn/skrollr | Free to use under terms of MIT license */
!function(a, b, c) {
    "use strict";
    function d(c) {
        if (e = b.documentElement,
        f = b.body,
        T(),
        ha = this,
        c = c || {},
        ma = c.constants || {},
        c.easing)
            for (var d in c.easing)
                W[d] = c.easing[d];
        ta = c.edgeStrategy || "set",
        ka = {
            beforerender: c.beforerender,
            render: c.render,
            keyframe: c.keyframe
        },
        la = c.forceHeight !== !1,
        la && (Ka = c.scale || 1),
        na = c.mobileDeceleration || y,
        pa = c.smoothScrolling !== !1,
        qa = c.smoothScrollingDuration || A,
        ra = {
            targetTop: ha.getScrollTop()
        },
        Sa = (c.mobileCheck || function() {
            return /Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || a.opera)
        }
        )(),
        Sa ? (ja = b.getElementById(c.skrollrBody || z),
        ja && ga(),
        X(),
        Ea(e, [s, v], [t])) : Ea(e, [s, u], [t]),
        ha.refresh(),
        wa(a, "resize orientationchange", function() {
            var a = e.clientWidth
              , b = e.clientHeight;
            (b !== Pa || a !== Oa) && (Pa = b,
            Oa = a,
            Qa = !0)
        });
        var g = U();
        return function h() {
            $(),
            va = g(h)
        }(),
        ha
    }
    var e, f, g = {
        get: function() {
            return ha
        },
        init: function(a) {
            return ha || new d(a)
        },
        VERSION: "0.6.30"
    }, h = Object.prototype.hasOwnProperty, i = a.Math, j = a.getComputedStyle, k = "touchstart", l = "touchmove", m = "touchcancel", n = "touchend", o = "skrollable", p = o + "-before", q = o + "-between", r = o + "-after", s = "skrollr", t = "no-" + s, u = s + "-desktop", v = s + "-mobile", w = "linear", x = 1e3, y = .004, z = "skrollr-body", A = 200, B = "start", C = "end", D = "center", E = "bottom", F = "___skrollable_id", G = /^(?:input|textarea|button|select)$/i, H = /^\s+|\s+$/g, I = /^data(?:-(_\w+))?(?:-?(-?\d*\.?\d+p?))?(?:-?(start|end|top|center|bottom))?(?:-?(top|center|bottom))?$/, J = /\s*(@?[\w\-\[\]]+)\s*:\s*(.+?)\s*(?:;|$)/gi, K = /^(@?[a-z\-]+)\[(\w+)\]$/, L = /-([a-z0-9_])/g, M = function(a, b) {
        return b.toUpperCase()
    }, N = /[\-+]?[\d]*\.?[\d]+/g, O = /\{\?\}/g, P = /rgba?\(\s*-?\d+\s*,\s*-?\d+\s*,\s*-?\d+/g, Q = /[a-z\-]+-gradient/g, R = "", S = "", T = function() {
        var a = /^(?:O|Moz|webkit|ms)|(?:-(?:o|moz|webkit|ms)-)/;
        if (j) {
            var b = j(f, null);
            for (var c in b)
                if (R = c.match(a) || +c == c && b[c].match(a))
                    break;
            if (!R)
                return void (R = S = "");
            R = R[0],
            "-" === R.slice(0, 1) ? (S = R,
            R = {
                "-webkit-": "webkit",
                "-moz-": "Moz",
                "-ms-": "ms",
                "-o-": "O"
            }[R]) : S = "-" + R.toLowerCase() + "-"
        }
    }, U = function() {
        var b = a.requestAnimationFrame || a[R.toLowerCase() + "RequestAnimationFrame"]
          , c = Ha();
        return (Sa || !b) && (b = function(b) {
            var d = Ha() - c
              , e = i.max(0, 1e3 / 60 - d);
            return a.setTimeout(function() {
                c = Ha(),
                b()
            }, e)
        }
        ),
        b
    }, V = function() {
        var b = a.cancelAnimationFrame || a[R.toLowerCase() + "CancelAnimationFrame"];
        return (Sa || !b) && (b = function(b) {
            return a.clearTimeout(b)
        }
        ),
        b
    }, W = {
        begin: function() {
            return 0
        },
        end: function() {
            return 1
        },
        linear: function(a) {
            return a
        },
        quadratic: function(a) {
            return a * a
        },
        cubic: function(a) {
            return a * a * a
        },
        swing: function(a) {
            return -i.cos(a * i.PI) / 2 + .5
        },
        sqrt: function(a) {
            return i.sqrt(a)
        },
        outCubic: function(a) {
            return i.pow(a - 1, 3) + 1
        },
        bounce: function(a) {
            var b;
            if (.5083 >= a)
                b = 3;
            else if (.8489 >= a)
                b = 9;
            else if (.96208 >= a)
                b = 27;
            else {
                if (!(.99981 >= a))
                    return 1;
                b = 91
            }
            return 1 - i.abs(3 * i.cos(a * b * 1.028) / b)
        }
    };
    d.prototype.refresh = function(a) {
        var d, e, f = !1;
        for (a === c ? (f = !0,
        ia = [],
        Ra = 0,
        a = b.getElementsByTagName("*")) : a.length === c && (a = [a]),
        d = 0,
        e = a.length; e > d; d++) {
            var g = a[d]
              , h = g
              , i = []
              , j = pa
              , k = ta
              , l = !1;
            if (f && F in g && delete g[F],
            g.attributes) {
                for (var m = 0, n = g.attributes.length; n > m; m++) {
                    var p = g.attributes[m];
                    if ("data-anchor-target" !== p.name)
                        if ("data-smooth-scrolling" !== p.name)
                            if ("data-edge-strategy" !== p.name)
                                if ("data-emit-events" !== p.name) {
                                    var q = p.name.match(I);
                                    if (null !== q) {
                                        var r = {
                                            props: p.value,
                                            element: g,
                                            eventType: p.name.replace(L, M)
                                        };
                                        i.push(r);
                                        var s = q[1];
                                        s && (r.constant = s.substr(1));
                                        var t = q[2];
                                        /p$/.test(t) ? (r.isPercentage = !0,
                                        r.offset = (0 | t.slice(0, -1)) / 100) : r.offset = 0 | t;
                                        var u = q[3]
                                          , v = q[4] || u;
                                        u && u !== B && u !== C ? (r.mode = "relative",
                                        r.anchors = [u, v]) : (r.mode = "absolute",
                                        u === C ? r.isEnd = !0 : r.isPercentage || (r.offset = r.offset * Ka))
                                    }
                                } else
                                    l = !0;
                            else
                                k = p.value;
                        else
                            j = "off" !== p.value;
                    else if (h = b.querySelector(p.value),
                    null === h)
                        throw 'Unable to find anchor target "' + p.value + '"'
                }
                if (i.length) {
                    var w, x, y;
                    !f && F in g ? (y = g[F],
                    w = ia[y].styleAttr,
                    x = ia[y].classAttr) : (y = g[F] = Ra++,
                    w = g.style.cssText,
                    x = Da(g)),
                    ia[y] = {
                        element: g,
                        styleAttr: w,
                        classAttr: x,
                        anchorTarget: h,
                        keyFrames: i,
                        smoothScrolling: j,
                        edgeStrategy: k,
                        emitEvents: l,
                        lastFrameIndex: -1
                    },
                    Ea(g, [o], [])
                }
            }
        }
        for (Aa(),
        d = 0,
        e = a.length; e > d; d++) {
            var z = ia[a[d][F]];
            z !== c && (_(z),
            ba(z))
        }
        return ha
    }
    ,
    d.prototype.relativeToAbsolute = function(a, b, c) {
        var d = e.clientHeight
          , f = a.getBoundingClientRect()
          , g = f.top
          , h = f.bottom - f.top;
        return b === E ? g -= d : b === D && (g -= d / 2),
        c === E ? g += h : c === D && (g += h / 2),
        g += ha.getScrollTop(),
        g + .5 | 0
    }
    ,
    d.prototype.animateTo = function(a, b) {
        b = b || {};
        var d = Ha()
          , e = ha.getScrollTop()
          , f = b.duration === c ? x : b.duration;
        return oa = {
            startTop: e,
            topDiff: a - e,
            targetTop: a,
            duration: f,
            startTime: d,
            endTime: d + f,
            easing: W[b.easing || w],
            done: b.done
        },
        oa.topDiff || (oa.done && oa.done.call(ha, !1),
        oa = c),
        ha
    }
    ,
    d.prototype.stopAnimateTo = function() {
        oa && oa.done && oa.done.call(ha, !0),
        oa = c
    }
    ,
    d.prototype.isAnimatingTo = function() {
        return !!oa
    }
    ,
    d.prototype.isMobile = function() {
        return Sa
    }
    ,
    d.prototype.setScrollTop = function(b, c) {
        return sa = c === !0,
        Sa ? Ta = i.min(i.max(b, 0), Ja) : a.scrollTo(0, b),
        ha
    }
    ,
    d.prototype.getScrollTop = function() {
        return Sa ? Ta : a.pageYOffset || e.scrollTop || f.scrollTop || 0
    }
    ,
    d.prototype.getMaxScrollTop = function() {
        return Ja
    }
    ,
    d.prototype.on = function(a, b) {
        return ka[a] = b,
        ha
    }
    ,
    d.prototype.off = function(a) {
        return delete ka[a],
        ha
    }
    ,
    d.prototype.destroy = function() {
        var a = V();
        a(va),
        ya(),
        Ea(e, [t], [s, u, v]);
        for (var b = 0, d = ia.length; d > b; b++)
            fa(ia[b].element);
        e.style.overflow = f.style.overflow = "",
        e.style.height = f.style.height = "",
        ja && g.setStyle(ja, "transform", "none"),
        ha = c,
        ja = c,
        ka = c,
        la = c,
        Ja = 0,
        Ka = 1,
        ma = c,
        na = c,
        La = "down",
        Ma = -1,
        Oa = 0,
        Pa = 0,
        Qa = !1,
        oa = c,
        pa = c,
        qa = c,
        ra = c,
        sa = c,
        Ra = 0,
        ta = c,
        Sa = !1,
        Ta = 0,
        ua = c
    }
    ;
    var X = function() {
        var d, g, h, j, o, p, q, r, s, t, u, v;
        wa(e, [k, l, m, n].join(" "), function(a) {
            var e = a.changedTouches[0];
            for (j = a.target; 3 === j.nodeType; )
                j = j.parentNode;
            switch (o = e.clientY,
            p = e.clientX,
            t = a.timeStamp,
            G.test(j.tagName) || a.preventDefault(),
            a.type) {
            case k:
                d && d.blur(),
                ha.stopAnimateTo(),
                d = j,
                g = q = o,
                h = p,
                s = t;
                break;
            case l:
                G.test(j.tagName) && b.activeElement !== j && a.preventDefault(),
                r = o - q,
                v = t - u,
                ha.setScrollTop(Ta - r, !0),
                q = o,
                u = t;
                break;
            default:
            case m:
            case n:
                var f = g - o
                  , w = h - p
                  , x = w * w + f * f;
                if (49 > x) {
                    if (!G.test(d.tagName)) {
                        d.focus();
                        var y = b.createEvent("MouseEvents");
                        y.initMouseEvent("click", !0, !0, a.view, 1, e.screenX, e.screenY, e.clientX, e.clientY, a.ctrlKey, a.altKey, a.shiftKey, a.metaKey, 0, null),
                        d.dispatchEvent(y)
                    }
                    return
                }
                d = c;
                var z = r / v;
                z = i.max(i.min(z, 3), -3);
                var A = i.abs(z / na)
                  , B = z * A + .5 * na * A * A
                  , C = ha.getScrollTop() - B
                  , D = 0;
                C > Ja ? (D = (Ja - C) / B,
                C = Ja) : 0 > C && (D = -C / B,
                C = 0),
                A *= 1 - D,
                ha.animateTo(C + .5 | 0, {
                    easing: "outCubic",
                    duration: A
                })
            }
        }),
        a.scrollTo(0, 0),
        e.style.overflow = f.style.overflow = "hidden"
    }
      , Y = function() {
        var a, b, c, d, f, g, h, j, k, l, m, n = e.clientHeight, o = Ba();
        for (j = 0,
        k = ia.length; k > j; j++)
            for (a = ia[j],
            b = a.element,
            c = a.anchorTarget,
            d = a.keyFrames,
            f = 0,
            g = d.length; g > f; f++)
                h = d[f],
                l = h.offset,
                m = o[h.constant] || 0,
                h.frame = l,
                h.isPercentage && (l *= n,
                h.frame = l),
                "relative" === h.mode && (fa(b),
                h.frame = ha.relativeToAbsolute(c, h.anchors[0], h.anchors[1]) - l,
                fa(b, !0)),
                h.frame += m,
                la && !h.isEnd && h.frame > Ja && (Ja = h.frame);
        for (Ja = i.max(Ja, Ca()),
        j = 0,
        k = ia.length; k > j; j++) {
            for (a = ia[j],
            d = a.keyFrames,
            f = 0,
            g = d.length; g > f; f++)
                h = d[f],
                m = o[h.constant] || 0,
                h.isEnd && (h.frame = Ja - h.offset + m);
            a.keyFrames.sort(Ia)
        }
    }
      , Z = function(a, b) {
        for (var c = 0, d = ia.length; d > c; c++) {
            var e, f, i = ia[c], j = i.element, k = i.smoothScrolling ? a : b, l = i.keyFrames, m = l.length, n = l[0], s = l[l.length - 1], t = k < n.frame, u = k > s.frame, v = t ? n : s, w = i.emitEvents, x = i.lastFrameIndex;
            if (t || u) {
                if (t && -1 === i.edge || u && 1 === i.edge)
                    continue;
                switch (t ? (Ea(j, [p], [r, q]),
                w && x > -1 && (za(j, n.eventType, La),
                i.lastFrameIndex = -1)) : (Ea(j, [r], [p, q]),
                w && m > x && (za(j, s.eventType, La),
                i.lastFrameIndex = m)),
                i.edge = t ? -1 : 1,
                i.edgeStrategy) {
                case "reset":
                    fa(j);
                    continue;
                case "ease":
                    k = v.frame;
                    break;
                default:
                case "set":
                    var y = v.props;
                    for (e in y)
                        h.call(y, e) && (f = ea(y[e].value),
                        0 === e.indexOf("@") ? j.setAttribute(e.substr(1), f) : g.setStyle(j, e, f));
                    continue
                }
            } else
                0 !== i.edge && (Ea(j, [o, q], [p, r]),
                i.edge = 0);
            for (var z = 0; m - 1 > z; z++)
                if (k >= l[z].frame && k <= l[z + 1].frame) {
                    var A = l[z]
                      , B = l[z + 1];
                    for (e in A.props)
                        if (h.call(A.props, e)) {
                            var C = (k - A.frame) / (B.frame - A.frame);
                            C = A.props[e].easing(C),
                            f = da(A.props[e].value, B.props[e].value, C),
                            f = ea(f),
                            0 === e.indexOf("@") ? j.setAttribute(e.substr(1), f) : g.setStyle(j, e, f)
                        }
                    w && x !== z && ("down" === La ? za(j, A.eventType, La) : za(j, B.eventType, La),
                    i.lastFrameIndex = z);
                    break
                }
        }
    }
      , $ = function() {
        Qa && (Qa = !1,
        Aa());
        var a, b, d = ha.getScrollTop(), e = Ha();
        if (oa)
            e >= oa.endTime ? (d = oa.targetTop,
            a = oa.done,
            oa = c) : (b = oa.easing((e - oa.startTime) / oa.duration),
            d = oa.startTop + b * oa.topDiff | 0),
            ha.setScrollTop(d, !0);
        else if (!sa) {
            var f = ra.targetTop - d;
            f && (ra = {
                startTop: Ma,
                topDiff: d - Ma,
                targetTop: d,
                startTime: Na,
                endTime: Na + qa
            }),
            e <= ra.endTime && (b = W.sqrt((e - ra.startTime) / qa),
            d = ra.startTop + b * ra.topDiff | 0)
        }
        if (sa || Ma !== d) {
            La = d > Ma ? "down" : Ma > d ? "up" : La,
            sa = !1;
            var h = {
                curTop: d,
                lastTop: Ma,
                maxTop: Ja,
                direction: La
            }
              , i = ka.beforerender && ka.beforerender.call(ha, h);
            i !== !1 && (Z(d, ha.getScrollTop()),
            Sa && ja && g.setStyle(ja, "transform", "translate(0, " + -Ta + "px) " + ua),
            Ma = d,
            ka.render && ka.render.call(ha, h)),
            a && a.call(ha, !1)
        }
        Na = e
    }
      , _ = function(a) {
        for (var b = 0, c = a.keyFrames.length; c > b; b++) {
            for (var d, e, f, g, h = a.keyFrames[b], i = {}; null !== (g = J.exec(h.props)); )
                f = g[1],
                e = g[2],
                d = f.match(K),
                null !== d ? (f = d[1],
                d = d[2]) : d = w,
                e = e.indexOf("!") ? aa(e) : [e.slice(1)],
                i[f] = {
                    value: e,
                    easing: W[d]
                };
            h.props = i
        }
    }
      , aa = function(a) {
        var b = [];
        return P.lastIndex = 0,
        a = a.replace(P, function(a) {
            return a.replace(N, function(a) {
                return a / 255 * 100 + "%"
            })
        }),
        S && (Q.lastIndex = 0,
        a = a.replace(Q, function(a) {
            return S + a
        })),
        a = a.replace(N, function(a) {
            return b.push(+a),
            "{?}"
        }),
        b.unshift(a),
        b
    }
      , ba = function(a) {
        var b, c, d = {};
        for (b = 0,
        c = a.keyFrames.length; c > b; b++)
            ca(a.keyFrames[b], d);
        for (d = {},
        b = a.keyFrames.length - 1; b >= 0; b--)
            ca(a.keyFrames[b], d)
    }
      , ca = function(a, b) {
        var c;
        for (c in b)
            h.call(a.props, c) || (a.props[c] = b[c]);
        for (c in a.props)
            b[c] = a.props[c]
    }
      , da = function(a, b, c) {
        var d, e = a.length;
        if (e !== b.length)
            throw "Can't interpolate between \"" + a[0] + '" and "' + b[0] + '"';
        var f = [a[0]];
        for (d = 1; e > d; d++)
            f[d] = a[d] + (b[d] - a[d]) * c;
        return f
    }
      , ea = function(a) {
        var b = 1;
        return O.lastIndex = 0,
        a[0].replace(O, function() {
            return a[b++]
        })
    }
      , fa = function(a, b) {
        a = [].concat(a);
        for (var c, d, e = 0, f = a.length; f > e; e++)
            d = a[e],
            c = ia[d[F]],
            c && (b ? (d.style.cssText = c.dirtyStyleAttr,
            Ea(d, c.dirtyClassAttr)) : (c.dirtyStyleAttr = d.style.cssText,
            c.dirtyClassAttr = Da(d),
            d.style.cssText = c.styleAttr,
            Ea(d, c.classAttr)))
    }
      , ga = function() {
        ua = "translateZ(0)",
        g.setStyle(ja, "transform", ua);
        var a = j(ja)
          , b = a.getPropertyValue("transform")
          , c = a.getPropertyValue(S + "transform")
          , d = b && "none" !== b || c && "none" !== c;
        d || (ua = "")
    };
    g.setStyle = function(a, b, c) {
        var d = a.style;
        if (b = b.replace(L, M).replace("-", ""),
        "zIndex" === b)
            isNaN(c) ? d[b] = c : d[b] = "" + (0 | c);
        else if ("float" === b)
            d.styleFloat = d.cssFloat = c;
        else
            try {
                R && (d[R + b.slice(0, 1).toUpperCase() + b.slice(1)] = c),
                d[b] = c
            } catch (e) {}
    }
    ;
    var ha, ia, ja, ka, la, ma, na, oa, pa, qa, ra, sa, ta, ua, va, wa = g.addEvent = function(b, c, d) {
        var e = function(b) {
            return b = b || a.event,
            b.target || (b.target = b.srcElement),
            b.preventDefault || (b.preventDefault = function() {
                b.returnValue = !1,
                b.defaultPrevented = !0
            }
            ),
            d.call(this, b)
        };
        c = c.split(" ");
        for (var f, g = 0, h = c.length; h > g; g++)
            f = c[g],
            b.addEventListener ? b.addEventListener(f, d, !1) : b.attachEvent("on" + f, e),
            Ua.push({
                element: b,
                name: f,
                listener: d
            })
    }
    , xa = g.removeEvent = function(a, b, c) {
        b = b.split(" ");
        for (var d = 0, e = b.length; e > d; d++)
            a.removeEventListener ? a.removeEventListener(b[d], c, !1) : a.detachEvent("on" + b[d], c)
    }
    , ya = function() {
        for (var a, b = 0, c = Ua.length; c > b; b++)
            a = Ua[b],
            xa(a.element, a.name, a.listener);
        Ua = []
    }, za = function(a, b, c) {
        ka.keyframe && ka.keyframe.call(ha, a, b, c)
    }, Aa = function() {
        var a = ha.getScrollTop();
        Ja = 0,
        la && !Sa && (f.style.height = ""),
        Y(),
        la && !Sa && (f.style.height = Ja + e.clientHeight + "px"),
        Sa ? ha.setScrollTop(i.min(ha.getScrollTop(), Ja)) : ha.setScrollTop(a, !0),
        sa = !0
    }, Ba = function() {
        var a, b, c = e.clientHeight, d = {};
        for (a in ma)
            b = ma[a],
            "function" == typeof b ? b = b.call(ha) : /p$/.test(b) && (b = b.slice(0, -1) / 100 * c),
            d[a] = b;
        return d
    }, Ca = function() {
        var a, b = 0;
        return ja && (b = i.max(ja.offsetHeight, ja.scrollHeight)),
        a = i.max(b, f.scrollHeight, f.offsetHeight, e.scrollHeight, e.offsetHeight, e.clientHeight),
        a - e.clientHeight
    }, Da = function(b) {
        var c = "className";
        return a.SVGElement && b instanceof a.SVGElement && (b = b[c],
        c = "baseVal"),
        b[c]
    }, Ea = function(b, d, e) {
        var f = "className";
        if (a.SVGElement && b instanceof a.SVGElement && (b = b[f],
        f = "baseVal"),
        e === c)
            return void (b[f] = d);
        for (var g = b[f], h = 0, i = e.length; i > h; h++)
            g = Ga(g).replace(Ga(e[h]), " ");
        g = Fa(g);
        for (var j = 0, k = d.length; k > j; j++)
            -1 === Ga(g).indexOf(Ga(d[j])) && (g += " " + d[j]);
        b[f] = Fa(g)
    }, Fa = function(a) {
        return a.replace(H, "")
    }, Ga = function(a) {
        return " " + a + " "
    }, Ha = Date.now || function() {
        return +new Date
    }
    , Ia = function(a, b) {
        return a.frame - b.frame
    }, Ja = 0, Ka = 1, La = "down", Ma = -1, Na = Ha(), Oa = 0, Pa = 0, Qa = !1, Ra = 0, Sa = !1, Ta = 0, Ua = [];
    "function" == typeof define && define.amd ? define([], function() {
        return g
    }) : "undefined" != typeof module && module.exports ? module.exports = g : a.skrollr = g
}(window, document);

/*! lazysizes - v4.0.0-rc2 */
!function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c,
    "object" == typeof module && module.exports && (module.exports = c)
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function(a, b) {
            return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
            p[b].test(a[i]("class") || "") && p[b]
        }, s = function(a, b) {
            r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b)
        }, t = function(a, b) {
            var c;
            (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "))
        }, u = function(a, b, c) {
            var d = c ? h : "removeEventListener";
            c && u(a, b),
            o.forEach(function(c) {
                a[d](c, b)
            })
        }, v = function(a, d, e, f, g) {
            var h = b.createEvent("CustomEvent");
            return e || (e = {}),
            e.instance = c,
            h.initCustomEvent(d, !f, !g, e),
            a.dispatchEvent(h),
            h
        }, w = function(b, c) {
            var e;
            !g && (e = a.picturefill || d.pf) ? e({
                reevaluate: !0,
                elements: [b]
            }) : c && c.src && (b.src = c.src)
        }, x = function(a, b) {
            return (getComputedStyle(a, null) || {})[b]
        }, y = function(a, b, c) {
            for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
                c = b.offsetWidth,
                b = b.parentNode;
            return c
        }, z = function() {
            var a, c, d = [], e = [], f = d, g = function() {
                var b = f;
                for (f = d.length ? e : d,
                a = !0,
                c = !1; b.length; )
                    b.shift()();
                a = !1
            }, h = function(d, e) {
                a && !e ? d.apply(this, arguments) : (f.push(d),
                c || (c = !0,
                (b.hidden ? k : l)(g)))
            };
            return h._lsFlush = g,
            h
        }(), A = function(a, b) {
            return b ? function() {
                z(a)
            }
            : function() {
                var b = this
                  , c = arguments;
                z(function() {
                    a.apply(b, c)
                })
            }
        }, B = function(a) {
            var b, c = 0, d = 125, e = 666, g = e, h = function() {
                b = !1,
                c = f.now(),
                a()
            }, i = m ? function() {
                m(h, {
                    timeout: g
                }),
                g !== e && (g = e)
            }
            : A(function() {
                k(h)
            }, !0);
            return function(a) {
                var e;
                (a = a === !0) && (g = 44),
                b || (b = !0,
                e = d - (f.now() - c),
                0 > e && (e = 0),
                a || 9 > e && m ? i() : k(i, e))
            }
        }, C = function(a) {
            var b, c, d = 99, e = function() {
                b = null,
                a()
            }, g = function() {
                var a = f.now() - c;
                d > a ? k(g, d - a) : (m || e)(e)
            };
            return function() {
                c = f.now(),
                b || (b = k(g, d))
            }
        }, D = function() {
            var g, l, m, o, p, y, D, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i, O = "onscroll"in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1, T = function(a) {
                R--,
                a && a.target && u(a.target, T),
                (!a || 0 > R || !a.target) && (R = 0)
            }, U = function(a, c) {
                var d, f = a, g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
                for (F -= c,
                I += c,
                G -= c,
                H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
                    g = (x(f, "opacity") || 1) > 0,
                    g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(),
                    g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
                return g
            }, V = function() {
                var a, f, h, j, k, m, n, p, q, r = c.elements;
                if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                    f = 0,
                    S++,
                    null == K && ("expand"in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370),
                    J = d.expand,
                    K = J * d.expFactor),
                    K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K,
                    S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                    for (; a > f; f++)
                        if (r[f] && !r[f]._lazyRace)
                            if (O)
                                if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q),
                                q !== m && (y = innerWidth + m * L,
                                D = innerHeight + m,
                                n = -1 * m,
                                q = m),
                                h = r[f].getBoundingClientRect(),
                                (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) {
                                    if (ba(r[f]),
                                    k = !0,
                                    R > 9)
                                        break
                                } else
                                    !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]);
                            else
                                ba(r[f]);
                    j && !k && ba(j)
                }
            }, W = B(V), X = function(a) {
                s(a.target, d.loadedClass),
                t(a.target, d.loadingClass),
                u(a.target, Z),
                v(a.target, "lazyloaded")
            }, Y = A(X), Z = function(a) {
                Y({
                    target: a.target
                })
            }, $ = function(a, b) {
                try {
                    a.contentWindow.location.replace(b)
                } catch (c) {
                    a.src = b
                }
            }, _ = function(a) {
                var b, c = a[i](d.srcsetAttr);
                (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b),
                c && a.setAttribute("srcset", c)
            }, aa = A(function(a, b, c, e, f) {
                var g, h, j, l, o, p;
                (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
                h = a[i](d.srcsetAttr),
                g = a[i](d.srcAttr),
                f && (j = a.parentNode,
                l = j && n.test(j.nodeName || "")),
                p = b.firesLoad || "src"in a && (h || g || l),
                o = {
                    target: a
                },
                p && (u(a, T, !0),
                clearTimeout(m),
                m = k(T, 2500),
                s(a, d.loadingClass),
                u(a, Z, !0)),
                l && q.call(j.getElementsByTagName("source"), _),
                h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g),
                f && (h || l) && w(a, {
                    src: g
                })),
                a._lazyRace && delete a._lazyRace,
                t(a, d.lazyClass),
                z(function() {
                    (!p || a.complete && a.naturalWidth > 1) && (p ? T(o) : R--,
                    X(o))
                }, !0)
            }), ba = function(a) {
                var b, c = M.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e;
                (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass)) && (b = v(a, "lazyunveilread").detail,
                f && E.updateElem(a, !0, a.offsetWidth),
                a._lazyRace = !0,
                R++,
                aa(a, b, f, e, c))
            }, ca = function() {
                if (!l) {
                    if (f.now() - p < 999)
                        return void k(ca, 999);
                    var a = C(function() {
                        d.loadMode = 3,
                        W()
                    });
                    l = !0,
                    d.loadMode = 3,
                    W(),
                    j("scroll", function() {
                        3 == d.loadMode && (d.loadMode = 2),
                        a()
                    }, !0)
                }
            };
            return {
                _: function() {
                    p = f.now(),
                    c.elements = b.getElementsByClassName(d.lazyClass),
                    g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass),
                    L = d.hFac,
                    j("scroll", W, !0),
                    j("resize", W, !0),
                    a.MutationObserver ? new MutationObserver(W).observe(e, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (e[h]("DOMNodeInserted", W, !0),
                    e[h]("DOMAttrModified", W, !0),
                    setInterval(W, 999)),
                    j("hashchange", W, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(a) {
                        b[h](a, W, !0)
                    }),
                    /d$|^c/.test(b.readyState) ? ca() : (j("load", ca),
                    b[h]("DOMContentLoaded", W),
                    k(ca, 2e4)),
                    c.elements.length ? (V(),
                    z._lsFlush()) : W()
                },
                checkElems: W,
                unveil: ba
            }
        }(), E = function() {
            var a, c = A(function(a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d,
                d += "px",
                a.setAttribute("sizes", d),
                n.test(b.nodeName || ""))
                    for (e = b.getElementsByTagName("source"),
                    f = 0,
                    g = e.length; g > f; f++)
                        e[f].setAttribute("sizes", d);
                c.detail.dataAttr || w(a, c.detail)
            }), e = function(a, b, d) {
                var e, f = a.parentNode;
                f && (d = y(a, f, d),
                e = v(a, "lazybeforesizes", {
                    width: d,
                    dataAttr: !!b
                }),
                e.defaultPrevented || (d = e.detail.width,
                d && d !== a._lazysizesWidth && c(a, f, e, d)))
            }, f = function() {
                var b, c = a.length;
                if (c)
                    for (b = 0; c > b; b++)
                        e(a[b])
            }, g = C(f);
            return {
                _: function() {
                    a = b.getElementsByClassName(d.autosizesClass),
                    j("resize", g)
                },
                checkElems: g,
                updateElem: e
            }
        }(), F = function() {
            F.i || (F.i = !0,
            E._(),
            D._())
        };
        return function() {
            var b, c = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0
            };
            d = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in c)
                b in d || (d[b] = c[b]);
            a.lazySizesConfig = d,
            k(function() {
                d.init && F()
            })
        }(),
        c = {
            cfg: d,
            autoSizer: E,
            loader: D,
            init: F,
            uP: w,
            aC: s,
            rC: t,
            hC: r,
            fire: v,
            gW: y,
            rAF: z
        }
    }
});

/*! lazysizes - v4.0.0-rc2 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    var d, e = c && c.cfg || a.lazySizesConfig, f = b.createElement("img"), g = "sizes"in f && "srcset"in f, h = /\s+\d+h/g, i = function() {
        var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , c = Array.prototype.forEach;
        return function(d) {
            var e = b.createElement("img")
              , f = function(b) {
                var c, d = b.getAttribute(lazySizesConfig.srcsetAttr);
                d && (d.match(a) && (c = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1,
                c && b.setAttribute("data-aspectratio", c)),
                b.setAttribute(lazySizesConfig.srcsetAttr, d.replace(h, "")))
            }
              , g = function(a) {
                var b = a.target.parentNode;
                b && "PICTURE" == b.nodeName && c.call(b.getElementsByTagName("source"), f),
                f(a.target)
            }
              , i = function() {
                e.currentSrc && b.removeEventListener("lazybeforeunveil", g)
            };
            d[1] && (b.addEventListener("lazybeforeunveil", g),
            e.onload = i,
            e.onerror = i,
            e.srcset = "data:,a 1w 1h",
            e.complete && i())
        }
    }();
    if (e || (e = {},
    a.lazySizesConfig = e),
    e.supportsType || (e.supportsType = function(a) {
        return !a
    }
    ),
    !a.picturefill && !e.pf) {
        if (a.HTMLPictureElement && g)
            return b.msElementsFromPoint && i(navigator.userAgent.match(/Edge\/(\d+)/)),
            void (e.pf = function() {}
            );
        e.pf = function(b) {
            var c, e;
            if (!a.picturefill)
                for (c = 0,
                e = b.elements.length; e > c; c++)
                    d(b.elements[c])
        }
        ,
        d = function() {
            var f = function(a, b) {
                return a.w - b.w
            }
              , i = /^\s*\d+\.*\d*px\s*$/
              , j = function(a) {
                var b, c, d = a.length, e = a[d - 1], f = 0;
                for (f; d > f; f++)
                    if (e = a[f],
                    e.d = e.w / a.w,
                    e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                        b.cached && (b.d += .15 * c),
                        b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    }
                return e
            }
              , k = function() {
                var a, b = /(([^,\s].[^\s]+)\s+(\d+)w)/g, c = /\s/, d = function(b, c, d, e) {
                    a.push({
                        c: c,
                        u: d,
                        w: 1 * e
                    })
                };
                return function(e) {
                    return a = [],
                    e = e.trim(),
                    e.replace(h, "").replace(b, d),
                    a.length || !e || c.test(e) || a.push({
                        c: e,
                        u: e,
                        w: 99
                    }),
                    a
                }
            }()
              , l = function() {
                l.init || (l.init = !0,
                addEventListener("resize", function() {
                    var a, c = b.getElementsByClassName("lazymatchmedia"), e = function() {
                        var a, b;
                        for (a = 0,
                        b = c.length; b > a; a++)
                            d(c[a])
                    };
                    return function() {
                        clearTimeout(a),
                        a = setTimeout(e, 66)
                    }
                }()))
            }
              , m = function(b, d) {
                var f, g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
                !g && d && (g = b._lazypolyfill ? b._lazypolyfill._set : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
                b._lazypolyfill && b._lazypolyfill._set == g || (f = k(g || ""),
                d && b.parentNode && (f.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase(),
                f.isPicture && a.matchMedia && (c.aC(b, "lazymatchmedia"),
                l())),
                f._set = g,
                Object.defineProperty(b, "_lazypolyfill", {
                    value: f,
                    writable: !0
                }))
            }
              , n = function(b) {
                var d = a.devicePixelRatio || 1
                  , e = c.getX && c.getX(b);
                return Math.min(e || d, 2.5, d)
            }
              , o = function(b) {
                return a.matchMedia ? (o = function(a) {
                    return !a || (matchMedia(a) || {}).matches
                }
                )(b) : !b
            }
              , p = function(a) {
                var b, d, g, h, k, l, p;
                if (h = a,
                m(h, !0),
                k = h._lazypolyfill,
                k.isPicture)
                    for (d = 0,
                    b = a.parentNode.getElementsByTagName("source"),
                    g = b.length; g > d; d++)
                        if (e.supportsType(b[d].getAttribute("type"), a) && o(b[d].getAttribute("media"))) {
                            h = b[d],
                            m(h),
                            k = h._lazypolyfill;
                            break
                        }
                return k.length > 1 ? (p = h.getAttribute("sizes") || "",
                p = i.test(p) && parseInt(p, 10) || c.gW(a, a.parentNode),
                k.d = n(a),
                !k.src || !k.w || k.w < p ? (k.w = p,
                l = j(k.sort(f)),
                k.src = l) : l = k.src) : l = k[0],
                l
            }
              , q = function(a) {
                if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                    var b = p(a);
                    b && b.u && a._lazypolyfill.cur != b.u && (a._lazypolyfill.cur = b.u,
                    b.cached = !0,
                    a.setAttribute(e.srcAttr, b.u),
                    a.setAttribute("src", b.u))
                }
            };
            return q.parse = k,
            q
        }(),
        e.loadedClass && e.loadingClass && !function() {
            var a = [];
            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b) {
                a.push(b + e.loadedClass),
                a.push(b + e.loadingClass)
            }),
            e.pf({
                elements: b.querySelectorAll(a.join(", "))
            })
        }()
    }
});

/*! lazysizes - v4.0.0-rc2 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+/g
          , e = /\s*\|\s+|\s+\|\s*/g
          , f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/
          , g = /\(|\)|'/
          , h = {
            contain: 1,
            cover: 1
        }
          , i = function(a) {
            var b = c.gW(a, a.parentNode);
            return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b),
            a._lazysizesWidth
        }
          , j = function(a) {
            var b;
            return b = (getComputedStyle(a) || {
                getPropertyValue: function() {}
            }).getPropertyValue("background-size"),
            !h[b] && h[a.style.backgroundSize] && (b = a.style.backgroundSize),
            b
        }
          , k = function(a, c, g) {
            var h = b.createElement("picture")
              , i = c.getAttribute(lazySizesConfig.sizesAttr)
              , j = c.getAttribute("data-ratio")
              , k = c.getAttribute("data-optimumx");
            c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset),
            Object.defineProperty(g, "_lazybgset", {
                value: c,
                writable: !0
            }),
            Object.defineProperty(c, "_lazybgset", {
                value: h,
                writable: !0
            }),
            a = a.replace(d, " ").split(e),
            h.style.display = "none",
            g.className = lazySizesConfig.lazyClass,
            1 != a.length || i || (i = "auto"),
            a.forEach(function(a) {
                var c = b.createElement("source");
                i && "auto" != i && c.setAttribute("sizes", i),
                a.match(f) && (c.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                RegExp.$2 && c.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                h.appendChild(c)
            }),
            i && (g.setAttribute(lazySizesConfig.sizesAttr, i),
            c.removeAttribute(lazySizesConfig.sizesAttr),
            c.removeAttribute("sizes")),
            k && g.setAttribute("data-optimumx", k),
            j && g.setAttribute("data-ratio", j),
            h.appendChild(g),
            c.appendChild(h)
        }
          , l = function(a) {
            if (a.target._lazybgset) {
                var b = a.target
                  , d = b._lazybgset
                  , e = b.currentSrc || b.src;
                e && (d.style.backgroundImage = "url(" + (g.test(e) ? JSON.stringify(e) : e) + ")"),
                b._lazybgsetLoading && (c.fire(d, "_lazyloaded", {}, !1, !0),
                delete b._lazybgsetLoading)
            }
        };
        addEventListener("lazybeforeunveil", function(a) {
            var d, e, f;
            !a.defaultPrevented && (d = a.target.getAttribute("data-bgset")) && (f = a.target,
            e = b.createElement("img"),
            e.alt = "",
            e._lazybgsetLoading = !0,
            a.detail.firesLoad = !0,
            k(d, f, e),
            setTimeout(function() {
                c.loader.unveil(e),
                c.rAF(function() {
                    c.fire(e, "_lazyloaded", {}, !0, !0),
                    e.complete && l({
                        target: e
                    })
                })
            }))
        }),
        b.addEventListener("load", l, !0),
        a.addEventListener("lazybeforesizes", function(a) {
            if (a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr) {
                var b = a.target._lazybgset
                  , d = j(b);
                h[d] && (a.target._lazysizesParentFit = d,
                c.rAF(function() {
                    a.target.setAttribute("data-parent-fit", d),
                    a.target._lazysizesParentFit && delete a.target._lazysizesParentFit
                }))
            }
        }, !0),
        b.documentElement.addEventListener("lazybeforesizes", function(a) {
            !a.defaultPrevented && a.target._lazybgset && a.detail.instance == c && (a.detail.width = i(a.target._lazybgset))
        })
    }
});

var destroySlider = function(slider) {

    if (slider && slider.data('flexslider')) {
        var slider = slider.data('flexslider');
        var classNamespace = '.' + slider.vars.namespace;
        // Namespaced class selector
        if (slider.vars.controlNav)
            slider.controlNav.closest(classNamespace + 'control-nav').remove();
        // Remove control elements if present
        if (slider.vars.directionNav)
            slider.directionNav.closest(classNamespace + 'direction-nav').remove();
        // Remove direction-nav elements if present
        if (slider.vars.pausePlay)
            slider.pausePlay.closest(classNamespace + 'pauseplay').remove();
        // Remove pauseplay elements if present
        slider.find('.clone').remove();
        // Remove any flexslider clones
        slider.unbind(slider.vars.eventNamespace);
        // Remove events on slider
        if (slider.vars.animation != "fade")
            slider.container.unwrap();
        // Remove the .flex-viewport div
        slider.container.removeAttr('style')
        // Remove generated CSS (could collide with 3rd parties)
        slider.container.unbind(slider.vars.eventNamespace);
        // Remove events on slider
        slider.slides.removeAttr('style');
        // Remove generated CSS (could collide with 3rd parties)
        slider.slides.filter(classNamespace + 'active-slide').removeClass(slider.vars.namespace + 'active-slide');
        // Remove slide active class
        slider.slides.unbind(slider.vars.eventNamespace);
        // Remove events on slides
        $(document).unbind(slider.vars.eventNamespace + "-" + slider.id);
        // Remove events from document for this instance only
        $(window).unbind(slider.vars.eventNamespace + "-" + slider.id);
        // Remove events from window for this instance only
        slider.stop();
        // Stop the interval
        slider.removeData('flexslider');
        // Remove data
    }
}

var instagram = {
    loadContent: function(s) {
        if (s.clientID) {
            var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + s.clientID;

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'jsonp',
                success: function(data) {

                    if (data.meta.code === 200 && data.data.length) {
                        var data = data.data;
                        var count = 0;
                        s.el.empty();

                        for (var i = 0; i < data.length; i++) {
                            var thisMedia = data[i], item;

                            var url = thisMedia.images.low_resolution.url;

                            if (!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                                item = '<div class="il-photo__img instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link">' + item + '</a>';
                            }

                            if (thisMedia.videos) {
                                item = '<div class="instagram__video instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link instagram__video-link">' + item + '</a>';
                            }

                            if (item) {
                                item = '<div class="four columns instagram__item">' + item + '</div>';
                            }
                            if (item !== '') {
                                s.el.append(item);
                                count++;
                            }
                            if (count == s.limit) {
                                break;
                            }
                        }
                    }
                },
                error: function() {}
            });
        }
    }
}

$(document).on('shopify:block:select', function(e) {

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.select(blockId, $parentSection);
    }

});

$(document).on('shopify:block:deselect', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.deselect($parentSection)
    }

});

$(document).on('shopify:section:load', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {

            social.twitter();

            var $target = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: $target,
                clientID: $target.data('client-id'),
                limit: $target.data('count')
            });
        });
    }

    if ($parentSection.hasClass('cart-section')) {
        productFormListeners.init();
        cart.init();
    }

    if ($parentSection.hasClass('image-with-text-overlay-section')) {
        banner_image.init();
        banner.init();
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.init();
    }

    if ($parentSection.hasClass('featured-products-section')) {
        product.init();
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        collection.init();
        product.init();
        banner.init();
    }

    if ($parentSection.hasClass('featured-promotions-section')) {
        featured_promotions.init();
    }

    if ($parentSection.hasClass('video-section')) {
        videoTheme.init();
        banner.init();
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.init();
    }

    if ($parentSection.hasClass('product-template-section')) {
        collection.init();
        product.init();
    }

    if ($parentSection.hasClass('collection-template-section')) {
        banner_image.init();
        collection.init();
        product.init();
    }

    if ($parentSection.hasClass('contact-template-section')) {
        banner_image.init();
        banner.init();
    }

    if ($parentSection.hasClass('article-template-section')) {
        article.init();
    }

    if ($parentSection.hasClass('search-template-section')) {
        collection.init();
    }

    if ($parentSection.hasClass('banner-template-section')) {
        banner_image.init();
        banner.init();
    }

    if ($parentSection.hasClass('blog-template-section')) {
        banner_image.init();
        banner.init();
    }

    if ($parentSection.hasClass('header-section')) {
        banner_image.init();
        header.init();
    }
});

$(document).on('shopify:section:unload', function(e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.unload($target);
        });
    }

    if ($parentSection.hasClass('image-with-text-overlay-section')) {
        banner.unload($target);
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.unload($target);
    }

    if ($parentSection.hasClass('featured-products-section')) {
        product.unload($target);
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        collection.unload($target);
    }

    if ($parentSection.hasClass('video-section')) {
        homepageVideo.unload($target);
    }

    if ($parentSection.hasClass('product-template-section')) {
        product.unload($target);
    }

    if ($parentSection.hasClass('collection-template-section')) {
        collection.unload($target);
    }
});

$(document).on('shopify:section:select', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    header.init();
    banner_image.init();
    banner.init();

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.twitter();
        });
    }
});

$(document).on('shopify:section:deselect', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.unload();
        });
    }

});

$(document).on('shopify:section:reorder', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    header.init();
    banner_image.init();

});
